import { useLazyLoadQuery, fetchQuery, useRelayEnvironment as useRelayEnvironment$1, useMutation as useMutation$1, useFragment as useFragment$1 } from 'react-relay/hooks';
import React, { useRef, useState, useEffect, Suspense, useContext, createContext, useLayoutEffect, useCallback } from 'react';
import { kebabCase } from 'lodash';
import styled, { css, useTheme } from 'styled-components';
import { Text, SparkContentLoader, Accordion, AccordionItem, AccordionItemHeading, AccordionButton, AccordionItemBodyWithAnimation, RawHtml, NumberInput, Box, TextButton, Icon, TextVariantMap, subheadingMStyle, bodySMediumStyle, bodySDemiStyle, footNoteDemiStyle, colors, spacing, InfoBanner, ChoiceboxGroup, ChoiceBox, HeaderCategory, Header as Header$2, HeaderSegmentSwitcher, HeaderSegmentSwitcherItem, BrandLogo, MediaQuery, HeaderCategories, PersonalCategoriesContainer, BusinessCategoriesContainer, HeaderCategoriesContainer, CartButton, ProfilePill, AuthenticatedProfileMenu, UnauthenticatedProfileMenu, useSnackbar, useMediaQuery, Button, IconButton as IconButton$1, InfoBox, FormDropdown, StoreFinder, Link, LoadingSpinner, InformationLayer, InformationLayerTitle, Divider, Footer, useHeader, SearchButton as SearchButton$1, SnackbarProvider, HeaderCategoryV2, HeaderAccordion, HeaderAccordionItem, HeaderAccordionItemHeading, HeaderAccordionButton, HeaderAccordionItemBodyWithAnimation, SearchBar, MobileMegaMenuBackButton, HeaderFilterDropdown, HeaderFilterMenu, Modal, GridRow, GridColumn, Checkbox, ProductCardMedia, BaseProductCard, ProductCardSection, RadioGroup, RadioButton, FloatUp, ProductCardButton } from '@sparknz/spark-pattern-library';
import { trackDigitalEvent, LinkRegion, trackCustomLink, ImpressionRegion } from '@sparknz/tracking';
import { useRelayEnvironment, useMutation, useLazyLoadQuery as useLazyLoadQuery$1, useFragment } from 'react-relay';
import { createOperationDescriptor, getRequest, Store, RecordSource, Environment } from 'relay-runtime';
import { useCookies } from 'react-cookie';
import { useQuery } from 'react-query';
import { format, isValid, formatISO, addDays, parseISO, sub, endOfMonth, isMatch, startOfMonth } from 'date-fns';
import { v4 } from 'uuid';
import * as Sentry from '@sentry/nextjs';
import { captureException } from '@sentry/nextjs';
import { cacheMiddleware, urlMiddleware, RelayNetworkLayer } from 'react-relay-network-modern';
import { scrollTo } from 'scroll-js';
import { useForm, FormProvider, useWatch, useController, useFormContext, Controller, useFormState } from 'react-hook-form';
import { DialogOverlay } from '@reach/dialog';
import HCaptcha from '@hcaptcha/react-hcaptcha';
import padStart from 'lodash/padStart';
import parseInt from 'lodash/parseInt';
import jexl from 'jexl';
import useScript from 'react-script-hook';
import noop from 'lodash/noop';
import { ForgotEmailJourney, ForgotPasswordJourney, LoginJourney as LoginJourney$1, RegisterJourney } from '@sparknz/universal-login-library';
import { Widget } from '@sparknz/online-web-forgerock-login';
import capitalize from 'lodash/capitalize';
import 'lodash/first';
import isNil from 'lodash/isNil';
import omitBy from 'lodash/omitBy';
import 'qs';

var _cartFragment;
var cartFragment = _cartFragment !== void 0 ? _cartFragment : (_cartFragment = require("./__generated__/cartFragment.graphql"), _cartFragment.hash && _cartFragment.hash !== "d24ba3a850b0e44a784f43ebd7fafbef" && console.error("The definition of 'cartFragment' appears to have changed. Run `relay-compiler` to update the generated files to receive the expected data."), _cartFragment);

function _regeneratorRuntime() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */

  _regeneratorRuntime = function () {
    return exports;
  };

  var exports = {},
      Op = Object.prototype,
      hasOwn = Op.hasOwnProperty,
      $Symbol = "function" == typeof Symbol ? Symbol : {},
      iteratorSymbol = $Symbol.iterator || "@@iterator",
      asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
      toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }

  try {
    define({}, "");
  } catch (err) {
    define = function (obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
        generator = Object.create(protoGenerator.prototype),
        context = new Context(tryLocsList || []);
    return generator._invoke = function (innerFn, self, context) {
      var state = "suspendedStart";
      return function (method, arg) {
        if ("executing" === state) throw new Error("Generator is already running");

        if ("completed" === state) {
          if ("throw" === method) throw arg;
          return doneResult();
        }

        for (context.method = method, context.arg = arg;;) {
          var delegate = context.delegate;

          if (delegate) {
            var delegateResult = maybeInvokeDelegate(delegate, context);

            if (delegateResult) {
              if (delegateResult === ContinueSentinel) continue;
              return delegateResult;
            }
          }

          if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
            if ("suspendedStart" === state) throw state = "completed", context.arg;
            context.dispatchException(context.arg);
          } else "return" === context.method && context.abrupt("return", context.arg);
          state = "executing";
          var record = tryCatch(innerFn, self, context);

          if ("normal" === record.type) {
            if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
            return {
              value: record.arg,
              done: context.done
            };
          }

          "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
        }
      };
    }(innerFn, self, context), generator;
  }

  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }

  exports.wrap = wrap;
  var ContinueSentinel = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
      NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);

  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);

      if ("throw" !== record.type) {
        var result = record.arg,
            value = result.value;
        return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }

      reject(record.arg);
    }

    var previousPromise;

    this._invoke = function (method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function (resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
    };
  }

  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];

    if (undefined === method) {
      if (context.delegate = null, "throw" === context.method) {
        if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel;
        context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }

  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }

  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;

      if (!isNaN(iterable.length)) {
        var i = -1,
            next = function next() {
          for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;

          return next.value = undefined, next.done = !0, next;
        };

        return next.next = next;
      }
    }

    return {
      next: doneResult
    };
  }

  function doneResult() {
    return {
      value: undefined,
      done: !0
    };
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (object) {
    var keys = [];

    for (var key in object) keys.push(key);

    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }

      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function (skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
    },
    stop: function () {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function (exception) {
      if (this.done) throw exception;
      var context = this;

      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
            record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
              hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function (type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function (record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function (finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    catch: function (tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;

          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }

          return thrown;
        }
      }

      throw new Error("illegal catch attempt");
    },
    delegateYield: function (iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized(self);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function interpolateText(text, interpolationInfo) {
  return Object.keys(interpolationInfo).reduce(function (textResult, key) {
    var value = interpolationInfo[key];
    var regex = new RegExp("{".concat(key, "}"), 'gi');
    return textResult.replace(regex, value);
  }, text);
}

var _useAuthorableContentsFromRelayQuery;
var query$2 = _useAuthorableContentsFromRelayQuery !== void 0 ? _useAuthorableContentsFromRelayQuery : (_useAuthorableContentsFromRelayQuery = require("./__generated__/useAuthorableContentsFromRelayQuery.graphql"), _useAuthorableContentsFromRelayQuery.hash && _useAuthorableContentsFromRelayQuery.hash !== "eb3c1ca7c8e318223f1f54c99a64c0bc" && console.error("The definition of 'useAuthorableContentsFromRelayQuery' appears to have changed. Run `relay-compiler` to update the generated files to receive the expected data."), _useAuthorableContentsFromRelayQuery);

var useAuthorableContentsFromRelay = function useAuthorableContentsFromRelay(journeyStepId, variation) {
  var _useLazyLoadQuery = useLazyLoadQuery(query$2, {
    journeyStepId: journeyStepId,
    variation: variation
  }, {
    fetchPolicy: 'store-only'
  }),
      contentJourneyDetails = _useLazyLoadQuery.contentJourneyDetails;

  var authorableContents = contentJourneyDetails === null || contentJourneyDetails === void 0 ? void 0 : contentJourneyDetails.reduce(function (contents, content) {
    if (!content) {
      return contents;
    }

    return Object.assign(Object.assign({}, contents), _defineProperty({}, content.key, {
      value: content.value,
      url: content.url
    }));
  }, {});

  function getText(key, interpolationInfo) {
    var _a;

    var rawText = ((_a = authorableContents === null || authorableContents === void 0 ? void 0 : authorableContents[key]) === null || _a === void 0 ? void 0 : _a.value) || '';

    if (interpolationInfo) {
      return interpolateText(rawText, interpolationInfo);
    }

    return rawText;
  }

  return {
    getText: getText,
    getAllContents: function getAllContents() {
      return authorableContents;
    },
    getLink: function getLink(key) {
      var _a;

      return ((_a = authorableContents === null || authorableContents === void 0 ? void 0 : authorableContents[key]) === null || _a === void 0 ? void 0 : _a.url) || '';
    }
  };
};

function parseJwt$1(token) {
  var base64Url = token.split('.')[1];
  var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  var jsonPayload = decodeURIComponent(Buffer.from(base64, 'base64').toString('binary').split('').map(function (c) {
    var internalString = "00".concat(c.charCodeAt(0).toString(16)).slice(-2);
    return "%".concat(internalString);
  }).join(''));
  return JSON.parse(jsonPayload);
}

function decodeCartCookie$1(cartCookieValue) {
  try {
    var payload = parseJwt$1(cartCookieValue);
    return JSON.parse(payload['cart-details']);
  } catch (_a) {
    return {
      cartId: '',
      itemsCount: 0,
      segment: 'Consumer'
    };
  }
}

function useCartCookie(_ref) {
  var cartCookieName = _ref.cartCookieName;

  var _useCookies = useCookies(),
      _useCookies2 = _slicedToArray(_useCookies, 2),
      cookies = _useCookies2[0],
      removeCookie = _useCookies2[1];

  var CART_COOKIE_DOMAIN = cartCookieName === 'mock-cart-cookie' ? 'localhost' : '.spark.co.nz';

  var _decodeCartCookie = decodeCartCookie$1(cookies[cartCookieName]),
      cartId = _decodeCartCookie.cartId,
      itemsCount = _decodeCartCookie.itemsCount,
      segment = _decodeCartCookie.segment;

  function expireCartCookie() {
    /*
      Use this function to clear the cookie without initiating any react lifecyle events.
      It sets the expiry of the cookie to the past which effectively deletes the cookie
    */
    document.cookie = "".concat(cartCookieName, "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=").concat(CART_COOKIE_DOMAIN, ";");
  }

  function clearCartCookie() {
    removeCookie(cartCookieName, {
      domain: CART_COOKIE_DOMAIN,
      path: '/'
    });
  }

  return {
    cartId: cartId,
    expireCartCookie: expireCartCookie,
    clearCartCookie: clearCartCookie,
    numberOfCartItems: itemsCount,
    cartSegment: segment
  };
}

function useFetchQuery(query, environment) {
  var unsubscribe = useRef(null);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isInFlight = _useState2[0],
      setQueryInFlight = _useState2[1];

  function cancelSubscription() {
    if (unsubscribe.current) {
      unsubscribe.current();
    }
  }

  function handleFetch(variables) {
    cancelSubscription();
    return new Promise(function (resolve, reject) {
      var subscription = fetchQuery(environment, query, variables).subscribe({
        start: function start() {
          return setQueryInFlight(true);
        },
        next: function next(resourceQueryResponse) {
          return resolve(resourceQueryResponse);
        },
        complete: function complete() {
          return setQueryInFlight(false);
        },
        error: function error(_error) {
          setQueryInFlight(false);
          return reject(_error);
        }
      });
      unsubscribe.current = subscription.unsubscribe;
    });
  }

  useEffect(function () {
    // Do nothing
    return function () {
      return cancelSubscription();
    };
  }, []);
  return {
    isInFlight: isInFlight,
    fetch: handleFetch
  };
}

var CHANNELS = {
  PERSONAL_SHOP: 'personalshop',
  BUSINESS_SHOP: 'businessshop',
  PERSONAL_SELF_SERVICE: 'personalss',
  SPARK_DIGITAL_SHOP: 'sparkdigitalshop'
};
var SEGMENTS = {
  PERSONAL: 'personal',
  BUSINESS: 'business',
  LARGE_BUSINESS: 'largeBusinessAndGovernment'
};
var SEGMENT_PATHS = {
  BUSINESS: '/business',
  MY_SPARK: '/online/myspark',
  LARGE_BUSINESS_AND_GOVERNMENT: '/large-business-govt'
};

var SETUP_SERVICE_PROVIDER_ID_FIELD_KEY = 'service_provider_id:chooseNumber=Keep my current number';

var DEFAULT_AUTHENTICATED_PRIMARY_OPTIONS = [{
  name: 'MySpark account',
  code: 'account'
}, {
  name: 'Spark ID settings',
  code: 'settings'
}];
var DEFAULT_AUTHENTICATED_SECONDARY_OPTIONS = [{
  name: 'Sign out',
  code: 'signout'
}];
var DEFAULT_UNAUTHENTICATED_MENU_OPTIONS = [{
  name: 'Top up',
  code: 'topup'
}, {
  name: 'Pay a bill',
  code: 'payabill'
}];
var DEFAULT_UNAUTHENTICATED_SME_MENU_OPTIONS = [{
  name: 'Pay a bill',
  code: 'payabill'
}];
var DEFAULT_HEADER_ID = 'online-shop/header-menu';

var MYSPARK_USAGE_PAGE = '/myspark/beta/usage';
var MYSPARK_BILLING_PAGE = '/myspark/beta/billing';
var MYSPARK_PROFILE_PAGE = '/online/myspark/beta/profile';
var MYSPARK_PRODUCTS_PAGE = '/myspark/beta/subscriptions;';
var MYSPARK_PAY_BILL = '/myspark/paybill';
var MYSPARK_SPARK_ID_SETTINGS = '/secure/myspark/signindetails/';
var MESSAGE_US = '/shop/message-us';
var SHOP_TOP_UP = '/shop/mobile-plans/prepaid/top-up';
var ADDONS_PAGE = '/online/shop/addons';
var ADDONS_SME_PAGE = '/online/shop/business/addons';
var CART_PAGE = '/online/shop/cart';
var CART_SME_PAGE = '/online/shop/business/cart';
var MOBILE_PLANS_PATH = '/online/shop/mobile-plans';
var PAY_BILL_PAGE = '/myspark/paybill/';
var MYSPARK_HOME_PAGE = '/secure/myspark/mysparkhome/';
var SPARK_ID_SETTINGS_PAGE = '/secure/myspark/signindetails/';
var TOP_UP_PAGE = '/shop/mobile-plans/prepaid/top-up';
var BUSINESS_HOME_PAGE = '/business';
var PERSONAL_HOME_PAGE = '/';
var CART = '/cart';
var SEARCH_PATH = '/search';
var BASE_PATH = process.env.NEXT_PUBLIC_BASE_PATH;
var PRODUCT_DETAILS_PAGE = '/products';
var LARGE_BUSINESS_GOVT = '/large-business-govt';

var INCLUDED_TEXT = 'Included';

var GLOBAL_QUERY_PARAMS = {
  isWebView: 'app_webview',
  lineNumber: 'lineNumber',
  productInstanceId: 'productInstanceId'
};

var JOURNEY_HEADER_KEY = 'X-JOURNEYS-NAME';
var JOURNEY_SESSION_KEY = 'journeyName';

function parseSegmentFromPath(pathname) {
  if (pathname.includes("".concat(SEGMENT_PATHS.LARGE_BUSINESS_AND_GOVERNMENT))) {
    return SEGMENTS.LARGE_BUSINESS;
  }

  if (pathname.includes("".concat(SEGMENT_PATHS.BUSINESS, "/"))) {
    return SEGMENTS.BUSINESS;
  }

  return SEGMENTS.PERSONAL;
}

function getChannel(segment, pathname) {
  var BUSINESS = SEGMENTS.BUSINESS,
      LARGE_BUSINESS = SEGMENTS.LARGE_BUSINESS,
      PERSONAL = SEGMENTS.PERSONAL;

  switch (segment) {
    case LARGE_BUSINESS:
      return CHANNELS.SPARK_DIGITAL_SHOP;

    case BUSINESS:
      return CHANNELS.BUSINESS_SHOP;

    case PERSONAL:
      return pathname.includes("".concat(SEGMENT_PATHS.MY_SPARK, "/")) ? CHANNELS.PERSONAL_SELF_SERVICE : CHANNELS.PERSONAL_SHOP;

    default:
      return CHANNELS.PERSONAL_SHOP;
  }
}

var businessSegments = [SEGMENTS.BUSINESS, SEGMENTS.LARGE_BUSINESS];
var getSegmentData = function getSegmentData(pathname) {
  var segment = parseSegmentFromPath(pathname);
  var channel = getChannel(segment, pathname);
  return {
    channel: channel,
    isBusiness: businessSegments.includes(segment),
    isLargeBusiness: segment === SEGMENTS.LARGE_BUSINESS,
    isPersonal: segment === SEGMENTS.PERSONAL,
    segment: segment
  };
};
function useSegment() {
  var pathname = window.location.pathname;
  return getSegmentData(pathname);
}

var _useAvailableAccountsQuery;
var query$1 = _useAvailableAccountsQuery !== void 0 ? _useAvailableAccountsQuery : (_useAvailableAccountsQuery = require("./__generated__/useAvailableAccountsQuery.graphql"), _useAvailableAccountsQuery.hash && _useAvailableAccountsQuery.hash !== "afe4ef8545cac4feb72cab210a98c663" && console.error("The definition of 'useAvailableAccountsQuery' appears to have changed. Run `relay-compiler` to update the generated files to receive the expected data."), _useAvailableAccountsQuery);

var useAvailableAccounts = function useAvailableAccounts(_ref) {
  var cartCookieName = _ref.cartCookieName;
  var ref = useRef();
  var environment = useRelayEnvironment();

  var _useCartCookie = useCartCookie({
    cartCookieName: cartCookieName
  }),
      cartId = _useCartCookie.cartId;

  var _useSegment = useSegment(),
      channel = _useSegment.channel,
      segment = _useSegment.segment;

  useEffect(function () {
    return function () {
      var _a;

      return (_a = ref.current) === null || _a === void 0 ? void 0 : _a.dispose();
    };
  }, []);

  var _useFetchQuery = useFetchQuery(query$1, environment),
      fetch = _useFetchQuery.fetch,
      isInFlight = _useFetchQuery.isInFlight;

  var fetchAvailableAccounts = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var operation, _yield$fetch, accountList, cart, disposable;

      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              operation = createOperationDescriptor(getRequest(query$1), {});
              _context.next = 3;
              return fetch({
                cartId: cartId,
                channel: channel
              });

            case 3:
              _yield$fetch = _context.sent;
              accountList = _yield$fetch.me.accountList;
              cart = _yield$fetch.cartView.cart;
              disposable = environment.retain(operation);
              ref.current = disposable;
              return _context.abrupt("return", {
                accounts: accountList.filter(function (account) {
                  return account.segment === segment;
                }),
                cartAccountNumber: cart === null || cart === void 0 ? void 0 : cart.accountNumber
              });

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function fetchAvailableAccounts() {
      return _ref2.apply(this, arguments);
    };
  }();

  return {
    fetchAvailableAccounts: fetchAvailableAccounts,
    isFetchingAccounts: isInFlight
  };
};

/**
 * Field keys are typically used as form field names.
 * Therefore, model values need to be sanitised to remove
 * characters that are typically reserved by form libraries
 */
function sanitiseValue(value) {
  return value.replace(/\./g, '');
}
/**
 * This function generates unique keys for every field by using its parent's name and value.
 * There may be two fields with the same name but not under the same parent option.
 *
 * When there is no parent, just the field's name will work as a key.
 *
 * Be aware this implementation should be kept in-line with the BFF's buildFieldKey
 *
 * @see buildFieldKey checkoutStructure.helper.ts
 */


function buildFieldKey(_ref) {
  var name = _ref.name,
      parent = _ref.parent;

  if (!parent) {
    return name;
  }

  return "".concat(name, ":").concat(parent.name, "=").concat(sanitiseValue(parent.value));
}
function parseFieldName$1(fieldKey) {
  var _fieldKey$split = fieldKey.split(':'),
      _fieldKey$split2 = _slicedToArray(_fieldKey$split, 1),
      fieldName = _fieldKey$split2[0];

  return fieldName;
}

var convertValue = function convertValue(fieldModel, value) {
  if (_typeof(value) === 'object' && fieldModel.fieldType === 'FULL_DATE_INPUT' || fieldModel.fieldType === 'MONTH_DATE_INPUT') {
    return "".concat(value.yearText, "-").concat(value.monthText, "-").concat(value.dayText);
  }

  return value;
};

function buildEntry(_ref) {
  var formData = _ref.formData,
      name = _ref.name,
      value = _ref.value,
      stepFieldModels = _ref.stepFieldModels;

  var _a;

  var fieldModel = stepFieldModels.find(function (stepFieldModel) {
    // check if field names match
    if (stepFieldModel.name !== name) {
      return false;
    } // check if doesn't have parent


    if (!stepFieldModel.parent) {
      return true;
    } // return if parent's values match


    return formData[stepFieldModel.parent.name] === stepFieldModel.parent.value;
  });

  if (!fieldModel) {
    return null;
  }

  if (value == null || value === '') {
    return null;
  }

  var convertedValue = convertValue(fieldModel, value);
  return {
    name: name,
    value: String(convertedValue),
    parentOption: fieldModel.parent,
    hasOptions: Boolean((_a = fieldModel.options) === null || _a === void 0 ? void 0 : _a.length)
  };
}

function filterRootFields(allEntries) {
  return allEntries.filter(function (entry) {
    return entry.parentOption === null && !entry.hasOptions;
  }).map(function (_ref2) {
    var name = _ref2.name,
        value = _ref2.value;
    return {
      name: name,
      value: value
    };
  });
}

function filterChildFields(_ref3) {
  var allEntries = _ref3.allEntries,
      parentOption = _ref3.parentOption;
  return allEntries.filter(function (entry) {
    return entry.parentOption && entry.parentOption.name === parentOption.name && entry.parentOption.value === parentOption.value && !entry.hasOptions;
  }).map(function (_ref4) {
    var name = _ref4.name,
        value = _ref4.value;
    return {
      name: name,
      value: value
    };
  });
}

function filterOptionsFields(allEntries) {
  return allEntries.filter(function (entry) {
    return entry.hasOptions;
  }).map(function (_ref5) {
    var name = _ref5.name,
        value = _ref5.value,
        parentOption = _ref5.parentOption;
    return {
      name: name,
      value: value,
      fields: filterChildFields({
        allEntries: allEntries,
        parentOption: {
          name: name,
          value: value
        }
      }),
      parentOption: parentOption ? {
        name: parentOption.name,
        value: parentOption.value
      } : null
    };
  });
}

function parseFieldName(key) {
  var _key$split = key.split(':'),
      _key$split2 = _slicedToArray(_key$split, 1),
      fieldName = _key$split2[0];

  return fieldName;
}

function convertFormDataToNames(formData) {
  return Object.fromEntries(Object.entries(formData).map(function (_ref6) {
    var _ref7 = _slicedToArray(_ref6, 2),
        key = _ref7[0],
        value = _ref7[1];

    return [parseFieldName(key), value];
  }));
}

function buildRootFieldsAndOptions(_ref8) {
  var formData = _ref8.formData,
      stepFieldModels = _ref8.stepFieldModels;
  var convertedFormData = convertFormDataToNames(formData);
  var allEntries = Object.entries(convertedFormData).map(function (_ref9) {
    var _ref10 = _slicedToArray(_ref9, 2),
        name = _ref10[0],
        value = _ref10[1];

    return buildEntry({
      formData: convertedFormData,
      name: name,
      value: value,
      stepFieldModels: stepFieldModels
    });
  }).filter(function (entry) {
    return entry;
  });
  var rootFields = filterRootFields(allEntries);
  var options = filterOptionsFields(allEntries);
  return {
    rootFields: rootFields,
    options: options
  };
}

function parseJwt(token) {
  var _a;

  var base64Url = token.split('.')[1];
  var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  var jsonPayload = decodeURIComponent((_a = Buffer.from(base64, 'base64')) === null || _a === void 0 ? void 0 : _a.toString());
  return JSON.parse(jsonPayload);
}

function decodeCartCookie(cartCookieValue) {
  try {
    var payload = parseJwt(cartCookieValue);
    return JSON.parse(payload['cart-details']);
  } catch (_a) {
    return {
      cartId: '',
      itemsCount: 0,
      segment: 'Consumer'
    };
  }
}

// Intl.NumberFormat doesn't support by old browsers (i.e ios13 or below)
// Will use 'currency' and 'narrowSymbol' after getting intl polyfill working in other repos
function formatNZD(value) {
  var numDecimals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  var isNegative = value < 0;
  var positiveValue = Math.abs(value);
  var formmattedDecimalNumber = new Intl.NumberFormat('en-NZ', {
    style: 'decimal',
    maximumFractionDigits: numDecimals,
    minimumFractionDigits: numDecimals
  }).format(positiveValue);
  return "".concat(isNegative ? '-' : '', "$").concat(formmattedDecimalNumber);
}
function formatNZDWithoutSymbol(value) {
  var numDecimals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  return new Intl.NumberFormat('en-NZ', {
    currency: 'NZD',
    maximumFractionDigits: numDecimals,
    minimumFractionDigits: numDecimals
  }).format(value);
}

var getOptionsFromDataRef = function getOptionsFromDataRef(dataRef) {
  var options = dataRef.map(function (_ref) {
    var id = _ref.id,
        text = _ref.text;
    return {
      value: id,
      label: text
    };
  });
  return options;
};
function getSelectedOption(_ref2) {
  var options = _ref2.options,
      value = _ref2.value;

  var _a;

  if (value == null) {
    return null;
  }

  return {
    label: (_a = options.find(function (option) {
      return option.value === value;
    })) === null || _a === void 0 ? void 0 : _a.label,
    value: String(value)
  };
}

/**
 * Enumeration of various date formats used throughout the application.
 * Each format is represented by a string pattern compatible with date formatting libraries.
 */

var DateFormat;

(function (DateFormat) {
  /**
   * Day of the month.
   * Examples: 1, 2, ..., 31
   */
  DateFormat["DAY_OF_MONTH_SINGLE_DIGIT"] = "d";
  /**
   * Day of the month.
   * Examples: 14, 05, 23
   */

  DateFormat["DAY_OF_MONTH"] = "dd";
  /**
   * Abbreviated day of the week.
   * Examples: Tue, Fri, Mon
   */

  DateFormat["DAY_OF_WEEK"] = "iii";
  /**
   * Full date with time.
   * Examples: 28 Jun 2021, 12:40 pm; 15 Aug 2022, 03:15 am
   */

  DateFormat["FULL_DATE_WITH_TIME"] = "dd MMM yyyy, h:mmaaa";
  /**
   * Full date with slashes.
   * Examples: 30/07/2021, 01/01/2020
   */

  DateFormat["FULL_DATE_SLASH_SEPARATED"] = "dd/MM/yyyy";
  /**
   * Full date with spaces.
   * Examples: 28 Jun 2021, 01 Jan 2020
   */

  DateFormat["FULL_DATE_SPACE_SEPARATED"] = "dd MMM yyyy";
  /**
   * Full date with unabbreviated month.
   * Examples: 28 January 2021, 01 February 2020
   */

  DateFormat["FULL_DATE_UNABBREVIATED"] = "dd MMMM yyyy";
  /**
   * Full date in numeric format with spaces.
   * Examples: 28 06 2021, 01 01 2020
   */

  DateFormat["FULL_DATE_IN_NUMBER_SPACE_SEPERATED"] = "dd MM yyyy";
  /**
   * Full date in alphanumeric format with spaces.
   * Examples: 27 September 2022, 01 January 2020
   */

  DateFormat["FULL_DATE_IN_ALPHANUMERIC_SPACE_SEPARATED"] = "d MMMM yyyy";
  /**
   * Hour in 12-hour format with AM/PM.
   * Examples: 11 am, 03 pm
   */

  DateFormat["HOUR"] = "h aa";
  /**
   * Hour of the day in 12-hour format without space.
   * Examples: 11am, 03pm
   */

  DateFormat["HOUR_OF_DAY"] = "haa";
  /**
   * Date in ISO format.
   * Examples: 2021-06-31, 2020-01-01
   */

  DateFormat["ISO_DATE"] = "yyyy-MM-dd";
  /**
   * Month and year.
   * Examples: Jun 2020, Jan 2021
   */

  DateFormat["MONTH_AND_YEAR"] = "MMM yyyy";
  /**
   * Month and year in numeric format.
   * Examples: 09 2020, 01 2021
   */

  DateFormat["MONTH_AND_YEAR_IN_NUMBER"] = "MM yyyy";
  /**
   * Abbreviated month.
   * Examples: Jun, Jan, Feb
   */

  DateFormat["MONTH"] = "MMM";
  /**
   * Time in 12-hour format with minutes and AM/PM.
   * Examples: 11:30 am, 03:45 pm
   */

  DateFormat["TIME"] = "h:mmaaa";
  /**
   * Year.
   * Examples: 2020, 2021
   */

  DateFormat["YEAR"] = "yyyy";
  /**
   * Full unabbreviated month.
   * Examples: January, February, March
   */

  DateFormat["FULL_UNABBREVIATED_MONTH"] = "MMMM";
})(DateFormat || (DateFormat = {}));

function formatDateTime(date, formatString) {
  return format(date, formatString);
}

var formatLineNumber = function formatLineNumber() {
  var lineNumber = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var isScottBaseNumber = lineNumber === '02409';
  var mobilePrefixIndex = lineNumber.indexOf('2');
  var isMobileNumber = mobilePrefixIndex === 1 && !isScottBaseNumber;
  return lineNumber // Format mobile numbers missing a naught at index zero same as landlines
  .replace(isMobileNumber ? /(\w{3})(\w{3})/ : /(\w{2})(\w{3})/, '$1 $2 ').trim().toUpperCase();
};

var getBillingFrequencyLabel = function getBillingFrequencyLabel(billingFrequency) {
  switch (billingFrequency) {
    case 'EVERY_28_DAYS':
      return 'Every 28 days';

    case 'MONTHLY':
      return 'Monthly';

    case 'ONE_OFF':
    case 'UP_FRONT':
      return 'One-off';

    default:
      return null;
  }
};

// TO_DO: Add a common image path which is not specific for Shop.
var PLACEHOLDER_IMAGE_URL = '/content/dam/shop-journeys/addons/no-image.svg';
function getCartImageUrl(productOfferingId, images) {
  var image = images === null || images === void 0 ? void 0 : images.find(function (item) {
    return item.offerId === productOfferingId && item.type === 'PRODUCT';
  });
  return (image === null || image === void 0 ? void 0 : image.url) || PLACEHOLDER_IMAGE_URL;
}

/**
 * This function is used to generate a unique session id for the user and is stored in local storag
 * @returns
 */

function getUiSessionId() {
  var sessionIDKey = 'uiSessionId';

  try {
    var sessionId = localStorage.getItem(sessionIDKey);

    if (sessionId) {
      return sessionId;
    }

    var newSessionId = v4();
    localStorage.setItem(sessionIDKey, newSessionId);
    return newSessionId;
  } catch (_a) {
    // This is a fallback in case of any error
    return 'default-session-id';
  }
}

var testUserProfileStorageKey = 'testUserProfile';

function getTestUserProfileFromUrl() {
  var urlParams = new URLSearchParams(window.location.search);
  var testUserProfile = urlParams.get(testUserProfileStorageKey);

  if (testUserProfile) {
    sessionStorage === null || sessionStorage === void 0 ? void 0 : sessionStorage.setItem(testUserProfileStorageKey, testUserProfile);
  }

  return testUserProfile;
}

function getSparkLdContext() {
  var _a;

  var context = {
    kind: 'user',
    key: getUiSessionId(),
    testUserProfile: getTestUserProfileFromUrl() || ((_a = window === null || window === void 0 ? void 0 : window.sessionStorage) === null || _a === void 0 ? void 0 : _a.getItem(testUserProfileStorageKey)) || ''
  };
  return context;
}

var logFunction = function logFunction(params) {
  var _a, _b, _c, _d;

  try {
    if (params.name === 'network.error') {
      var relayError = params.error;
      var requestId = (_a = relayError === null || relayError === void 0 ? void 0 : relayError.req) === null || _a === void 0 ? void 0 : _a.getID();
      var responseHeaders = (_b = relayError === null || relayError === void 0 ? void 0 : relayError.res) === null || _b === void 0 ? void 0 : _b.headers;
      Sentry.setTag('operation', requestId);
      Sentry.configureScope(function (scope) {
        scope.setTag('X-Global-Transaction-ID', responseHeaders === null || responseHeaders === void 0 ? void 0 : responseHeaders.get('x-global-transaction-id'));
      });
      Sentry.addBreadcrumb({
        message: 'Response error',
        type: 'Error',
        data: {
          errors: (_c = relayError === null || relayError === void 0 ? void 0 : relayError.res) === null || _c === void 0 ? void 0 : _c.errors
        }
      }); // Query errors are captured in Sentry Error boundary

      if ((_d = relayError.req) === null || _d === void 0 ? void 0 : _d.isMutation()) {
        Sentry.captureException(relayError);
      }
    }
  } catch (e) {
    console.log('Error in logging to sentry', e);
  }
};

function pluralize(value, unit, unitOnly) {
  var formattedUnit = unit === null || unit === void 0 ? void 0 : unit.toLowerCase();

  if (value === 1) {
    if (unitOnly) {
      return formattedUnit;
    }

    return "".concat(value, " ").concat(formattedUnit);
  }

  return "".concat(value !== null && value !== void 0 ? value : 0, " ").concat(formattedUnit, "s");
}

function getCartItemPrice(_ref) {
  var price = _ref.price,
      isBusiness = _ref.isBusiness,
      isIncluded = _ref.isIncluded;

  var _a, _b;

  var cartItemPrice = isBusiness ? (_a = price === null || price === void 0 ? void 0 : price.basePrice) === null || _a === void 0 ? void 0 : _a.taxExclusiveValue : (_b = price === null || price === void 0 ? void 0 : price.effectivePrice) === null || _b === void 0 ? void 0 : _b.value;
  if (isIncluded || cartItemPrice === 0) return INCLUDED_TEXT;
  if (!cartItemPrice) return null;
  return "".concat(formatNZD(cartItemPrice)).concat(isBusiness ? '*' : '');
}

var relayEnvironment;
function setJourneyName(newJourneyName) {
  if (typeof window !== 'undefined') {
    if (!newJourneyName) {
      sessionStorage.removeItem(JOURNEY_SESSION_KEY);
      return;
    }

    sessionStorage.setItem(JOURNEY_SESSION_KEY, newJourneyName);
  }
}
function getJourneyName() {
  if (typeof window !== 'undefined') {
    var sessionJourneyName = sessionStorage === null || sessionStorage === void 0 ? void 0 : sessionStorage.getItem(JOURNEY_SESSION_KEY);
    return sessionJourneyName === 'undefined' ? null : sessionJourneyName;
  }
}
function buildHeadersMiddleware() {
  var journeyName = getJourneyName();
  return function (next) {
    return function (req) {
      if (process.env.NODE_ENV === 'production') {
        req.fetchOpts.credentials = 'include';
      }

      if (journeyName) {
        req.fetchOpts.headers[JOURNEY_HEADER_KEY] = journeyName;
      }

      req.fetchOpts.headers['X-DASL-SESSION-ID'] = getUiSessionId();
      return next(req);
    };
  };
}
var makeRelayEnvironment = function makeRelayEnvironment(_ref) {
  var url = _ref.graphqlURL;
  var store = new Store(new RecordSource(), {
    // This property tells Relay to not immediately clear its cache when the user
    // navigates around the app. Relay will hold onto the specified number of
    // query results, allowing the user to return to recently visited pages
    // and reusing cached data if its available/fresh.
    gcReleaseBufferSize: 10
  });
  var middlewares = [cacheMiddleware(), urlMiddleware({
    url: url
  }), buildHeadersMiddleware()];
  return new Environment({
    store: store,
    log: logFunction,
    network: new RelayNetworkLayer(middlewares)
  });
};
function createRelayEnvironment(config) {
  if (!relayEnvironment) {
    relayEnvironment = makeRelayEnvironment(config);
  }

  return relayEnvironment;
}
function resetRelayEnvironment() {
  relayEnvironment = null;
}

function removeMatchingRegex(stringArg, regex) {
  return stringArg.replace(regex, '').trim().replace(/\s\s+/g, ' ');
}

function removePricesAndCharacteristics(productName) {
  var priceAndCharacteristicsRegex = /(^\$((?:\d|,)*\.?\d+))|(^\d(\d|\w)+)/;
  return removeMatchingRegex(productName, priceAndCharacteristicsRegex);
}
function removePrice(productName) {
  var priceRegex = /(^\$((?:\d|,)*\.?\d+))/;
  return removeMatchingRegex(productName, priceRegex);
}

var BAMBORA_CARD_BRANDS_PATH = 'https://cdn.na.bambora.com/downloads/images/cards';
function buildCardBrandLogoURL(cardBrand) {
  if (!cardBrand) {
    return null;
  }

  return "".concat(BAMBORA_CARD_BRANDS_PATH, "/").concat(cardBrand, ".svg");
}
function getLastFourCardCharacters(maskedCardNumber) {
  return maskedCardNumber.slice(maskedCardNumber.length - 4);
}

var CHECKOUT_ACTION_LAYER_INNER_ID = 'checkoutPrimaryActionLayerInner'; // TO_DO: Add CHECKOUT_HEADER_HEIGHT to params.

var CHECKOUT_HEADER_HEIGHT = 147;
function smoothScrollToId(id, parentId) {
  var scrollContainer = document.getElementById(parentId || CHECKOUT_ACTION_LAYER_INNER_ID);
  var sectionContainer = document.getElementById(id);

  if (!sectionContainer) {
    return;
  }

  scrollTo(scrollContainer, {
    behavior: 'smooth',
    duration: 2000,
    top: sectionContainer.offsetTop - CHECKOUT_HEADER_HEIGHT
  });
}
function instantScrollToId(id) {
  var scrollContainer = document.getElementById(CHECKOUT_ACTION_LAYER_INNER_ID);
  var sectionContainer = document.getElementById(id);
  scrollTo(scrollContainer, {
    behavior: 'auto',
    duration: 0,
    top: sectionContainer.offsetTop - CHECKOUT_HEADER_HEIGHT
  });
}

function extractDESLErrorAttributes(error) {
  var _a, _b, _c, _d, _e, _f;

  if (error.name !== 'RRNLRequestError') {
    return {
      code: null,
      message: null
    };
  }

  var responseMessageError = (_f = (_e = (_d = (_c = (_b = (_a = error.res.errors) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.extensions) === null || _c === void 0 ? void 0 : _c.response) === null || _d === void 0 ? void 0 : _d.body) === null || _e === void 0 ? void 0 : _e.messages) === null || _f === void 0 ? void 0 : _f[0];

  if (responseMessageError == null) {
    return {
      code: null,
      message: null
    };
  }

  var code = responseMessageError.code,
      message = responseMessageError.message;
  return {
    code: code,
    message: message
  };
}

var ErrorBoundary = /*#__PURE__*/function (_React$Component) {
  _inherits(ErrorBoundary, _React$Component);

  var _super = _createSuper(ErrorBoundary);

  function ErrorBoundary(props) {
    var _this;

    _classCallCheck(this, ErrorBoundary);

    _this = _super.call(this, props);
    _this.state = {
      error: null
    };
    return _this;
  }

  _createClass(ErrorBoundary, [{
    key: "componentDidCatch",
    value: function componentDidCatch(error, errorInfo) {
      // displays the actual error in the console, to get a clear fail fast feedback
      // eslint-disable-next-line no-console
      console.error('ErrorBoundary did catch error: ', error);
      var onError = this.props.onError;
      Sentry.withScope(function (scope) {
        scope.setExtras({
          errorInfo: errorInfo
        });
        Sentry.captureException(error);
      });

      if (onError) {
        onError(error);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var error = this.state.error;
      var _this$props = this.props,
          Fallback = _this$props.fallback,
          children = _this$props.children,
          _this$props$showFallb = _this$props.showFallback,
          showFallback = _this$props$showFallb === void 0 ? true : _this$props$showFallb;

      if (error && showFallback) {
        var _extractDESLErrorAttr = extractDESLErrorAttributes(error),
            deslCode = _extractDESLErrorAttr.code,
            deslMessage = _extractDESLErrorAttr.message;

        return /*#__PURE__*/React.createElement(Fallback, {
          error: error,
          deslCode: deslCode,
          deslMessage: deslMessage
        });
      }

      return /*#__PURE__*/React.createElement(React.Fragment, null, children);
    }
  }], [{
    key: "getDerivedStateFromError",
    value: function getDerivedStateFromError(error) {
      // Update state so the next render will show the fallback UI.
      return {
        error: error
      };
    }
  }]);

  return ErrorBoundary;
}(React.Component);

function TestForm(_ref) {
  var children = _ref.children,
      _ref$defaultValues = _ref.defaultValues,
      defaultValues = _ref$defaultValues === void 0 ? {} : _ref$defaultValues,
      submitHandler = _ref.onSubmit,
      onFormDataChange = _ref.onFormDataChange;
  var form = useForm({
    defaultValues: defaultValues,
    mode: 'all'
  });
  var handleSubmit = form.handleSubmit,
      watch = form.watch;
  var formData = watch();
  useEffect(function () {
    if (onFormDataChange) {
      onFormDataChange(formData);
    }
  }, [formData]);
  return /*#__PURE__*/React.createElement("form", {
    onSubmit: handleSubmit(submitHandler)
  }, /*#__PURE__*/React.createElement(FormProvider, Object.assign({}, form), /*#__PURE__*/React.createElement(ErrorBoundary, {
    fallback: function fallback() {
      return /*#__PURE__*/React.createElement("p", null, "Error boundary");
    }
  }, children)));
}

function setupRenderWithForm(render) {
  return function renderWithForm(children, options) {
    return render( /*#__PURE__*/React.createElement(TestForm, {
      defaultValues: options === null || options === void 0 ? void 0 : options.defaultValues,
      onFormDataChange: options === null || options === void 0 ? void 0 : options.onFormDataChange,
      onSubmit: options === null || options === void 0 ? void 0 : options.onSubmit
    }, children), options);
  };
}

function getContentVariation(isBusiness, variation) {
  if (variation) {
    return variation;
  }

  return isBusiness ? 'business' : 'consumer';
}

var generateContentHeaders = function generateContentHeaders() {
  var headers = {};
  var journeyName = getJourneyName();

  if (journeyName) {
    headers[JOURNEY_HEADER_KEY] = journeyName;
  }

  return headers;
};

function addQueryParamToURL(url, variation) {
  var urlObj = new URL(url);

  if (Boolean(variation)) {
    urlObj.searchParams.append('variation', variation);
  }

  return urlObj.toString();
}

var useContent = function useContent(_ref) {
  var apiBaseUrl = _ref.apiBaseUrl,
      modelId = _ref.modelId,
      contentId = _ref.contentId,
      variation = _ref.variation,
      persistedQuery = _ref.persistedQuery,
      _ref$format = _ref.format,
      format = _ref$format === void 0 ? 'json' : _ref$format,
      queryOptions = _ref.queryOptions;
  var url = addQueryParamToURL("".concat(apiBaseUrl, "/v2/utility/content/fragments/spark-models/").concat(persistedQuery, "/models/").concat(modelId, "/").concat(contentId, "/").concat(format), variation);
  var headers = generateContentHeaders();
  return useQuery(['AuthorableContent', modelId, contentId, variation, format], function () {
    return fetch(url, {
      headers: headers
    }).then(function (res) {
      return res.json();
    });
  }, Object.assign({}, queryOptions));
};

function getUrl() {
  return "".concat(window.location.origin, "/rest/v1/access/logout");
}

function useLogout() {
  function logoutAndRedirectToHome() {
    window.location.assign(getUrl());
  }

  function requestLogout() {
    return _requestLogout.apply(this, arguments);
  }

  function _requestLogout() {
    _requestLogout = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var response;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return fetch(getUrl(), {
                method: 'GET'
              });

            case 2:
              response = _context.sent;
              return _context.abrupt("return", {
                success: response.ok
              });

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return _requestLogout.apply(this, arguments);
  }

  return {
    requestLogout: requestLogout,
    logoutAndRedirectToHome: logoutAndRedirectToHome
  };
}

function promisifyMutation(commitFn) {
  return function (variables) {
    return new Promise(function (resolve, reject) {
      commitFn({
        onCompleted: resolve,
        onError: reject,
        variables: variables
      });
    });
  };
}

function usePromiseMutation(mutation) {
  var _useMutation = useMutation(mutation),
      _useMutation2 = _slicedToArray(_useMutation, 1),
      commitFn = _useMutation2[0];

  return promisifyMutation(commitFn);
}

function trackFieldError(_ref) {
  var errorMessage = _ref.errorMessage,
      label = _ref.label,
      sectionName = _ref.sectionName;
  trackDigitalEvent({
    event: 'userInputError',
    w3cddl: {
      event: [{
        eventInfo: {
          eventName: "Checkout ".concat(sectionName, " User Input Error"),
          eventAction: 'userInputError'
        },
        attributes: {
          userInputError: {
            inputField: label,
            errorMessage: errorMessage,
            inputErrorType: 'Immediate error'
          }
        }
      }]
    }
  });
}
function useTrackFieldError(_ref2) {
  var errorMessage = _ref2.errorMessage,
      label = _ref2.label,
      sectionName = _ref2.sectionName;
  useEffect(function () {
    if (errorMessage) {
      trackFieldError({
        label: label,
        errorMessage: errorMessage,
        sectionName: sectionName
      });
    }
  }, [errorMessage]);
}

var _templateObject$B, _templateObject2$p, _templateObject3$d;
var FAQsAccordionContainer = styled.div(_templateObject$B || (_templateObject$B = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref) {
  var _ref$theme = _ref.theme,
      media = _ref$theme.media,
      _ref$theme$spacing = _ref$theme.spacing,
      s8 = _ref$theme$spacing.s8,
      s9 = _ref$theme$spacing.s9,
      s10 = _ref$theme$spacing.s10;
  return css(_templateObject2$p || (_templateObject2$p = _taggedTemplateLiteral(["\n    padding-top: ", ";\n    margin-bottom: ", ";\n\n    ", " {\n      padding-top: ", ";\n      margin-bottom: ", ";\n    }\n\n    ", " {\n      padding-top: ", ";\n      margin: 0 auto ", ";\n      max-width: 742px;\n    }\n  "])), s8, s8, media.up('slim'), s9, s9, media.up('big'), s9, s10);
});
var HeadingText = styled(Text)(_templateObject3$d || (_templateObject3$d = _taggedTemplateLiteral(["\n  text-align: center;\n"])));

var AccordionWithContentLoader = function AccordionWithContentLoader() {
  return /*#__PURE__*/React.createElement(FAQsAccordionContainer, null, /*#__PURE__*/React.createElement(HeadingText, {
    variant: "headingS"
  }, "Important things to know"), /*#__PURE__*/React.createElement(SparkContentLoader, {
    height: 500,
    width: 300,
    title: "Loading ...",
    style: {
      width: '100%'
    },
    "data-testid": "faq-accordion-loader"
  }, /*#__PURE__*/React.createElement("rect", {
    x: "0",
    y: "24",
    rx: "8",
    ry: "8",
    width: "100%",
    height: "60"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "0",
    y: "108",
    rx: "8",
    ry: "8",
    width: "100%",
    height: "60"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "0",
    y: "192",
    rx: "8",
    ry: "8",
    width: "100%",
    height: "60"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "0",
    y: "276",
    rx: "8",
    ry: "8",
    width: "100%",
    height: "60"
  })));
};

var GenericErrorText = function GenericErrorText() {
  return /*#__PURE__*/React.createElement("div", null, "The data is currently unavailable. Please come back later and try again.");
};

var _templateObject$A, _templateObject2$o;
var Title$1 = styled(Text)(_templateObject$A || (_templateObject$A = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref) {
  var _ref$theme = _ref.theme,
      media = _ref$theme.media,
      spacing = _ref$theme.spacing;
  return css(_templateObject2$o || (_templateObject2$o = _taggedTemplateLiteral(["\n    margin: 0 auto ", ";\n    width: 100%;\n    text-align: center;\n\n    ", " {\n      margin-bottom: ", ";\n    }\n  "])), spacing.s4, media.up('big'), spacing.s7);
});

var AccordionContentBody = function AccordionContentBody(_ref2) {
  var apiBaseUrl = _ref2.apiBaseUrl,
      contentId = _ref2.contentId,
      variation = _ref2.variation,
      regionId = _ref2.regionId;

  var _a, _b, _c, _d, _e;

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      currentExpandedItems = _useState2[0],
      setCurrentExpandedItems = _useState2[1];

  var _useTheme = useTheme(),
      palette = _useTheme.palette;

  var _useContent = useContent({
    apiBaseUrl: apiBaseUrl,
    persistedQuery: 'accordion-modal-list',
    modelId: 'accordion-modal-model',
    contentId: contentId,
    format: 'html',
    variation: variation
  }),
      accordionResponse = _useContent.data,
      isLoading = _useContent.isLoading;

  if (isLoading) {
    return /*#__PURE__*/React.createElement(AccordionWithContentLoader, null);
  }

  var data = accordionResponse.data;
  var accordionTitle = (_b = (_a = data.accordionModalList.items) === null || _a === void 0 ? void 0 : _a[0].title) !== null && _b !== void 0 ? _b : '';
  var accordionList = (_c = data.accordionModalList.items) !== null && _c !== void 0 ? _c : [];
  var accordionContent = (_e = (_d = accordionList[0]) === null || _d === void 0 ? void 0 : _d.fieldLabel) !== null && _e !== void 0 ? _e : [];
  return /*#__PURE__*/React.createElement(LinkRegion, {
    regionId: regionId || accordionTitle
  }, /*#__PURE__*/React.createElement(Title$1, {
    variant: "headingS"
  }, accordionTitle), /*#__PURE__*/React.createElement(Accordion, {
    allowMultipleExpanded: true,
    onChange: function onChange(expandedItems) {
      setCurrentExpandedItems(expandedItems);
      trackCustomLink(expandedItems[0]);
    }
  }, accordionContent.map(function (_ref3) {
    var accordionItemTitle = _ref3.accordionItemTitle,
        accordionItemContent = _ref3.accordionItemContent;
    var id = kebabCase(accordionItemTitle);
    return /*#__PURE__*/React.createElement(AccordionItem, {
      key: id,
      uuid: id,
      isOpen: currentExpandedItems.includes(id)
    }, /*#__PURE__*/React.createElement(AccordionItemHeading, null, /*#__PURE__*/React.createElement(Text, {
      variant: "subheadingM"
    }, accordionItemTitle), /*#__PURE__*/React.createElement(AccordionButton, null)), /*#__PURE__*/React.createElement(AccordionItemBodyWithAnimation, {
      isOpen: currentExpandedItems.includes(id)
    }, /*#__PURE__*/React.createElement(RawHtml, {
      color: palette.baseColors.newZealandBlack,
      variant: "bodySMedium",
      html: accordionItemContent.html
    })));
  })));
};

var AccordionWithContent = function AccordionWithContent(_ref4) {
  var apiBaseUrl = _ref4.apiBaseUrl,
      contentId = _ref4.contentId,
      variation = _ref4.variation,
      regionId = _ref4.regionId;

  var _useSegment = useSegment(),
      isBusiness = _useSegment.isBusiness;

  return /*#__PURE__*/React.createElement(ErrorBoundary, {
    fallback: function fallback() {
      return /*#__PURE__*/React.createElement(GenericErrorText, null);
    }
  }, /*#__PURE__*/React.createElement(Suspense, {
    fallback: /*#__PURE__*/React.createElement(AccordionWithContentLoader, null)
  }, /*#__PURE__*/React.createElement(AccordionContentBody, {
    apiBaseUrl: apiBaseUrl,
    contentId: contentId,
    regionId: regionId,
    variation: getContentVariation(isBusiness, variation)
  })));
};

var _templateObject$z, _templateObject2$n;
styled.div(_templateObject$z || (_templateObject$z = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref) {
  var media = _ref.theme.media;
  return css(_templateObject2$n || (_templateObject2$n = _taggedTemplateLiteral(["\n    display: flex;\n    flex-direction: column;\n    min-width: 327px;\n\n    ", " {\n      width: 376px;\n    }\n\n    ", " {\n      width: 392px;\n    }\n  "])), media.up('slim'), media.up('big'));
});

var SERVICE_PROVIDER_ACCOUNT_VALIDATION_RULES = {
  '5': {
    message: 'Please enter 9 digits, beginning with 0, 3 or 4',
    pattern: /^(0|3|4)[0-9]{8}$/
  },
  '24': {
    message: 'Please enter from 4 to 10 digits',
    pattern: /^[0-9]{4,10}$/
  },
  '27': {
    message: 'Please enter from 8 digits',
    pattern: /^[0-9]{8,}$/
  }
};
var FALLBACK_ACCOUNT_VALIDATION_RULE = {
  message: 'Please check if the account number is correct',
  pattern: /^[0-9]{4,25}$/
};
function AccountNumberField$1(_ref) {
  var model = _ref.model,
      sectionName = _ref.sectionName;

  var _a, _b;

  var serviceProviderId = useWatch({
    name: SETUP_SERVICE_PROVIDER_ID_FIELD_KEY
  });
  var validationRule = (_a = SERVICE_PROVIDER_ACCOUNT_VALIDATION_RULES[serviceProviderId]) !== null && _a !== void 0 ? _a : FALLBACK_ACCOUNT_VALIDATION_RULE;

  var _useController = useController({
    name: model.key,
    defaultValue: '',
    rules: {
      pattern: validationRule.pattern,
      required: model.required
    },
    shouldUnregister: true
  }),
      field = _useController.field,
      fieldState = _useController.fieldState;

  var value = String((_b = field.value) !== null && _b !== void 0 ? _b : '');
  var isError = value !== '' && fieldState.isDirty && fieldState.invalid;
  var errorMessage = isError ? validationRule.message : null;
  var optionalField = !model.required;
  useTrackFieldError({
    errorMessage: errorMessage,
    label: model.label,
    sectionName: sectionName
  });

  var handleChange = function handleChange(event) {
    field.onChange(event.target.value);
  };

  return /*#__PURE__*/React.createElement(NumberInput, {
    name: model.key,
    label: model.label,
    placeholder: model.placeholder,
    onChange: handleChange,
    errorText: errorMessage,
    optional: optionalField,
    value: value
  });
}

function __rest(s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}

var _templateObject$y, _templateObject2$m, _templateObject3$c, _templateObject4$b;
var HeadingFieldWrapper = styled(Box)(_templateObject$y || (_templateObject$y = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref) {
  var media = _ref.theme.media,
      hasInfoLayerContentKey = _ref.hasInfoLayerContentKey;
  return css(_templateObject2$m || (_templateObject2$m = _taggedTemplateLiteral(["\n    ", " {\n      max-width: ", ";\n    }\n  "])), media.up('lil'), hasInfoLayerContentKey && '300px');
});
var InfoHeading = styled(Text)(_templateObject3$c || (_templateObject3$c = _taggedTemplateLiteral(["\n  display: inline-block;\n"])));
var IconButton = styled(TextButton)(_templateObject4$b || (_templateObject4$b = _taggedTemplateLiteral(["\n  position: relative;\n  top: 4px;\n"])));

var InfoButton = function InfoButton(_ref2) {
  var onIconClick = _ref2.onIconClick,
      testId = _ref2.testId;

  var _useTheme = useTheme(),
      palette = _useTheme.palette;

  return /*#__PURE__*/React.createElement(IconButton, {
    type: "button",
    "data-testid": testId,
    onClick: onIconClick,
    variant: "textbutton"
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "info_small",
    fill: palette.baseColors.lupin
  }));
};

var typographyVariants = Object.keys(TextVariantMap);
function HeadingField(_ref3) {
  var model = _ref3.model,
      onInfoLayerChange = _ref3.onInfoLayerChange;
  var infoLayerContentKey = model.infoLayerContentKey,
      label = model.label,
      name = model.name,
      typographyVariant = model.typographyVariant;
  var variant = typographyVariants.includes(typographyVariant) ? typographyVariant : 'bodyMDemi';
  return /*#__PURE__*/React.createElement(HeadingFieldWrapper, {
    hasInfoLayerContentKey: Boolean(infoLayerContentKey)
  }, /*#__PURE__*/React.createElement(InfoHeading, {
    variant: variant
  }, label, infoLayerContentKey ? /*#__PURE__*/React.createElement(InfoButton, {
    testId: name,
    onIconClick: function onIconClick() {
      trackCustomLink('Info icon');

      if (typeof onInfoLayerChange === 'function') {
        onInfoLayerChange(infoLayerContentKey);
      }
    }
  }) : null));
}

var _templateObject$x;
var CONTENT_TYPOGRAPHY = css(_templateObject$x || (_templateObject$x = _taggedTemplateLiteral(["\n  h6 {\n    ", "\n  }\n\n  p {\n    ", "\n  }\n\n  b {\n    ", "\n  }\n\n  span {\n    ", "\n    color: ", ";\n  }\n\n  ol,\n  ul {\n    padding-left: ", ";\n\n    li {\n      ", "\n    }\n  }\n"])), subheadingMStyle, bodySMediumStyle, bodySDemiStyle, footNoteDemiStyle, colors.mawheranui, spacing.s2, bodySMediumStyle);
function RawHTMLContent(_ref) {
  var content = _ref.content,
      typography = _ref.typography;

  var _useTheme = useTheme(),
      palette = _useTheme.palette;

  return /*#__PURE__*/React.createElement(RawHtml, {
    variant: "bodySMedium",
    linkStyle: "lightMode",
    bulletColor: palette.baseColors.newZealandBlack,
    color: palette.baseColors.newZealandBlack,
    html: content,
    customHtmlStyles: typography || CONTENT_TYPOGRAPHY
  });
}

function InfoBannerWithContent(_ref) {
  var journeyStepId = _ref.journeyStepId,
      contentKey = _ref.contentKey,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'INFO' : _ref$variant,
      contentVariation = _ref.contentVariation;

  var _useAuthorableContent = useAuthorableContentsFromRelay(journeyStepId, contentVariation),
      getText = _useAuthorableContent.getText;

  var content = getText(contentKey);
  return /*#__PURE__*/React.createElement(InfoBanner, {
    variant: variant
  }, /*#__PURE__*/React.createElement(RawHTMLContent, {
    content: content
  }));
}

function ChoiceBoxFieldDescription(_ref) {
  var journeyStepId = _ref.journeyStepId,
      contentKey = _ref.contentKey,
      contentVariation = _ref.contentVariation;

  var _useAuthorableContent = useAuthorableContentsFromRelay(journeyStepId, contentVariation),
      getText = _useAuthorableContent.getText;

  return /*#__PURE__*/React.createElement(Box, {
    mb: "s2"
  }, /*#__PURE__*/React.createElement(RawHTMLContent, {
    content: getText(contentKey)
  }));
}

var _templateObject$w, _templateObject2$l;
var IconWithMargin = styled(Icon)(_templateObject$w || (_templateObject$w = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref) {
  var spacing = _ref.theme.spacing;
  return css(_templateObject2$l || (_templateObject2$l = _taggedTemplateLiteral(["\n    margin-right: ", ";\n  "])), spacing.s1_5);
});

function ChoiceBoxOption(_ref2) {
  var onSelect = _ref2.onSelect,
      optionModel = _ref2.optionModel,
      selectedValue = _ref2.selectedValue,
      infoBoxContent = _ref2.infoBoxContent,
      journeyStepId = _ref2.journeyStepId,
      contentVariation = _ref2.contentVariation;

  var _useTheme = useTheme(),
      palette = _useTheme.palette;

  var infoBannerContentKey = optionModel.infoBannerContentKey,
      infoBannerVariant = optionModel.infoBannerVariant;
  var isChecked = optionModel.value === selectedValue;
  var hasInfoBox = infoBoxContent || journeyStepId && infoBannerContentKey;
  var shouldDisplayInfoBox = hasInfoBox && isChecked;

  function handleChange() {
    trackCustomLink(optionModel.value);
    onSelect(optionModel.value);
  }

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ChoiceBox, {
    key: optionModel.value,
    name: optionModel.value,
    checked: isChecked,
    onChange: handleChange,
    value: optionModel.value
  }, /*#__PURE__*/React.createElement(Box, {
    flexDirection: "row"
  }, optionModel.iconName ? /*#__PURE__*/React.createElement(IconWithMargin, {
    fill: palette.baseColors.lupin,
    name: optionModel.iconName
  }) : null, /*#__PURE__*/React.createElement(Box, {
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "center"
  }, /*#__PURE__*/React.createElement(Text, {
    variant: "bodySDemi"
  }, optionModel.label), /*#__PURE__*/React.createElement(Text, {
    variant: "bodySMedium"
  }, optionModel.sublabel)))), shouldDisplayInfoBox ? /*#__PURE__*/React.createElement(Box, {
    pt: "s1",
    mb: "s2"
  }, /*#__PURE__*/React.createElement(InfoBannerWithContent, Object.assign({}, infoBoxContent || {
    journeyStepId: journeyStepId,
    contentKey: infoBannerContentKey,
    variant: infoBannerVariant,
    contentVariation: contentVariation
  }))) : null);
}

function filterVisibleOptions(options) {
  return options.filter(function (option) {
    return option.visibility;
  });
}

function HiddenSingleOption(_ref3) {
  var model = _ref3.model,
      visibleOptions = _ref3.visibleOptions;

  var _useController = useController({
    defaultValue: model.defaultValue,
    rules: {
      required: model.required
    },
    name: model.key,
    shouldUnregister: true
  }),
      field = _useController.field; // UI rerendering issue using field.onchange in useeffect with empty array in dependency
  // Tried adding dependency like visibleOptions[0].value and field to useeffect this is leading to infinite loop
  // Also tried adding useState to set the value, setValue and trigger from useForm hook. Still did n't work.
  // Adding field.value to this worked fine. If we face any issue with this component in future, we need to change the logic for this component.


  useEffect(function () {
    var value = visibleOptions[0].value;
    field.onChange(value);
  }, [field.value]);
  return null;
}

function StandardChoiceBoxField(_a) {
  var model = _a.model,
      onInfoLayerChange = _a.onInfoLayerChange,
      infoBoxContent = _a.infoBoxContent,
      journeyStepId = _a.journeyStepId,
      contentVariation = _a.contentVariation,
      rest = __rest(_a, ["model", "onInfoLayerChange", "infoBoxContent", "journeyStepId", "contentVariation"]);

  var _useController2 = useController({
    defaultValue: model.defaultValue,
    rules: {
      required: model.required
    },
    name: model.key,
    shouldUnregister: true
  }),
      field = _useController2.field;

  var handleSelect = function handleSelect(value) {
    field.onChange({
      target: {
        value: value
      }
    });
  };

  var hasDescription = journeyStepId && model.contentKey;
  var visibleOptions = filterVisibleOptions(model.options);
  useEffect(function () {
    if (visibleOptions.length === 1) {
      var value = visibleOptions[0].value;
      handleSelect(value);
    }
  }, []);
  return /*#__PURE__*/React.createElement(ChoiceboxGroup, null, /*#__PURE__*/React.createElement(Box, {
    mb: "s2"
  }, /*#__PURE__*/React.createElement(HeadingField, Object.assign({}, rest, {
    model: model,
    onInfoLayerChange: onInfoLayerChange
  }))), hasDescription ? /*#__PURE__*/React.createElement(ChoiceBoxFieldDescription, {
    journeyStepId: journeyStepId,
    contentKey: model.contentKey,
    contentVariation: contentVariation
  }) : null, visibleOptions.map(function (optionModel) {
    return /*#__PURE__*/React.createElement(ChoiceBoxOption, {
      key: optionModel.value,
      onSelect: handleSelect,
      optionModel: optionModel,
      selectedValue: String(field.value),
      infoBoxContent: infoBoxContent,
      journeyStepId: journeyStepId,
      contentVariation: contentVariation
    });
  }));
}

function ChoiceBoxField(_a) {
  var model = _a.model,
      rest = __rest(_a, ["model"]);

  var visibleOptions = filterVisibleOptions(model.options);

  if (visibleOptions.length === 1 && model.shouldHideWhenSingleOption) {
    return /*#__PURE__*/React.createElement(HiddenSingleOption, {
      model: model,
      visibleOptions: visibleOptions
    });
  }

  return /*#__PURE__*/React.createElement(StandardChoiceBoxField, Object.assign({
    model: model
  }, rest));
}

var _templateObject$v, _templateObject2$k, _templateObject3$b, _templateObject4$a, _templateObject5$5, _templateObject6$5;
var BaseDateTextInput = styled(NumberInput)(_templateObject$v || (_templateObject$v = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref) {
  var _ref$theme = _ref.theme,
      palette = _ref$theme.palette,
      spacing = _ref$theme.spacing,
      isError = _ref.isError;
  return css(_templateObject2$k || (_templateObject2$k = _taggedTemplateLiteral(["\n    flex-shrink: 0;\n    margin-right: ", ";\n    width: 74px;\n\n    ", ";\n  "])), spacing.s2, isError && css(_templateObject3$b || (_templateObject3$b = _taggedTemplateLiteral(["\n      &,\n      :focus-within {\n        border: 2px solid ", ";\n      }\n    "])), palette.baseColors.marangai));
});
var DayTextInput = BaseDateTextInput;
var MonthTextInput = styled(NumberInput)(_templateObject4$a || (_templateObject4$a = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref2) {
  var _ref2$theme = _ref2.theme,
      palette = _ref2$theme.palette,
      spacing = _ref2$theme.spacing,
      isError = _ref2.isError,
      isFullDate = _ref2.isFullDate;
  return css(_templateObject5$5 || (_templateObject5$5 = _taggedTemplateLiteral(["\n    margin-right: ", ";\n    width: ", ";\n\n    ", ";\n  "])), spacing.s2, isFullDate ? '74px' : '104px', isError && css(_templateObject6$5 || (_templateObject6$5 = _taggedTemplateLiteral(["\n      &,\n      :focus-within {\n        border: 2px solid ", ";\n      }\n    "])), palette.baseColors.marangai));
});
var DateInputField = function DateInputField(_ref3) {
  var model = _ref3.model,
      textValues = _ref3.textValues,
      fieldState = _ref3.fieldState,
      _onChange = _ref3.onChange,
      onBlur = _ref3.onBlur,
      isFullDate = _ref3.isFullDate;

  var _a, _b;

  var _useTheme = useTheme(),
      marangai = _useTheme.palette.baseColors.marangai;

  var isError = fieldState.isDirty && fieldState.invalid;
  var errorMessage = ((_a = model === null || model === void 0 ? void 0 : model.minimumRule) === null || _a === void 0 ? void 0 : _a.message) || ((_b = model === null || model === void 0 ? void 0 : model.maximumRule) === null || _b === void 0 ? void 0 : _b.message) || 'Invalid date';
  var errorText = isError ? errorMessage : null;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, {
    variant: "bodySDemi",
    mb: "s0_5"
  }, model.label), /*#__PURE__*/React.createElement(Box, {
    flexDirection: "row"
  }, isFullDate ? /*#__PURE__*/React.createElement(DayTextInput, {
    name: model.key,
    value: textValues === null || textValues === void 0 ? void 0 : textValues.dayText,
    isError: isError,
    onChange: function onChange(event) {
      return _onChange({
        dayText: event.target.value
      });
    },
    onBlur: onBlur,
    placeholder: "DD",
    inputProps: {
      maxLength: 2
    }
  }) : null, /*#__PURE__*/React.createElement(MonthTextInput, {
    name: model.key,
    value: textValues === null || textValues === void 0 ? void 0 : textValues.monthText,
    isError: isError,
    onChange: function onChange(event) {
      return _onChange({
        monthText: event.target.value
      });
    },
    onBlur: onBlur,
    placeholder: "MM",
    isFullDate: isFullDate,
    inputProps: {
      maxLength: 2
    }
  }), /*#__PURE__*/React.createElement(NumberInput, {
    name: model.key,
    value: textValues === null || textValues === void 0 ? void 0 : textValues.yearText,
    onChange: function onChange(event) {
      return _onChange({
        yearText: event.target.value
      });
    },
    showErrorMessage: false,
    errorText: errorText,
    onBlur: onBlur,
    placeholder: "YYYY",
    inputProps: {
      maxLength: 4
    }
  })), isError ? /*#__PURE__*/React.createElement(Text, {
    variant: "bodySDemi",
    color: marangai
  }, errorText) : null);
};

function HeaderCategoryList(_ref) {
  var categories = _ref.categories,
      _onCategoryClick = _ref.onCategoryClick;

  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      selectedCategory = _useState2[0],
      setSelectedCategory = _useState2[1];

  return /*#__PURE__*/React.createElement(React.Fragment, null, categories === null || categories === void 0 ? void 0 : categories.map(function (_ref2) {
    var label = _ref2.label,
        iconName = _ref2.iconName,
        url = _ref2.url;
    return /*#__PURE__*/React.createElement(HeaderCategory, {
      key: label,
      isSelected: label === selectedCategory,
      onCategoryClick: function onCategoryClick() {
        setSelectedCategory(label);

        if (_onCategoryClick) {
          _onCategoryClick(url, label);
        }
      },
      iconName: iconName
    }, label);
  }));
}

var AuthorableContentsContext = /*#__PURE__*/React.createContext(null);

var AuthorableContentsProvider = function AuthorableContentsProvider(_ref) {
  var children = _ref.children,
      defaultContents = _ref.defaultContents;

  var _useState = useState(defaultContents),
      _useState2 = _slicedToArray(_useState, 2),
      authorableContents = _useState2[0],
      setAuthorableContents = _useState2[1];

  var updateAuthorableContents = function updateAuthorableContents(newContents) {
    setAuthorableContents(function (contents) {
      return Object.assign(Object.assign({}, contents), newContents);
    });
  };

  return /*#__PURE__*/React.createElement(AuthorableContentsContext.Provider, {
    value: {
      authorableContents: authorableContents,
      updateAuthorableContents: updateAuthorableContents
    }
  }, children);
};
/**
 *
 * @param newContents - IMPORTANT: this parameter is watched by useEffect internally. Do not spread it (create new array each time), it can cause infinit render loop!
 * @param defaultContents
 * @returns
 */


var useAuthorableContentsUpdate = function useAuthorableContentsUpdate(newContents) {
  var _useContext = useContext(AuthorableContentsContext),
      updateAuthorableContents = _useContext.updateAuthorableContents;

  var updateAuthorableContentsFromResponse = function updateAuthorableContentsFromResponse(contentJourneyDetails) {
    var contentsFromParams = contentJourneyDetails.reduce(function (contents, content) {
      return Object.assign(Object.assign({}, contents), _defineProperty({}, content.key, {
        value: content.value,
        url: content.url
      }));
    }, {});
    updateAuthorableContents(contentsFromParams);
  };

  useEffect(function () {
    updateAuthorableContentsFromResponse([].concat(newContents).flat());
  }, _toConsumableArray(newContents));
};

var _getText = function getText(text, interpolationInfo) {
  var result = text;

  if (interpolationInfo) {
    Object.keys(interpolationInfo).forEach(function (key) {
      var value = interpolationInfo[key]; // eslint-disable-next-line no-useless-escape

      var regex = new RegExp("{".concat(key, "}"), 'gi');
      result = result.replace(regex, value);
    });
  }

  return result;
};

var useAuthorableContents = function useAuthorableContents() {
  var _useContext2 = useContext(AuthorableContentsContext),
      authorableContents = _useContext2.authorableContents;

  return {
    getText: function getText(key, interpolationInfo) {
      var _a;

      return _getText(((_a = authorableContents === null || authorableContents === void 0 ? void 0 : authorableContents[key]) === null || _a === void 0 ? void 0 : _a.value) || '', interpolationInfo);
    },
    getAllContents: function getAllContents() {
      return authorableContents;
    },
    getLink: function getLink(key) {
      var _a;

      return ((_a = authorableContents === null || authorableContents === void 0 ? void 0 : authorableContents[key]) === null || _a === void 0 ? void 0 : _a.url) || '';
    }
  };
};

// https://github.com/hCaptcha/react-hcaptcha#props
var generateZeroRatingProps = function generateZeroRatingProps(url, isZeroRatingEnabled) {
  if (!isZeroRatingEnabled) {
    return {};
  }

  var parts = url.split('.'); // Extract the subdomain (stXX or intXX)

  var subdomain = parts[0].split('-')[1];

  if (!subdomain) {
    return {
      host: "hcaptcha.spark.co.nz",
      apihost: "https://hcaptcha.spark.co.nz",
      assethost: "https://assets.hcaptcha.spark.co.nz",
      imghost: "https://images.hcaptcha.spark.co.nz",
      reportapi: "https://accounts.hcaptcha.spark.co.nz",
      endpoint: "https://api.hcaptcha.spark.co.nz"
    };
  }

  return {
    host: "".concat(subdomain, ".hcaptcha.spark.co.nz"),
    apihost: "https://".concat(subdomain, ".hcaptcha.spark.co.nz"),
    assethost: "https://assets-".concat(subdomain, ".hcaptcha.spark.co.nz"),
    imghost: "https://images-".concat(subdomain, ".hcaptcha.spark.co.nz"),
    reportapi: "https://accounts-".concat(subdomain, ".hcaptcha.spark.co.nz"),
    endpoint: "https://api-".concat(subdomain, ".hcaptcha.spark.co.nz")
  };
};

var CaptchaContext = /*#__PURE__*/React.createContext({
  getToken: function getToken() {
    return null;
  }
});

var CaptchaProvider = function CaptchaProvider(_ref) {
  var children = _ref.children,
      hCaptchaKey = _ref.hCaptchaKey,
      _ref$isZeroRatingEnab = _ref.isZeroRatingEnabled,
      isZeroRatingEnabled = _ref$isZeroRatingEnab === void 0 ? true : _ref$isZeroRatingEnab;
  var captchaRef = useRef(null);
  var isReady = useRef(false);
  var zeroRatingProps = generateZeroRatingProps(window.location.href, isZeroRatingEnabled);

  var getToken = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var _a, _b, data;

      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!isReady.current) {
                _context.next = 9;
                break;
              }

              _context.prev = 1;
              _context.next = 4;
              return (_a = captchaRef.current) === null || _a === void 0 ? void 0 : _a.execute({
                async: true
              });

            case 4:
              data = _context.sent;
              return _context.abrupt("return", data === null || data === void 0 ? void 0 : data.response);

            case 6:
              _context.prev = 6;
              (_b = captchaRef.current) === null || _b === void 0 ? void 0 : _b.resetCaptcha();
              return _context.finish(6);

            case 9:
              return _context.abrupt("return", null);

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1,, 6, 9]]);
    }));

    return function getToken() {
      return _ref2.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/React.createElement(CaptchaContext.Provider, {
    value: {
      getToken: getToken
    }
  }, children, /*#__PURE__*/React.createElement(HCaptcha, Object.assign({
    id: "global-captcha",
    size: "invisible",
    sitekey: hCaptchaKey,
    ref: captchaRef,
    onLoad: function onLoad() {
      isReady.current = true;
    },
    sentry: false
  }, zeroRatingProps)));
};
var useCaptcha = function useCaptcha() {
  var context = useContext(CaptchaContext);

  if (!context) {
    throw new Error('useCaptcha should be used inside CaptchaProvider');
  }

  return context;
};

var isRuntimeConfigAvailable = function isRuntimeConfigAvailable() {
  return process.env.NODE_ENV === 'production';
};

var initialConfig = isRuntimeConfigAvailable() ? undefined : {
  baseURL: 'http://localhost:8080',
  cdpURL: 'https://tags.tiqcdn.com/utag/sparknz/main/dev/utag.sync.js',
  deslURL: 'http://localhost:8080',
  graphqlURL: 'http://localhost:3001/graphql',
  _buildID: 'dev-build',
  cartCookieName: 'mock-cart-cookie',
  clickScriptURL: 'https://clickcustompay.uat.paymark.nz/paymarkPlugin.js',
  clickScriptIntegrity: undefined,
  // TODO add integrity hash
  iovationScriptURL: 'https://ci-first.iovation.com/5.0.0/static_wdp.js?loaderVer=5.1.0&compat=false&tp=true&tp_split=false&fp_static=true&fp_dyn=true&flash=false',
  signInURL: 'http://localhost:3000',
  trackingURL: 'https://assets.adobedtm.com/3ab3370ddaf0/3160affbc39f/launch-c57fc65d7cd6-development.min.js',
  isDevelopmentEnvironment: 'true',
  isWebView: 'false',
  hCaptchaKey: '20000000-ffff-ffff-ffff-000000000002'
};

function fetchConfig(_x) {
  return _fetchConfig.apply(this, arguments);
}

function _fetchConfig() {
  _fetchConfig = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(signal) {
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", isRuntimeConfigAvailable() ? fetch("".concat(process.env.NEXT_PUBLIC_BASE_PATH || '', "/config.json"), {
              signal: signal
            }).then(function (response) {
              return response.json();
            }) : Promise.resolve(initialConfig));

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _fetchConfig.apply(this, arguments);
}

var EnvironmentConfigContext = /*#__PURE__*/React.createContext(null);

function PropsBasedConfigProvider(_ref) {
  var children = _ref.children,
      envConfig = _ref.envConfig;

  var _useState = useState(envConfig),
      _useState2 = _slicedToArray(_useState, 1),
      config = _useState2[0];

  if (!config) return null;
  return /*#__PURE__*/React.createElement(EnvironmentConfigContext.Provider, {
    value: config
  }, children);
}

function RuntimeConfigProvider(_ref2) {
  var children = _ref2.children;

  var _useState3 = useState(initialConfig),
      _useState4 = _slicedToArray(_useState3, 2),
      config = _useState4[0],
      setConfig = _useState4[1];

  var isConfigAvailable = isRuntimeConfigAvailable();
  React.useEffect(function () {
    var controller = new AbortController();

    if (isConfigAvailable) {
      fetchConfig(controller.signal).then(function (response) {
        setConfig(response);
      });
    }

    return function () {
      controller.abort();
    };
  }, [isConfigAvailable]);
  return config ? /*#__PURE__*/React.createElement(EnvironmentConfigContext.Provider, {
    value: config
  }, children) : null;
}

function EnvironmentConfigProvider(_ref3) {
  var children = _ref3.children,
      envConfig = _ref3.envConfig;

  if (envConfig) {
    return /*#__PURE__*/React.createElement(PropsBasedConfigProvider, {
      envConfig: envConfig
    }, children);
  }

  return /*#__PURE__*/React.createElement(RuntimeConfigProvider, null, children);
}
function useEnvironmentConfig() {
  var context = useContext(EnvironmentConfigContext);

  if (!context) {
    throw new Error('useEnvironmentConfig must be used inside EnvironmentConfigProvider');
  }

  return context;
}

var _GlobalUserProviderAuthenticatedInfoQuery;
var GlobalUserContext = /*#__PURE__*/createContext(null);
var authenticatedInfoQuery = _GlobalUserProviderAuthenticatedInfoQuery !== void 0 ? _GlobalUserProviderAuthenticatedInfoQuery : (_GlobalUserProviderAuthenticatedInfoQuery = require("./__generated__/GlobalUserProviderAuthenticatedInfoQuery.graphql"), _GlobalUserProviderAuthenticatedInfoQuery.hash && _GlobalUserProviderAuthenticatedInfoQuery.hash !== "1c0f1a8d2f94626836ecdbbca5506575" && console.error("The definition of 'GlobalUserProviderAuthenticatedInfoQuery' appears to have changed. Run `relay-compiler` to update the generated files to receive the expected data."), _GlobalUserProviderAuthenticatedInfoQuery);
var defaultAuthenticatedUser = {
  isLoggedIn: false,
  isGuest: false,
  hasSparkId: false,
  profile: null
};
function GlobalUserProvider(_ref) {
  var children = _ref.children;
  var relayEnvironment = useRelayEnvironment$1();

  var _useFetchQuery = useFetchQuery(authenticatedInfoQuery, relayEnvironment),
      fetchUser = _useFetchQuery.fetch;

  var loadUser = function loadUser() {
    return fetchUser({}).then(function (response) {
      return response.authenticatedInfo;
    })["catch"](function (exception) {
      // Do nothing here
      Sentry.captureException(exception);
      return Promise.reject(exception);
    });
  };

  useEffect(function () {
    loadUser();
  }, []);
  var contextValue = {
    refetchUser: loadUser
  };
  return /*#__PURE__*/React.createElement(GlobalUserContext.Provider, {
    value: contextValue
  }, children);
}
function useGlobalUser() {
  var context = useContext(GlobalUserContext);
  var response = useLazyLoadQuery(authenticatedInfoQuery, {}, {
    fetchPolicy: 'store-only'
  });

  if (!context) {
    throw new Error('useGlobalUser should be used inside GlobalUserProvider');
  }

  var authenticatedInfo = (response === null || response === void 0 ? void 0 : response.authenticatedInfo) || defaultAuthenticatedUser;
  var user = Object.assign(Object.assign({}, authenticatedInfo), {
    isAuthenticatedSparkUser: authenticatedInfo.isLoggedIn && authenticatedInfo.hasSparkId
  });
  return Object.assign(Object.assign({}, context), {
    isLoading: !Boolean(response === null || response === void 0 ? void 0 : response.authenticatedInfo),
    authenticatedInfo: user,
    user: user
  });
}

var LoginModalContext = /*#__PURE__*/createContext(null);
function LoginModalProvider(_ref) {
  var children = _ref.children,
      useForgerock = _ref.useForgerock,
      forgerockConfig = _ref.forgerockConfig;

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  var handleClose = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(state === null || state === void 0 ? void 0 : state.onClose)) {
                _context.next = 3;
                break;
              }

              _context.next = 3;
              return state.onClose();

            case 3:
              setState(null);

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleClose() {
      return _ref2.apply(this, arguments);
    };
  }();

  var handleLoginSuccess = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!(state === null || state === void 0 ? void 0 : state.onLoginSuccess)) {
                _context2.next = 3;
                break;
              }

              _context2.next = 3;
              return state.onLoginSuccess();

            case 3:
              setState(null);

            case 4:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleLoginSuccess() {
      return _ref3.apply(this, arguments);
    };
  }();

  var openLoginModal = function openLoginModal(_ref4) {
    var onClose = _ref4.onClose,
        onLoginSuccess = _ref4.onLoginSuccess;
    setState({
      isOpen: true,
      onClose: onClose,
      onLoginSuccess: onLoginSuccess
    });
  };

  return /*#__PURE__*/React.createElement(LoginModalContext.Provider, {
    value: {
      openLoginModal: openLoginModal
    }
  }, children, useForgerock ? /*#__PURE__*/React.createElement(ForgerockLoginModal, {
    isOpen: state === null || state === void 0 ? void 0 : state.isOpen,
    onClose: handleClose,
    onLoginSuccess: handleLoginSuccess,
    config: forgerockConfig
  }) : /*#__PURE__*/React.createElement(LoginModal, {
    isOpen: state === null || state === void 0 ? void 0 : state.isOpen,
    onClose: handleClose,
    onLoginSuccess: handleLoginSuccess
  }));
}
function useLoginModal() {
  var context = useContext(LoginModalContext);

  if (!context) {
    throw new Error('useLoginModal should be used inside LoginModalProvider');
  }

  return context;
}

var NoAccountModalContext = /*#__PURE__*/createContext(null);
function NoAccountModalProvider(_ref) {
  var children = _ref.children,
      fetchAccountList = _ref.fetchAccountList,
      segment = _ref.segment;

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  var _useLogout = useLogout(),
      requestLogout = _useLogout.requestLogout;

  function handleClose() {
    if (state === null || state === void 0 ? void 0 : state.onClose) {
      state.onClose();
    }

    setState(null);
  }

  function handleContinue() {
    return _handleContinue.apply(this, arguments);
  }

  function _handleContinue() {
    _handleContinue = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (state === null || state === void 0 ? void 0 : state.onContinue) {
                state.onContinue();
              }

              setState(null);
              return _context.abrupt("return");

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return _handleContinue.apply(this, arguments);
  }

  function onLoginOpen() {
    setState(Object.assign(Object.assign({}, state), {
      isNoAccountModalOpen: false
    }));
  }

  function handleLoginSuccessWithNoSegmentAccount() {
    setState(Object.assign(Object.assign({}, state), {
      isNoAccountModalOpen: true
    }));
  }

  function handleNewAccountClick() {
    return _handleNewAccountClick.apply(this, arguments);
  }

  function _handleNewAccountClick() {
    _handleNewAccountClick = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return requestLogout();

            case 2:
              if (state === null || state === void 0 ? void 0 : state.onCheckoutWithNewAccount) {
                state.onCheckoutWithNewAccount();
              }

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
    return _handleNewAccountClick.apply(this, arguments);
  }

  function openNoAccountModal(_ref2) {
    var onCheckoutWithNewAccount = _ref2.onCheckoutWithNewAccount,
        onClose = _ref2.onClose,
        onContinue = _ref2.onContinue,
        hideCheckout = _ref2.hideCheckout;
    setState({
      isNoAccountModalOpen: true,
      onCheckoutWithNewAccount: onCheckoutWithNewAccount,
      onClose: onClose,
      onContinue: onContinue,
      hideCheckout: hideCheckout
    });
  }

  var contextValue = {
    openNoAccountModal: openNoAccountModal
  };
  return /*#__PURE__*/React.createElement(NoAccountModalContext.Provider, {
    value: contextValue
  }, children, /*#__PURE__*/React.createElement(NoAccountModal, {
    fetchAccountList: fetchAccountList,
    isOpen: Boolean(state === null || state === void 0 ? void 0 : state.isNoAccountModalOpen),
    onClose: handleClose,
    onContinue: handleContinue,
    onLoginOpen: onLoginOpen,
    onLoginSuccessWithNoSegmentAccount: handleLoginSuccessWithNoSegmentAccount,
    onNewAccountClick: handleNewAccountClick,
    segment: segment,
    hideCheckout: Boolean(state === null || state === void 0 ? void 0 : state.hideCheckout)
  }));
}
function useNoAccountModal() {
  var context = useContext(NoAccountModalContext);

  if (!context) {
    throw new Error('useNoAccountModal should be used inside NoAccountModalProvider');
  }

  return context;
}

var _templateObject$u;
var LEGACY_HEADER_SEGMENTS = ['personal', 'business'];
var SegmentText = styled.span(_templateObject$u || (_templateObject$u = _taggedTemplateLiteral(["\n  text-transform: capitalize;\n"])));

var Header$1 = function Header(_ref) {
  var authenticatedPrimaryMenuOptions = _ref.authenticatedPrimaryMenuOptions,
      authenticatedSecondaryMenuOptions = _ref.authenticatedSecondaryMenuOptions,
      _ref$headerConfig = _ref.headerConfig,
      _ref$headerConfig$var = _ref$headerConfig.variant,
      variant = _ref$headerConfig$var === void 0 ? 'positive' : _ref$headerConfig$var,
      _ref$headerConfig$sit = _ref$headerConfig.siteSegment,
      siteSegment = _ref$headerConfig$sit === void 0 ? 'personal' : _ref$headerConfig$sit,
      loggedIn = _ref$headerConfig.loggedIn,
      isGuest = _ref$headerConfig.isGuest,
      profileData = _ref$headerConfig.profileData,
      cart = _ref$headerConfig.cart,
      isStickyNavigation = _ref$headerConfig.isStickyNavigation,
      onCategoryClick = _ref$headerConfig.onCategoryClick,
      headerMenuContent = _ref.headerMenuContent,
      onLogout = _ref.onLogout,
      onSegmentClick = _ref.onSegmentClick;

  var _useState = useState(siteSegment),
      _useState2 = _slicedToArray(_useState, 2),
      selectedSegment = _useState2[0],
      setSelectedSegment = _useState2[1];

  var mainNavRegionId = "Main Nav ".concat(selectedSegment);

  var handleClick = function handleClick(event, value) {
    event.preventDefault();
    setSelectedSegment(value);
    onSegmentClick(value);
  };

  var _useState3 = useState([]),
      _useState4 = _slicedToArray(_useState3, 2),
      businessCategories = _useState4[0],
      setBusinessCategories = _useState4[1];

  var _useState5 = useState([]),
      _useState6 = _slicedToArray(_useState5, 2),
      personalCategoriesDesktop = _useState6[0],
      setPersonalCategoriesDesktop = _useState6[1];

  var _useState7 = useState([]),
      _useState8 = _slicedToArray(_useState7, 2),
      businessCategoriesDesktop = _useState8[0],
      setBusinessCategoriesDesktop = _useState8[1];

  var _useState9 = useState([]),
      _useState10 = _slicedToArray(_useState9, 2),
      personalCategories = _useState10[0],
      setPersonalCategories = _useState10[1];

  var _useEnvironmentConfig = useEnvironmentConfig(),
      signInURL = _useEnvironmentConfig.signInURL;

  var _useLogout = useLogout(),
      requestLogout = _useLogout.requestLogout;

  var MENU_ITEMS_PAGES = [{
    code: 'dashboard',
    page: MYSPARK_HOME_PAGE
  }, {
    code: 'usage',
    page: MYSPARK_USAGE_PAGE
  }, {
    code: 'billing',
    page: MYSPARK_BILLING_PAGE
  }, {
    code: 'products',
    page: MYSPARK_PRODUCTS_PAGE
  }, {
    code: 'profile',
    page: MYSPARK_PROFILE_PAGE
  }, {
    code: 'signout',
    page: '',
    action: 'signout'
  }, {
    code: 'signin',
    page: signInURL
  }, {
    code: 'payabill',
    page: MYSPARK_PAY_BILL
  }, {
    code: 'sparkIdSettings',
    page: MYSPARK_SPARK_ID_SETTINGS
  }, {
    code: 'topup',
    page: SHOP_TOP_UP
  }];

  var onProfileMenuClick = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(linkCode) {
      var menuItem;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              menuItem = MENU_ITEMS_PAGES.find(function (item) {
                return item.code === linkCode;
              });

              if (menuItem === null || menuItem === void 0 ? void 0 : menuItem.page) {
                window.location.assign(menuItem.page);
              }

              if (!((menuItem === null || menuItem === void 0 ? void 0 : menuItem.action) && (menuItem === null || menuItem === void 0 ? void 0 : menuItem.action) === 'signout')) {
                _context.next = 6;
                break;
              }

              _context.next = 5;
              return requestLogout();

            case 5:
              if (onLogout) {
                onLogout();
              }

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function onProfileMenuClick(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var UNAUTHENTICATED_MENU_OPTIONS = siteSegment === 'business' ? [{
    name: 'Pay a bill',
    code: 'payabill'
  }] : [{
    name: 'Top up',
    code: 'topup'
  }, {
    name: 'Pay a bill',
    code: 'payabill'
  }];
  useEffect(function () {
    setPersonalCategories(headerMenuContent.personalCategories.map(function (item) {
      return {
        iconName: item.iconName,
        label: item.label,
        url: item.url
      };
    }));
    setBusinessCategories(headerMenuContent.businessCategories.map(function (item) {
      return {
        iconName: item.iconName,
        label: item.label,
        url: item.url
      };
    }));
    setPersonalCategoriesDesktop(headerMenuContent.personalCategoriesDesktop.map(function (item) {
      return {
        iconName: item.iconName,
        label: item.label,
        url: item.url
      };
    }));
    setBusinessCategoriesDesktop(headerMenuContent.businessCategoriesDesktop.map(function (item) {
      return {
        iconName: item.iconName,
        label: item.label,
        url: item.url
      };
    }));
  }, [headerMenuContent]);
  var showAuthenticatedProfileMenu = loggedIn && !isGuest;
  return /*#__PURE__*/React.createElement(Header$2, {
    variant: variant,
    profile: showAuthenticatedProfileMenu ? {
      firstName: profileData.firstName,
      lastName: profileData.lastName,
      profileNotifications: profileData.profileNotifications,
      src: profileData.src
    } : null,
    isStickyNavigation: isStickyNavigation,
    components: {
      SegmentSwitcher: /*#__PURE__*/React.createElement(LinkRegion, {
        regionId: "Global Nav"
      }, /*#__PURE__*/React.createElement(HeaderSegmentSwitcher, null, LEGACY_HEADER_SEGMENTS.map(function (segment) {
        return /*#__PURE__*/React.createElement(HeaderSegmentSwitcherItem, {
          key: segment,
          selected: segment === selectedSegment,
          onClick: function onClick(event) {
            return handleClick(event, segment);
          }
        }, /*#__PURE__*/React.createElement(SegmentText, null, segment));
      }))),
      BrandLogo: /*#__PURE__*/React.createElement(LinkRegion, {
        regionId: mainNavRegionId
      }, /*#__PURE__*/React.createElement(BrandLogo, {
        href: "/",
        title: "Spark"
      })),
      HeaderCategories: /*#__PURE__*/React.createElement(LinkRegion, {
        regionId: mainNavRegionId
      }, /*#__PURE__*/React.createElement(MediaQuery, {
        max: "slim"
      }, /*#__PURE__*/React.createElement(HeaderCategories, {
        selectedSegment: selectedSegment
      }, /*#__PURE__*/React.createElement(PersonalCategoriesContainer, null, /*#__PURE__*/React.createElement(HeaderCategoryList, {
        categories: personalCategories,
        onCategoryClick: onCategoryClick
      })), /*#__PURE__*/React.createElement(BusinessCategoriesContainer, null, /*#__PURE__*/React.createElement(HeaderCategoryList, {
        categories: businessCategories,
        onCategoryClick: onCategoryClick
      })))), /*#__PURE__*/React.createElement(MediaQuery, {
        min: "big"
      }, /*#__PURE__*/React.createElement(HeaderCategories, {
        selectedSegment: selectedSegment
      }, /*#__PURE__*/React.createElement(HeaderCategoriesContainer, null, /*#__PURE__*/React.createElement(HeaderCategoryList, {
        categories: selectedSegment === 'personal' ? personalCategoriesDesktop : businessCategoriesDesktop,
        onCategoryClick: onCategoryClick
      }))))),
      CartButton: /*#__PURE__*/React.createElement(React.Fragment, null, cart ? /*#__PURE__*/React.createElement(CartButton, {
        items: cart.items,
        onClick: cart.onClick
      }) : null),
      ProfilePill: /*#__PURE__*/React.createElement(LinkRegion, {
        isNotTracked: true
      }, /*#__PURE__*/React.createElement(ProfilePill, null, /*#__PURE__*/React.createElement(LinkRegion, {
        regionId: "MySpark Menu"
      }, showAuthenticatedProfileMenu ? /*#__PURE__*/React.createElement(AuthenticatedProfileMenu, {
        onClick: function onClick(linkCode) {
          return onProfileMenuClick(linkCode);
        },
        authenticatedPrimaryMenuOptions: authenticatedPrimaryMenuOptions,
        authenticatedSecondaryMenuOptions: authenticatedSecondaryMenuOptions
      }) : /*#__PURE__*/React.createElement(UnauthenticatedProfileMenu, {
        onClick: function onClick(linkCode) {
          return onProfileMenuClick(linkCode);
        },
        unauthenticatedMenuOptions: UNAUTHENTICATED_MENU_OPTIONS
      }))))
    }
  });
};

var _templateObject$t;
var CapitalisedText = styled.span(_templateObject$t || (_templateObject$t = _taggedTemplateLiteral(["\n  text-transform: capitalize;\n"])));

var HeaderLoader = function HeaderLoader(_ref) {
  var _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'positive' : _ref$variant,
      _ref$isStickyNavigati = _ref.isStickyNavigation,
      isStickyNavigation = _ref$isStickyNavigati === void 0 ? true : _ref$isStickyNavigati;
  return /*#__PURE__*/React.createElement(Header$2, {
    variant: variant,
    profile: null,
    isStickyNavigation: isStickyNavigation,
    components: {
      SegmentSwitcher: /*#__PURE__*/React.createElement(HeaderSegmentSwitcher, null, LEGACY_HEADER_SEGMENTS.map(function (segment) {
        return /*#__PURE__*/React.createElement(HeaderSegmentSwitcherItem, {
          key: segment,
          onClick: function onClick() {}
        }, /*#__PURE__*/React.createElement(CapitalisedText, null, segment));
      })),
      BrandLogo: /*#__PURE__*/React.createElement(BrandLogo, {
        title: "Spark"
      }),
      HeaderCategories: null,
      SearchButton: null,
      CartButton: null,
      ProfilePill: null
    }
  });
};

var DEFAULT_FALLBACK_IMAGE_PATH$1 = '/online/shop/static/assets/fallback/no-image.svg';

var ImageWithFallback$1 = function ImageWithFallback(_a) {
  var src = _a.src,
      alt = _a.alt,
      _a$fallbackSrc = _a.fallbackSrc,
      fallbackSrc = _a$fallbackSrc === void 0 ? DEFAULT_FALLBACK_IMAGE_PATH$1 : _a$fallbackSrc,
      rest = __rest(_a, ["src", "alt", "fallbackSrc"]);

  var _useState = useState(src),
      _useState2 = _slicedToArray(_useState, 2),
      imgSrc = _useState2[0],
      setImgSrc = _useState2[1];

  return /*#__PURE__*/React.createElement("img", Object.assign({}, rest, {
    alt: alt,
    src: imgSrc,
    onError: function onError() {
      return setImgSrc(fallbackSrc);
    }
  }));
};

var _useMiniCartActionDeleteBundleMutation, _useMiniCartActionDeleteItemMutation;
var deleteBundleMutation = _useMiniCartActionDeleteBundleMutation !== void 0 ? _useMiniCartActionDeleteBundleMutation : (_useMiniCartActionDeleteBundleMutation = require("./__generated__/useMiniCartActionDeleteBundleMutation.graphql"), _useMiniCartActionDeleteBundleMutation.hash && _useMiniCartActionDeleteBundleMutation.hash !== "ce13bb2c3dc3a44c451fdc0c8ece7038" && console.error("The definition of 'useMiniCartActionDeleteBundleMutation' appears to have changed. Run `relay-compiler` to update the generated files to receive the expected data."), _useMiniCartActionDeleteBundleMutation);
var deleteItemMutation = _useMiniCartActionDeleteItemMutation !== void 0 ? _useMiniCartActionDeleteItemMutation : (_useMiniCartActionDeleteItemMutation = require("./__generated__/useMiniCartActionDeleteItemMutation.graphql"), _useMiniCartActionDeleteItemMutation.hash && _useMiniCartActionDeleteItemMutation.hash !== "d647416588a7e26c7ed460daf35cd0b3" && console.error("The definition of 'useMiniCartActionDeleteItemMutation' appears to have changed. Run `relay-compiler` to update the generated files to receive the expected data."), _useMiniCartActionDeleteItemMutation);
function useMiniCartAction() {
  var _useMutation = useMutation$1(deleteBundleMutation),
      _useMutation2 = _slicedToArray(_useMutation, 2),
      commitDeleteBundle = _useMutation2[0],
      isDeletingBundle = _useMutation2[1];

  var _useMutation3 = useMutation$1(deleteItemMutation),
      _useMutation4 = _slicedToArray(_useMutation3, 2),
      commitDeleteItem = _useMutation4[0],
      isDeletingItem = _useMutation4[1];

  var _useSnackbar = useSnackbar(),
      showSnackbar = _useSnackbar.showSnackbar;

  var deleteItem = function deleteItem(_ref) {
    var bundleId = _ref.bundleId,
        cartId = _ref.cartId,
        channel = _ref.channel,
        itemId = _ref.itemId;
    commitDeleteItem({
      variables: {
        input: {
          cartId: cartId,
          channel: channel,
          bundleId: bundleId,
          itemId: itemId
        },
        channel: channel
      },
      onError: function onError() {
        showSnackbar({
          text: 'Error while removing item from the cart'
        });
      }
    });
  };

  var deleteBundle = function deleteBundle(_ref2) {
    var bundleId = _ref2.bundleId,
        cartId = _ref2.cartId,
        channel = _ref2.channel;
    commitDeleteBundle({
      variables: {
        input: {
          cartId: cartId,
          channel: channel,
          bundleId: bundleId
        },
        channel: channel
      },
      onError: function onError() {
        showSnackbar({
          text: 'Error while removing bundle item from the cart'
        });
      }
    });
  };

  return {
    deleteBundle: deleteBundle,
    deleteItem: deleteItem,
    isDeletingBundle: isDeletingBundle,
    isDeletingItem: isDeletingItem
  };
}

var _templateObject$s, _templateObject2$j, _templateObject3$a, _templateObject4$9, _templateObject5$4, _templateObject6$4, _templateObject7$4, _templateObject8$4, _templateObject9$4, _templateObject10$4, _templateObject11$4, _templateObject12$4;
var ProductRow = styled.div(_templateObject$s || (_templateObject$s = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref) {
  var spacing = _ref.theme.spacing;
  return css(_templateObject2$j || (_templateObject2$j = _taggedTemplateLiteral(["\n    display: flex;\n    width: 100%;\n    margin-bottom: ", ";\n  "])), spacing.s3);
});
var ImageContainer = styled.div(_templateObject3$a || (_templateObject3$a = _taggedTemplateLiteral(["\n  display: flex;\n  flex-shrink: 0;\n  justify-content: center;\n  align-items: center;\n  height: 48px;\n  width: 48px;\n"])));
var StyledImageWithFallback$2 = styled(ImageWithFallback$1)(_templateObject4$9 || (_templateObject4$9 = _taggedTemplateLiteral(["\n  max-width: 48px;\n  max-height: 48px;\n"])));
var ProductTextWrapper = styled.div(_templateObject5$4 || (_templateObject5$4 = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref2) {
  var _ref2$theme = _ref2.theme,
      spacing = _ref2$theme.spacing,
      media = _ref2$theme.media;
  return css(_templateObject6$4 || (_templateObject6$4 = _taggedTemplateLiteral(["\n    display: block;\n    ", " {\n      padding-left: ", ";\n    }\n  "])), media.up('slim'), spacing.s3);
});
var ProductText = styled(Text)(_templateObject7$4 || (_templateObject7$4 = _taggedTemplateLiteral(["\n  white-space: pre-wrap;\n  display: inline;\n"])));
var ProductQuantityText = styled(ProductText)(_templateObject8$4 || (_templateObject8$4 = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref3) {
  var palette = _ref3.theme.palette;
  return css(_templateObject9$4 || (_templateObject9$4 = _taggedTemplateLiteral(["\n    white-space: nowrap;\n    color: ", ";\n  "])), palette.baseColors.mawheranui);
});
var FrequencyText = styled(Text)(_templateObject10$4 || (_templateObject10$4 = _taggedTemplateLiteral(["\n  text-align: right;\n"])));
var PriceWrapper = styled.div(_templateObject11$4 || (_templateObject11$4 = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref4) {
  var spacing = _ref4.theme.spacing;
  return css(_templateObject12$4 || (_templateObject12$4 = _taggedTemplateLiteral(["\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end;\n    margin-left: auto;\n    margin-bottom: auto;\n    padding-left: ", ";\n    min-width: 75px;\n  "])), spacing.s2);
});

var MinicartItem = function MinicartItem(_ref5) {
  var bundleId = _ref5.bundleId,
      cartId = _ref5.cartId,
      channel = _ref5.channel,
      cartCookieName = _ref5.cartCookieName,
      item = _ref5.item,
      productOfferImages = _ref5.productOfferImages,
      isFirstItemInBundle = _ref5.isFirstItemInBundle,
      shouldDisplayRemoveButton = _ref5.shouldDisplayRemoveButton;

  var _useSegment = useSegment(),
      isBusiness = _useSegment.isBusiness;

  var isInMobile = useMediaQuery({
    max: 'lil'
  });

  var _useMiniCartAction = useMiniCartAction(),
      deleteBundle = _useMiniCartAction.deleteBundle,
      deleteItem = _useMiniCartAction.deleteItem,
      isDeletingBundle = _useMiniCartAction.isDeletingBundle,
      isDeletingItem = _useMiniCartAction.isDeletingItem;

  var price = item.prices[0];
  var costText = getCartItemPrice({
    price: price,
    isBusiness: isBusiness,
    isIncluded: item.isIncluded
  });
  var isIncluded = costText === null || costText === void 0 ? void 0 : costText.includes(INCLUDED_TEXT);
  var isCartItemRemovable = shouldDisplayRemoveButton && item.removable;

  var handleRemove = function handleRemove() {
    if (isFirstItemInBundle) {
      deleteBundle({
        bundleId: bundleId,
        cartId: cartId,
        channel: channel
      });
      decodeCartCookie(cartCookieName);
      return;
    }

    deleteItem({
      bundleId: bundleId,
      cartId: cartId,
      channel: channel,
      itemId: item.itemId
    });
    decodeCartCookie(cartCookieName);
  };

  return /*#__PURE__*/React.createElement(ProductRow, {
    "data-testid": item.productOfferingId,
    key: item.itemId
  }, !isInMobile ? /*#__PURE__*/React.createElement(ImageContainer, null, /*#__PURE__*/React.createElement(StyledImageWithFallback$2, {
    src: getCartImageUrl(item.offerId, productOfferImages),
    alt: item.title
  })) : null, /*#__PURE__*/React.createElement(ProductTextWrapper, null, /*#__PURE__*/React.createElement(ProductText, {
    variant: "bodySDemi"
  }, "".concat(item.title, " ")), /*#__PURE__*/React.createElement(ProductQuantityText, {
    variant: "footnoteMedium"
  }, "x\xA0"), /*#__PURE__*/React.createElement(ProductQuantityText, {
    variant: "bodySMedium"
  }, item.quantity), isCartItemRemovable ? /*#__PURE__*/React.createElement(Box, {
    justifyContent: "left"
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "textbutton",
    onClick: handleRemove,
    isLoading: isDeletingBundle || isDeletingItem
  }, "Remove")) : null), /*#__PURE__*/React.createElement(PriceWrapper, null, /*#__PURE__*/React.createElement(Text, {
    variant: "bodySMedium"
  }, costText), !isIncluded ? /*#__PURE__*/React.createElement(FrequencyText, {
    variant: "bodySMedium"
  }, getBillingFrequencyLabel(price.billingFrequency)) : null));
};

var _templateObject$r, _templateObject2$i, _templateObject3$9, _templateObject4$8, _templateObject5$3, _templateObject6$3, _templateObject7$3, _templateObject8$3, _templateObject9$3, _templateObject10$3, _templateObject11$3, _templateObject12$3, _templateObject13$3, _templateObject14$3, _templateObject15$2, _templateObject16$1, _templateObject17;
var MinicartModalContainer = styled(DialogOverlay)(_templateObject$r || (_templateObject$r = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref) {
  var _ref$theme = _ref.theme,
      palette = _ref$theme.palette,
      spacing = _ref$theme.spacing,
      borderRadius = _ref$theme.borderRadius,
      media = _ref$theme.media,
      zIndex = _ref$theme.zIndex,
      $positionRight = _ref.$positionRight,
      $positionTopBig = _ref.$positionTopBig;
  return css(_templateObject2$i || (_templateObject2$i = _taggedTemplateLiteral(["\n    display: flex;\n    width: calc(100% - 2 * ", ");\n    top: 70px;\n    position: fixed;\n    flex-direction: column;\n    margin: 0 ", ";\n    background-color: ", ";\n    border-radius: ", ";\n    z-index: ", ";\n    box-shadow:\n      0 -40px 80px rgba(0, 0, 0, 0.02),\n      0 -30px 24px rgba(0, 0, 0, 0.01),\n      0 -12px 10px rgba(0, 0, 0, 0.02),\n      0 -4px 4px rgba(0, 0, 0, 0.02),\n      0 7px 8px 0 rgba(0, 0, 0, 0.1),\n      0 12px 17px 0 rgba(0, 0, 0, 0.1);\n\n    ", " {\n      width: 396px;\n      top: 70px;\n      right: ", "px;\n    }\n\n    ", " {\n      top: ", "px;\n    }\n  "])), spacing.s0_5, spacing.s0_5, palette.baseColors.wairua, borderRadius.r2, zIndex.modal, media.up('slim'), $positionRight || 110, media.up('big'), $positionTopBig || 60);
});
var CartTitleRow = styled.div(_templateObject3$9 || (_templateObject3$9 = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref2) {
  var spacing = _ref2.theme.spacing;
  return css(_templateObject4$8 || (_templateObject4$8 = _taggedTemplateLiteral(["\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n    padding: ", " ", " 0;\n    margin-bottom: ", ";\n  "])), spacing.s4, spacing.s4, spacing.s1);
});
var ProductsContainer = styled.div(_templateObject5$3 || (_templateObject5$3 = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref3) {
  var _ref3$theme = _ref3.theme,
      spacing = _ref3$theme.spacing,
      media = _ref3$theme.media;
  return css(_templateObject6$3 || (_templateObject6$3 = _taggedTemplateLiteral(["\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    padding: ", " ", " 0;\n    max-height: 200px;\n    overflow: auto;\n\n    ", " {\n      max-height: 360px;\n    }\n  "])), spacing.s1, spacing.s4, media.up('slim'));
});
var TotalPriceContainer = styled.div(_templateObject7$3 || (_templateObject7$3 = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref4) {
  var _ref4$theme = _ref4.theme,
      palette = _ref4$theme.palette,
      spacing = _ref4$theme.spacing;
  return css(_templateObject8$3 || (_templateObject8$3 = _taggedTemplateLiteral(["\n    padding: ", ";\n    border-bottom-left-radius: inherit;\n    border-bottom-right-radius: inherit;\n    width: 100%;\n    background-color: ", ";\n  "])), spacing.s4, palette.baseColors.onepu);
});
var CloseMinicartOverlay = styled.div(_templateObject9$3 || (_templateObject9$3 = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref5) {
  var zIndex = _ref5.theme.zIndex,
      isOpen = _ref5.isOpen;
  return css(_templateObject10$3 || (_templateObject10$3 = _taggedTemplateLiteral(["\n    position: fixed;\n    height: 100vh;\n    width: 100vw;\n    display: ", ";\n    z-index: ", ";\n  "])), isOpen ? 'block' : 'none', zIndex.modal);
});
var BundleDivider = styled.div(_templateObject11$3 || (_templateObject11$3 = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref6) {
  var _ref6$theme = _ref6.theme,
      palette = _ref6$theme.palette,
      spacing = _ref6$theme.spacing;
  return css(_templateObject12$3 || (_templateObject12$3 = _taggedTemplateLiteral(["\n    border-bottom: solid 1px ", ";\n    margin-bottom: ", ";\n\n    &:last-child {\n      border-bottom: none;\n      margin-bottom: 0;\n    }\n  "])), palette.baseColors.moeraki, spacing.s3);
});
var GstExclText$1 = styled(Text)(_templateObject13$3 || (_templateObject13$3 = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref7) {
  var _ref7$theme = _ref7.theme,
      spacing = _ref7$theme.spacing,
      palette = _ref7$theme.palette;
  return css(_templateObject14$3 || (_templateObject14$3 = _taggedTemplateLiteral(["\n    padding: ", " ", ";\n    color: ", ";\n  "])), spacing.s2, spacing.s4, palette.baseColors.mawheranui);
});
var TotalPriceRow = styled.div(_templateObject15$2 || (_templateObject15$2 = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref8) {
  var spacing = _ref8.theme.spacing;
  return css(_templateObject16$1 || (_templateObject16$1 = _taggedTemplateLiteral(["\n    display: flex;\n    width: 100%;\n\n    & > :first-child {\n      margin-right: auto;\n    }\n\n    & > :nth-child(2) {\n      margin-right: ", ";\n    }\n\n    margin-bottom: ", ";\n  "])), spacing.s3, spacing.s3);
});
var PricingTextWrapper = styled.div(_templateObject17 || (_templateObject17 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n"])));

function MinicartLoader() {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ProductsContainer, null, /*#__PURE__*/React.createElement(SparkContentLoader, {
    style: {
      height: '150',
      width: '100%'
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: "0",
    y: "10",
    rx: "6",
    ry: "6",
    width: "50",
    height: "50"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "70",
    y: "10",
    rx: "6",
    ry: "6",
    width: "100%",
    height: "20"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "70",
    y: "40",
    rx: "6",
    ry: "6",
    width: "100%",
    height: "20"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "0",
    y: "80",
    rx: "6",
    ry: "6",
    width: "50",
    height: "50"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "70",
    y: "80",
    rx: "6",
    ry: "6",
    width: "100%",
    height: "20"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "70",
    y: "110",
    rx: "6",
    ry: "6",
    width: "100%",
    height: "20"
  }))), /*#__PURE__*/React.createElement(TotalPriceContainer, null));
}

var _MinicartQuery;
function getMinicartTotalPrice(cartSummary, isBusiness) {
  if (!(cartSummary === null || cartSummary === void 0 ? void 0 : cartSummary.total)) {
    return null;
  }

  if (isBusiness) {
    return "".concat(formatNZD(cartSummary.taxExclusiveTotal, 2), "*");
  }

  return formatNZD(cartSummary.total, 2);
}
var minicartQuery = _MinicartQuery !== void 0 ? _MinicartQuery : (_MinicartQuery = require("./__generated__/MinicartQuery.graphql"), _MinicartQuery.hash && _MinicartQuery.hash !== "c3da5c4bacafeb9099d8ac63eed6e1de" && console.error("The definition of 'MinicartQuery' appears to have changed. Run `relay-compiler` to update the generated files to receive the expected data."), _MinicartQuery);

var MinicartBundle = function MinicartBundle(_ref) {
  var bundle = _ref.bundle,
      cartId = _ref.cartId,
      channel = _ref.channel,
      productOfferImages = _ref.productOfferImages,
      shouldDisplayRemoveButton = _ref.shouldDisplayRemoveButton,
      cartCookieName = _ref.cartCookieName;
  return /*#__PURE__*/React.createElement(React.Fragment, null, bundle.items.map(function (item, index) {
    if (item.shouldHide) {
      return null;
    }

    return /*#__PURE__*/React.createElement(MinicartItem, {
      key: item.itemId,
      item: item,
      productOfferImages: productOfferImages,
      isFirstItemInBundle: index === 0,
      cartId: cartId,
      channel: channel,
      bundleId: bundle.bundleId,
      shouldDisplayRemoveButton: shouldDisplayRemoveButton,
      cartCookieName: cartCookieName
    });
  }), /*#__PURE__*/React.createElement(BundleDivider, null));
};

var MinicartContent = function MinicartContent(_ref2) {
  var cartCookieName = _ref2.cartCookieName,
      _ref2$hideGoToCart = _ref2.hideGoToCart,
      hideGoToCart = _ref2$hideGoToCart === void 0 ? false : _ref2$hideGoToCart,
      handleGoToCartClick = _ref2.handleGoToCartClick,
      shouldDisplayRemoveButton = _ref2.shouldDisplayRemoveButton;

  var _a;

  var _useSegment = useSegment(),
      channel = _useSegment.channel,
      isBusiness = _useSegment.isBusiness;

  var _useCartCookie = useCartCookie({
    cartCookieName: cartCookieName
  }),
      cartId = _useCartCookie.cartId;

  var _useLazyLoadQuery = useLazyLoadQuery$1(minicartQuery, {
    cartId: cartId,
    channel: channel
  }, {
    fetchPolicy: 'network-only'
  }),
      cartView = _useLazyLoadQuery.cartView;

  var cart = useFragment(cartFragment, cartView.cart);

  if (!cart || !(cart === null || cart === void 0 ? void 0 : cart.bundles.length)) {
    return /*#__PURE__*/React.createElement(Box, {
      px: "s4",
      py: "s3"
    }, /*#__PURE__*/React.createElement(Text, {
      variant: "bodySMedium"
    }, "You currently have no items in your cart"));
  }

  var summaries = cart.summaries,
      bundles = cart.bundles,
      productOfferImages = cart.productOfferImages;
  var oneOffSummary = summaries.find(function (summary) {
    return summary.frequencyType === 'OneOffTotal';
  });
  var oneOffTotal = oneOffSummary ? getMinicartTotalPrice(oneOffSummary, isBusiness) : 0;
  var monthlySummary = summaries.find(function (summary) {
    return summary.billingFrequency === 'MONTHLY';
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ProductsContainer, null, bundles.map(function (bundle) {
    return /*#__PURE__*/React.createElement(MinicartBundle, {
      "data-testid": bundle.bundleId,
      key: bundle.bundleId,
      bundle: bundle,
      productOfferImages: productOfferImages,
      cartId: cartId,
      channel: channel,
      shouldDisplayRemoveButton: shouldDisplayRemoveButton,
      cartCookieName: cartCookieName
    });
  })), isBusiness ? /*#__PURE__*/React.createElement(GstExclText$1, {
    variant: "bodySMedium"
  }, "*Prices exclude GST") : null, /*#__PURE__*/React.createElement(TotalPriceContainer, {
    "data-testid": 'minicart-summary'
  }, /*#__PURE__*/React.createElement(TotalPriceRow, null, /*#__PURE__*/React.createElement(Text, {
    variant: "bodyMDemi"
  }, "Total:"), oneOffTotal ? /*#__PURE__*/React.createElement(PricingTextWrapper, null, /*#__PURE__*/React.createElement(Text, {
    variant: "subheadingM"
  }, oneOffTotal), /*#__PURE__*/React.createElement(Text, {
    variant: "bodySMedium"
  }, "One-off")) : null, monthlySummary ? /*#__PURE__*/React.createElement(PricingTextWrapper, null, /*#__PURE__*/React.createElement(Text, {
    variant: "subheadingM"
  }, (_a = getMinicartTotalPrice(monthlySummary, isBusiness)) !== null && _a !== void 0 ? _a : 'n/a'), /*#__PURE__*/React.createElement(Text, {
    variant: "bodySMedium"
  }, "Monthly")) : null), !hideGoToCart ? /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    onClick: handleGoToCartClick,
    fullWidth: true
  }, "Review cart")) : null));
};

var Minicart = function Minicart(_ref3) {
  var isOpen = _ref3.isOpen,
      handleClose = _ref3.handleClose,
      positionRight = _ref3.positionRight,
      positionTopBig = _ref3.positionTopBig,
      _ref3$hideGoToCart = _ref3.hideGoToCart,
      hideGoToCart = _ref3$hideGoToCart === void 0 ? false : _ref3$hideGoToCart,
      cartCookieName = _ref3.cartCookieName,
      handleGoToCartClick = _ref3.handleGoToCartClick,
      shouldDisplayRemoveButton = _ref3.shouldDisplayRemoveButton;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CloseMinicartOverlay, {
    onClick: handleClose,
    isOpen: isOpen
  }), /*#__PURE__*/React.createElement(MinicartModalContainer, {
    isOpen: isOpen,
    dangerouslyBypassScrollLock: true,
    dangerouslyBypassFocusLock: true,
    positionRight: positionRight,
    positionTopBig: positionTopBig
  }, /*#__PURE__*/React.createElement(CartTitleRow, null, /*#__PURE__*/React.createElement(Text, {
    variant: "subheadingM"
  }, "Your cart"), /*#__PURE__*/React.createElement(IconButton$1, {
    variant: "primary",
    icon: "cross_small",
    onClick: handleClose,
    title: "close-minicart"
  })), /*#__PURE__*/React.createElement(ErrorBoundary, {
    fallback: function fallback() {
      return /*#__PURE__*/React.createElement(Box, {
        px: ['s4'],
        py: ['s3']
      }, /*#__PURE__*/React.createElement(Text, {
        variant: "bodySMedium"
      }, "The data is currently unavailable."));
    }
  }, /*#__PURE__*/React.createElement(Suspense, {
    fallback: /*#__PURE__*/React.createElement(MinicartLoader, null)
  }, /*#__PURE__*/React.createElement(MinicartContent, {
    hideGoToCart: hideGoToCart,
    cartCookieName: cartCookieName,
    handleGoToCartClick: handleGoToCartClick,
    shouldDisplayRemoveButton: shouldDisplayRemoveButton
  })))));
};

function HeaderCartButton(_ref) {
  var cartCookieName = _ref.cartCookieName,
      handleMinicartClick = _ref.handleMinicartClick,
      isMinicartOpen = _ref.isMinicartOpen,
      handleMinicartClose = _ref.handleMinicartClose,
      hideGoToCart = _ref.hideGoToCart,
      handleGoToCartClick = _ref.handleGoToCartClick,
      selectedSegment = _ref.segment,
      handleCartClick = _ref.handleCartClick,
      shouldDisplayRemoveButton = _ref.shouldDisplayRemoveButton;

  var _useCartCookie = useCartCookie({
    cartCookieName: cartCookieName
  }),
      cartItemsCount = _useCartCookie.numberOfCartItems;

  var cartProps = {
    isOpen: isMinicartOpen,
    handleClose: handleMinicartClose,
    positionTopBig: 110,
    cartCookieName: cartCookieName,
    hideGoToCart: hideGoToCart,
    handleGoToCartClick: handleGoToCartClick,
    shouldDisplayRemoveButton: shouldDisplayRemoveButton
  };
  return /*#__PURE__*/React.createElement(LinkRegion, {
    regionId: "utilityNav.".concat(selectedSegment)
  }, /*#__PURE__*/React.createElement(CartButton, {
    "data-testid": "cartButton",
    onClick: handleMinicartClick || handleCartClick,
    items: cartItemsCount
  }), /*#__PURE__*/React.createElement(Minicart, Object.assign({}, cartProps)));
}

var _templateObject$q;
var StyledImageWithFallback$1 = styled(ImageWithFallback$1)(_templateObject$q || (_templateObject$q = _taggedTemplateLiteral(["\n  max-width: 72px;\n  max-height: 72px;\n"])));
function DeliveryItem(_ref) {
  var imageUrl = _ref.imageUrl,
      quantity = _ref.quantity,
      title = _ref.title;
  return /*#__PURE__*/React.createElement(Box, {
    py: "s3",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "flex-start"
  }, /*#__PURE__*/React.createElement(Box, {
    mr: "s3"
  }, /*#__PURE__*/React.createElement(StyledImageWithFallback$1, {
    src: imageUrl,
    alt: title
  })), /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Text, {
    variant: "bodyMDemi"
  }, title), /*#__PURE__*/React.createElement(Text, {
    variant: "bodySMedium"
  }, "Quantity: ", quantity)));
}

var _DeliveryItemsFieldQuery, _DeliveryItemsFieldFragment;
var deliveryItemsFieldQuery = _DeliveryItemsFieldQuery !== void 0 ? _DeliveryItemsFieldQuery : (_DeliveryItemsFieldQuery = require("./__generated__/DeliveryItemsFieldQuery.graphql"), _DeliveryItemsFieldQuery.hash && _DeliveryItemsFieldQuery.hash !== "c4ddc11942b6d726d819a58d4514aa05" && console.error("The definition of 'DeliveryItemsFieldQuery' appears to have changed. Run `relay-compiler` to update the generated files to receive the expected data."), _DeliveryItemsFieldQuery);
var deliveryItemsFragment = _DeliveryItemsFieldFragment !== void 0 ? _DeliveryItemsFieldFragment : (_DeliveryItemsFieldFragment = require("./__generated__/DeliveryItemsFieldFragment.graphql"), _DeliveryItemsFieldFragment.hash && _DeliveryItemsFieldFragment.hash !== "4afa593c6988f85c53a437825686cd1c" && console.error("The definition of 'DeliveryItemsFieldFragment' appears to have changed. Run `relay-compiler` to update the generated files to receive the expected data."), _DeliveryItemsFieldFragment);

function DeliveryItemsFieldInternal(_ref) {
  var model = _ref.model,
      cartId = _ref.cartId;

  var _useSegment = useSegment(),
      channel = _useSegment.channel;

  var data = useLazyLoadQuery(deliveryItemsFieldQuery, {
    cartId: cartId,
    channel: channel
  });

  var _useFragment = useFragment$1(deliveryItemsFragment, data.cart),
      shippableItems = _useFragment.shippableItems,
      productOfferImages = _useFragment.productOfferImages;

  var hasShippableItems = Boolean(cartId && shippableItems.length);

  if (!hasShippableItems) {
    return null;
  }

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, {
    variant: "subheadingM"
  }, model.label), shippableItems.map(function (item) {
    var newItem = Object.assign(Object.assign({}, item), {
      imageUrl: getCartImageUrl(item.offerId, productOfferImages)
    });
    return /*#__PURE__*/React.createElement(DeliveryItem, Object.assign({
      key: item.itemId
    }, newItem));
  }));
}

function DeliveryItemsField(props) {
  return /*#__PURE__*/React.createElement(Suspense, {
    fallback: null
  }, /*#__PURE__*/React.createElement(DeliveryItemsFieldInternal, Object.assign({}, props)));
}

var STANDARD_DELIVERY_OPTION = 'Standard delivery - Free';
var EXTENDED_DELIVERY_OPTION = 'Extended delivery - Free';
var CLICK_AND_COLLECT_DELIVERY_OPTION = 'Click & Collect - Free';
var PREORDER_DELIVERY_OPTION = 'Pre-order delivery - Free';

var ESIM_OFFER_ID = 'esim';
var CONTENT_KEYS = {
  STANDARD_DELIVERY: 'checkout.delivery.standardDelivery.description',
  STANDARD_DELIVERY_WITH_ESIM: 'checkout.delivery.standardDeliveryWithEsim.description',
  EXTENDED_DELIVERY: 'checkout.delivery.extendedDelivery.description',
  EXTENDED_DELIVERY_WITH_ESIM: 'checkout.delivery.extendedDeliveryWithEsim.description',
  CLICK_AND_COLLECT: 'checkout.delivery.clickAndCollect.description',
  PREORDER_DELIVERY: 'checkout.delivery.preOrderDelivery.description',
  PREORDER_DELIVERY_WITH_ESIM: 'checkout.delivery.preOrderDeliveryWithEsim.description'
};

function chooseContentKey(_ref) {
  var hasEsim = _ref.hasEsim,
      selectedOption = _ref.selectedOption;

  if (selectedOption === STANDARD_DELIVERY_OPTION) {
    return hasEsim ? CONTENT_KEYS.STANDARD_DELIVERY_WITH_ESIM : CONTENT_KEYS.STANDARD_DELIVERY;
  }

  if (selectedOption === EXTENDED_DELIVERY_OPTION) {
    return hasEsim ? CONTENT_KEYS.EXTENDED_DELIVERY_WITH_ESIM : CONTENT_KEYS.EXTENDED_DELIVERY;
  }

  if (selectedOption === CLICK_AND_COLLECT_DELIVERY_OPTION) {
    return CONTENT_KEYS.CLICK_AND_COLLECT;
  }

  if (selectedOption === PREORDER_DELIVERY_OPTION) {
    return hasEsim ? CONTENT_KEYS.PREORDER_DELIVERY_WITH_ESIM : CONTENT_KEYS.PREORDER_DELIVERY;
  }

  return null;
}

function containsEsim(cart) {
  var allItems = cart.bundles.flatMap(function (bundle) {
    return bundle.items;
  });
  return allItems.some(function (item) {
    return item.offerId === ESIM_OFFER_ID;
  });
}

function getInfoBannerContentKey(fieldModel, selectedOption) {
  var optionModel = fieldModel.options.find(function (_ref2) {
    var value = _ref2.value;
    return value === selectedOption;
  });
  return optionModel === null || optionModel === void 0 ? void 0 : optionModel.infoBannerContentKey;
}

function DeliveryOptionsInfoBanner(_ref3) {
  var cart = _ref3.cart,
      selectedOption = _ref3.selectedOption,
      journeyId = _ref3.journeyId,
      fieldModel = _ref3.fieldModel,
      variant = _ref3.variant,
      contentVariation = _ref3.contentVariation;

  var _useAuthorableContent = useAuthorableContentsFromRelay(journeyId, contentVariation),
      getText = _useAuthorableContent.getText;

  var hasEsim = containsEsim(cart);
  var infoBannerContentKey = getInfoBannerContentKey(fieldModel, selectedOption);
  var contentFieldKey = chooseContentKey({
    hasEsim: hasEsim,
    selectedOption: selectedOption
  });
  var content = getText(infoBannerContentKey || contentFieldKey);

  if (!content) {
    return null;
  }

  return variant === 'box' ? /*#__PURE__*/React.createElement(InfoBox, {
    title: "Some things to keep in mind:"
  }, /*#__PURE__*/React.createElement(RawHTMLContent, {
    content: content
  })) : /*#__PURE__*/React.createElement(InfoBanner, {
    variant: "INFO"
  }, /*#__PURE__*/React.createElement(RawHTMLContent, {
    content: content
  }));
}

var _ClickAndCollectOptionQuery;
var STORE_STOCK_QUERY_LIMIT = 5;
var storeStockQuery = _ClickAndCollectOptionQuery !== void 0 ? _ClickAndCollectOptionQuery : (_ClickAndCollectOptionQuery = require("./__generated__/ClickAndCollectOptionQuery.graphql"), _ClickAndCollectOptionQuery.hash && _ClickAndCollectOptionQuery.hash !== "a0974b85ef29aea6c03537dc7165f541" && console.error("The definition of 'ClickAndCollectOptionQuery' appears to have changed. Run `relay-compiler` to update the generated files to receive the expected data."), _ClickAndCollectOptionQuery);
function ClickAndCollectOption(_ref) {
  var checked = _ref.checked,
      optionModel = _ref.optionModel,
      onChange = _ref.onChange,
      cartId = _ref.cartId;

  var _useSegment = useSegment(),
      channel = _useSegment.channel;

  var _useLazyLoadQuery = useLazyLoadQuery$1(storeStockQuery, {
    cartId: cartId,
    channel: channel,
    limit: STORE_STOCK_QUERY_LIMIT
  }),
      availability = _useLazyLoadQuery.storeStock.availability;

  var label = optionModel.label,
      sublabel = optionModel.sublabel,
      value = optionModel.value;

  function handleChange() {
    onChange({
      label: label,
      sublabel: sublabel,
      value: value
    });
  }

  var isClickAndCollectAvailable = availability > 0;

  if (!isClickAndCollectAvailable) {
    return null;
  }

  return /*#__PURE__*/React.createElement(ChoiceBox, {
    name: value,
    checked: checked,
    onChange: handleChange,
    value: value
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Text, {
    variant: "bodySDemi"
  }, label), /*#__PURE__*/React.createElement(Text, {
    variant: "bodySMedium"
  }, sublabel)));
}

var _ShippingOptionQuery;
var onlineStockQuery = _ShippingOptionQuery !== void 0 ? _ShippingOptionQuery : (_ShippingOptionQuery = require("./__generated__/ShippingOptionQuery.graphql"), _ShippingOptionQuery.hash && _ShippingOptionQuery.hash !== "3460cf057f8dcd83f443f0e625dea033" && console.error("The definition of 'ShippingOptionQuery' appears to have changed. Run `relay-compiler` to update the generated files to receive the expected data."), _ShippingOptionQuery);
function ShippingOptionOption(_ref) {
  var checked = _ref.checked,
      optionModel = _ref.optionModel,
      onChange = _ref.onChange,
      offerIds = _ref.offerIds,
      clickAndCollectOptionModel = _ref.clickAndCollectOptionModel;

  var _useLazyLoadQuery = useLazyLoadQuery$1(onlineStockQuery, {
    offerIds: offerIds
  }),
      onlineStock = _useLazyLoadQuery.onlineStock;

  function handleChange() {
    onChange(optionModel);
  }

  useEffect(function () {
    if ((onlineStock === null || onlineStock === void 0 ? void 0 : onlineStock.stockStatus) !== 'IN_STOCK') {
      onChange(clickAndCollectOptionModel);
    } else {
      onChange(optionModel);
    }
  }, [onlineStock]);
  var isShippingOptionAvailable = (onlineStock === null || onlineStock === void 0 ? void 0 : onlineStock.stockStatus) === 'IN_STOCK';

  if (!isShippingOptionAvailable) {
    return null;
  }

  return /*#__PURE__*/React.createElement(ChoiceBox, {
    name: optionModel.value,
    checked: checked,
    onChange: handleChange,
    value: optionModel.value
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Text, {
    variant: "bodySDemi"
  }, optionModel.label), /*#__PURE__*/React.createElement(Text, {
    variant: "bodySMedium"
  }, optionModel.sublabel)));
}

var fixedDeliveryOptions = [STANDARD_DELIVERY_OPTION, EXTENDED_DELIVERY_OPTION, PREORDER_DELIVERY_OPTION, CLICK_AND_COLLECT_DELIVERY_OPTION];
function chooseShippingOption(_ref) {
  var fieldModel = _ref.fieldModel,
      shippingMessage = _ref.shippingMessage;
  var hasPreorderDelivery = fieldModel.options.some(function (option) {
    return option.value === PREORDER_DELIVERY_OPTION && option.visibility;
  });

  if (hasPreorderDelivery) {
    return {
      label: 'Pre-order delivery - Free',
      sublabel: shippingMessage,
      value: PREORDER_DELIVERY_OPTION
    };
  }

  var hasExtendedDelivery = fieldModel.options.some(function (option) {
    return option.value === EXTENDED_DELIVERY_OPTION && option.visibility;
  });

  if (hasExtendedDelivery) {
    return {
      label: 'Extended delivery - Free',
      sublabel: shippingMessage,
      value: EXTENDED_DELIVERY_OPTION
    };
  }

  var deliveryOption = fieldModel.options.find(function (option) {
    return !fixedDeliveryOptions.includes(option.value) && option.visibility;
  });

  if (deliveryOption) {
    var label = deliveryOption.label,
        sublabel = deliveryOption.sublabel,
        value = deliveryOption.value,
        infoBannerContentKey = deliveryOption.infoBannerContentKey;
    return {
      label: label,
      sublabel: shippingMessage || sublabel,
      value: value,
      infoBannerContentKey: infoBannerContentKey
    };
  }

  return {
    label: 'Standard delivery - Free',
    sublabel: shippingMessage,
    value: STANDARD_DELIVERY_OPTION
  };
}

var PROMO_CATEGORIES = ['accessories_promo', 'handsets_promo'];

var _DeliveryOptionsFieldQuery;
var deliveryOptionsQuery = _DeliveryOptionsFieldQuery !== void 0 ? _DeliveryOptionsFieldQuery : (_DeliveryOptionsFieldQuery = require("./__generated__/DeliveryOptionsFieldQuery.graphql"), _DeliveryOptionsFieldQuery.hash && _DeliveryOptionsFieldQuery.hash !== "9d9983361a79f87d5f1aa7ba9e9f5d28" && console.error("The definition of 'DeliveryOptionsFieldQuery' appears to have changed. Run `relay-compiler` to update the generated files to receive the expected data."), _DeliveryOptionsFieldQuery);
var getShippableOfferIds = function getShippableOfferIds(cart) {
  var _a, _b;

  return (_b = (_a = cart === null || cart === void 0 ? void 0 : cart.shippableItems) === null || _a === void 0 ? void 0 : _a.filter(function (item) {
    return !PROMO_CATEGORIES.some(function (category) {
      var _a;

      return (_a = item === null || item === void 0 ? void 0 : item.categories) === null || _a === void 0 ? void 0 : _a.includes(category);
    });
  }).map(function (item) {
    return item.offerId;
  })) !== null && _b !== void 0 ? _b : [];
};
function DeliveryOptionsField(_ref) {
  var model = _ref.model,
      journeyId = _ref.journeyId,
      cartId = _ref.cartId,
      _ref$infoVariant = _ref.infoVariant,
      infoVariant = _ref$infoVariant === void 0 ? 'box' : _ref$infoVariant,
      _ref$isTitleVisible = _ref.isTitleVisible,
      isTitleVisible = _ref$isTitleVisible === void 0 ? false : _ref$isTitleVisible,
      contentVariation = _ref.contentVariation;

  var _useSegment = useSegment(),
      channel = _useSegment.channel;

  var _useLazyLoadQuery = useLazyLoadQuery(deliveryOptionsQuery, {
    cartId: cartId,
    channel: channel
  }),
      cart = _useLazyLoadQuery.cart;

  var _useController = useController({
    name: model.key,
    rules: {
      required: model.required
    },
    shouldUnregister: true
  }),
      field = _useController.field;

  var shippingOption = chooseShippingOption({
    fieldModel: model,
    shippingMessage: cart === null || cart === void 0 ? void 0 : cart.deliveryMessage
  });
  var clickAndCollectOption = model.options.find(function (option) {
    return option.value === CLICK_AND_COLLECT_DELIVERY_OPTION;
  });
  var isClickAndCollectVisible = clickAndCollectOption === null || clickAndCollectOption === void 0 ? void 0 : clickAndCollectOption.visibility;
  var shippableOfferIds = getShippableOfferIds(cart);

  function handleChange(changedOption) {
    trackCustomLink(changedOption.label);
    field.onChange(changedOption.value);
  }

  useEffect(function () {
    var visibleOptions = model.options.filter(function (_ref2) {
      var visibility = _ref2.visibility;
      return visibility;
    });

    if (visibleOptions.length === 1) {
      var value = visibleOptions[0].value;
      field.onChange(value);
    }
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ChoiceboxGroup, {
    title: isTitleVisible ? model.label : ''
  }, /*#__PURE__*/React.createElement(ShippingOptionOption, {
    optionModel: shippingOption,
    checked: field.value === shippingOption.value,
    onChange: handleChange,
    offerIds: shippableOfferIds,
    clickAndCollectOptionModel: clickAndCollectOption
  }), isClickAndCollectVisible ? /*#__PURE__*/React.createElement(ClickAndCollectOption, {
    checked: field.value === CLICK_AND_COLLECT_DELIVERY_OPTION,
    optionModel: clickAndCollectOption,
    onChange: handleChange,
    cartId: cartId
  }) : null), /*#__PURE__*/React.createElement(Box, {
    pb: "s1",
    pt: "s3"
  }, /*#__PURE__*/React.createElement(DeliveryOptionsInfoBanner, {
    cart: cart,
    selectedOption: field.value,
    journeyId: journeyId,
    fieldModel: model,
    variant: infoVariant,
    contentVariation: contentVariation
  })));
}

var getJexlExpression = function getJexlExpression(expression) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  jexl.addFunction('addDays', function (timestamp, dayAmount) {
    return formatISO(addDays(parseISO(timestamp), dayAmount));
  }); // eslint-disable-next-line @typescript-eslint/no-explicit-any

  jexl.addFunction('subtract', function (timestamp, years) {
    var months = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var days = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
    return formatISO(sub(parseISO(timestamp), {
      years: years,
      months: months,
      days: days
    }));
  }); // eslint-disable-next-line @typescript-eslint/no-explicit-any

  jexl.addFunction('today', function () {
    return formatISO(new Date());
  }); // eslint-disable-next-line @typescript-eslint/no-explicit-any

  jexl.addFunction('endOfMonth', function () {
    return formatISO(endOfMonth(Date.now()));
  });
  return parseISO(jexl.evalSync(expression));
};
var getMinDate = function getMinDate(model) {
  var _a, _b;

  if (!((_a = model === null || model === void 0 ? void 0 : model.minimumRule) === null || _a === void 0 ? void 0 : _a.expression)) {
    return null;
  }

  return getJexlExpression((_b = model === null || model === void 0 ? void 0 : model.minimumRule) === null || _b === void 0 ? void 0 : _b.expression);
};
var getMaxDate = function getMaxDate(model) {
  var _a, _b;

  if (!((_a = model === null || model === void 0 ? void 0 : model.maximumRule) === null || _a === void 0 ? void 0 : _a.expression)) {
    return null;
  }

  return getJexlExpression((_b = model === null || model === void 0 ? void 0 : model.maximumRule) === null || _b === void 0 ? void 0 : _b.expression);
};
var validateDate = function validateDate(textValues, model) {
  var _a;

  if (!(textValues === null || textValues === void 0 ? void 0 : textValues.yearText) || !(textValues === null || textValues === void 0 ? void 0 : textValues.monthText) || !(textValues === null || textValues === void 0 ? void 0 : textValues.dayText) || ((_a = textValues === null || textValues === void 0 ? void 0 : textValues.yearText) === null || _a === void 0 ? void 0 : _a.length) < 4) {
    return false;
  }

  var date = new Date("".concat(textValues === null || textValues === void 0 ? void 0 : textValues.yearText, "-").concat(textValues === null || textValues === void 0 ? void 0 : textValues.monthText, "-").concat(textValues === null || textValues === void 0 ? void 0 : textValues.dayText));
  var minDate = getMinDate(model);
  var maxDate = getMaxDate(model);

  if (!isValid(date)) {
    return false;
  }

  if (minDate && minDate > date) {
    return false;
  }

  if (maxDate && maxDate < date) {
    return false;
  }

  return true;
};
var padNumberToTwoDigits = function padNumberToTwoDigits(textValue) {
  if (!textValue || parseInt(textValue) === 0) {
    return '';
  }

  return padStart(textValue, 2, '0');
};

function FullDateInputField(_ref) {
  var model = _ref.model;

  var _useController = useController({
    name: model.key,
    rules: {
      required: model.required,
      validate: function validate(date) {
        return validateDate(date, model);
      }
    },
    shouldUnregister: true
  }),
      field = _useController.field,
      fieldState = _useController.fieldState;

  var onChange = function onChange(changeValues) {
    var _a;

    if (Number(changeValues === null || changeValues === void 0 ? void 0 : changeValues.dayText) > 31 || Number(changeValues === null || changeValues === void 0 ? void 0 : changeValues.monthText) > 12 || ((_a = changeValues === null || changeValues === void 0 ? void 0 : changeValues.yearText) === null || _a === void 0 ? void 0 : _a.length) > 4) {
      return;
    }

    var newTextValues = Object.assign(Object.assign({}, field.value), changeValues);
    field.onChange(newTextValues);
  };

  var buildTextValues = function buildTextValues() {
    var _a, _b;

    var dayText = padNumberToTwoDigits((_a = field.value) === null || _a === void 0 ? void 0 : _a.dayText);
    var monthText = padNumberToTwoDigits((_b = field.value) === null || _b === void 0 ? void 0 : _b.monthText);
    return Object.assign(Object.assign({}, field.value), {
      dayText: dayText,
      monthText: monthText
    });
  };

  var onBlur = function onBlur() {
    var newTextValues = buildTextValues();
    field.onChange(newTextValues);
    field.onBlur();
  };

  return /*#__PURE__*/React.createElement(DateInputField, {
    model: model,
    fieldState: fieldState,
    onChange: onChange,
    onBlur: onBlur,
    textValues: field.value,
    isFullDate: true
  });
}

function InfoBoxField(_ref) {
  var model = _ref.model,
      journeyId = _ref.journeyId,
      contentVariation = _ref.contentVariation;

  var _useAuthorableContent = useAuthorableContentsFromRelay(journeyId, contentVariation),
      getText = _useAuthorableContent.getText;

  var content = getText(model === null || model === void 0 ? void 0 : model.contentKey);
  return /*#__PURE__*/React.createElement(Box, {
    pb: "s1"
  }, /*#__PURE__*/React.createElement(InfoBox, {
    title: "Some things to keep in mind:"
  }, /*#__PURE__*/React.createElement(Box, {
    pt: "s1"
  }, /*#__PURE__*/React.createElement(RawHTMLContent, {
    content: content
  }))));
}

var _templateObject$p, _templateObject2$h;
var PREFIX_PLACEHOLDER = 'Prefix';

var buildOptions = function buildOptions(_ref) {
  var customItems = _ref.customItems;
  return customItems.map(function (customItem) {
    return {
      value: customItem,
      label: customItem
    };
  });
};

var StyledRow = styled.div(_templateObject$p || (_templateObject$p = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref2) {
  var spacing = _ref2.theme.spacing;
  return css(_templateObject2$h || (_templateObject2$h = _taggedTemplateLiteral(["\n    display: grid;\n    grid-gap: ", ";\n    grid-template-columns: 104px 1fr;\n  "])), spacing.s2);
});

function parseValue(value, options) {
  var sortedOptions = _toConsumableArray(options).sort(function (a, b) {
    return Number(b.value) - Number(a.value);
  });

  var matchingOption = sortedOptions.find(function (option) {
    return value.startsWith(option.value);
  });

  if (matchingOption) {
    var remainingNumber = value.slice(matchingOption.value.length);
    return {
      prefix: matchingOption,
      remainingNumber: remainingNumber
    };
  }

  return {
    prefix: null,
    remainingNumber: value
  };
}

function PhoneInput(_ref3) {
  var model = _ref3.model,
      onInfoLayerChange = _ref3.onInfoLayerChange;

  var _a;

  var _useController = useController({
    name: model.key,
    defaultValue: model.defaultValue,
    rules: {
      pattern: new RegExp(model.validationRule.expression),
      required: model.required
    },
    shouldUnregister: true
  }),
      field = _useController.field,
      fieldState = _useController.fieldState;

  var _useTheme = useTheme(),
      baseColors = _useTheme.palette.baseColors;

  if ((model === null || model === void 0 ? void 0 : model.customItems) == null) {
    // eslint-disable-next-line no-console
    console.log("Field model is missing customItems", model);
    return null;
  }

  var options = buildOptions(model);

  var _parseValue = parseValue(field.value, options),
      prefix = _parseValue.prefix,
      remainingNumber = _parseValue.remainingNumber;

  var isError = remainingNumber !== '' && fieldState.isDirty && fieldState.invalid;
  var erroText = isError ? (_a = model.validationRule) === null || _a === void 0 ? void 0 : _a.message : null;

  function handleChange(changePrefix, changeRemainingNumber) {
    field.onChange({
      target: {
        value: "".concat(changePrefix.value).concat(changeRemainingNumber)
      }
    });
  }

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Box, {
    flexDirection: "row"
  }, /*#__PURE__*/React.createElement(Text, {
    variant: "bodySDemi",
    mb: "s0_5"
  }, model.label), (model === null || model === void 0 ? void 0 : model.infoLayerContentKey) ? /*#__PURE__*/React.createElement(TextButton, {
    type: "button",
    onClick: function onClick() {
      onInfoLayerChange(model.infoLayerContentKey);
    },
    variant: "textbutton"
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "info_small",
    fill: baseColors.lupin
  })) : null), /*#__PURE__*/React.createElement(StyledRow, null, /*#__PURE__*/React.createElement(FormDropdown, {
    label: null,
    options: options,
    placeholder: PREFIX_PLACEHOLDER,
    value: prefix,
    onChange: function onChange(option) {
      return handleChange(option, remainingNumber);
    }
  }), /*#__PURE__*/React.createElement(NumberInput, {
    name: model.key,
    placeholder: model.placeholder,
    onChange: function onChange(event) {
      return handleChange(prefix, event.target.value);
    },
    errorText: erroText,
    inputProps: {
      'aria-label': model.label
    },
    value: remainingNumber
  })));
}

var getCompleteDate = function getCompleteDate(defaultDayMode) {
  return function (date) {
    return defaultDayMode === 'END_OF_MONTH' ? endOfMonth(date) : startOfMonth(date);
  };
};

var formatDayTextForMonthInput = function formatDayTextForMonthInput(textValues, defaultDayMode) {
  if (!(textValues === null || textValues === void 0 ? void 0 : textValues.yearText) || !(textValues === null || textValues === void 0 ? void 0 : textValues.monthText)) {
    return;
  }

  var newDate = getCompleteDate(defaultDayMode)(new Date(Number(textValues === null || textValues === void 0 ? void 0 : textValues.yearText), Number(textValues === null || textValues === void 0 ? void 0 : textValues.monthText) - 1));
  return format(newDate, DateFormat.DAY_OF_MONTH);
};

function MonthDateInputField(_ref) {
  var model = _ref.model;

  var _useController = useController({
    name: model.key,
    rules: {
      required: model.required,
      validate: function validate(date) {
        return validateDate(date, model);
      }
    },
    shouldUnregister: true
  }),
      field = _useController.field,
      fieldState = _useController.fieldState;

  var onChange = function onChange(changeValues) {
    var _a;

    if (Number(changeValues === null || changeValues === void 0 ? void 0 : changeValues.monthText) > 12 || ((_a = changeValues === null || changeValues === void 0 ? void 0 : changeValues.yearText) === null || _a === void 0 ? void 0 : _a.length) > 4) {
      return;
    }

    var updatedValues = Object.assign(Object.assign({}, field.value), changeValues);
    var dayText = Number(updatedValues.monthText) > 0 && isMatch(updatedValues.yearText, DateFormat.YEAR) ? formatDayTextForMonthInput(updatedValues, model.defaultDayMode) : null;
    var newTextValues = Object.assign(Object.assign(Object.assign({}, field.value), changeValues), {
      dayText: dayText
    });
    field.onChange(newTextValues);
  };

  var buildTextValues = function buildTextValues() {
    var _a, _b;

    if ((_a = field.value) === null || _a === void 0 ? void 0 : _a.monthText) {
      return Object.assign(Object.assign({}, field.value), {
        monthText: padNumberToTwoDigits((_b = field.value) === null || _b === void 0 ? void 0 : _b.monthText)
      });
    }
  };

  var onBlur = function onBlur() {
    var newTextValues = buildTextValues();
    field.onChange(newTextValues);
    field.onBlur();
  };

  return /*#__PURE__*/React.createElement(DateInputField, {
    model: model,
    fieldState: fieldState,
    onChange: onChange,
    onBlur: onBlur,
    textValues: field.value
  });
}

var MAX_LENGTH_ERROR_MESSAGE = 'Please enter no more than 100 letters';
function AddressField(_ref) {
  var model = _ref.model,
      onInfoLayerChange = _ref.onInfoLayerChange,
      fetchSuggestions = _ref.fetchSuggestions,
      _ref$InputWrapper = _ref.InputWrapper,
      InputWrapper = _ref$InputWrapper === void 0 ? React.Fragment : _ref$InputWrapper;

  var _a, _b;

  var _useController = useController({
    name: model.key,
    shouldUnregister: true,
    rules: {
      maxLength: {
        value: 100,
        message: MAX_LENGTH_ERROR_MESSAGE
      }
    },
    defaultValue: ''
  }),
      addressField = _useController.field,
      addressFieldState = _useController.fieldState;

  var _useController2 = useController({
    name: model.key.replace(model.name, model.name.concat('Elid')),
    rules: {
      required: model.required
    },
    shouldUnregister: true
  }),
      elidField = _useController2.field,
      elidFieldState = _useController2.fieldState;

  var _useTheme = useTheme(),
      marangai = _useTheme.palette.baseColors.marangai;

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      suggestions = _useState2[0],
      setSuggestions = _useState2[1];

  var infoLayerContentKey = model.infoLayerContentKey;

  var onChange = function onChange(newValue) {
    addressField.onChange(newValue);
    elidField.onChange(null);
  };

  var onSuggestionsFetchRequested = function onSuggestionsFetchRequested(partialAddress) {
    var isPartialValidForSearch = (partialAddress.match(/[A-Za-z]/g) || []).length > 2;

    if (isPartialValidForSearch && fetchSuggestions) {
      fetchSuggestions({
        partialAddress: partialAddress
      }).then(function (_ref2) {
        var matches = _ref2.location.address.suggestions;
        setSuggestions(matches);
      })["catch"](function () {
        setSuggestions([]);
      });
    } else {
      setSuggestions([]);
    }
  };

  var handleSelection = function handleSelection(address) {
    addressField.onChange(address.label);
    elidField.onChange(address.value);
  };

  var isError = (elidFieldState === null || elidFieldState === void 0 ? void 0 : elidFieldState.invalid) && (elidFieldState === null || elidFieldState === void 0 ? void 0 : elidFieldState.isDirty);
  var errorText = isError ? ((_a = addressFieldState === null || addressFieldState === void 0 ? void 0 : addressFieldState.error) === null || _a === void 0 ? void 0 : _a.message) || ((_b = model === null || model === void 0 ? void 0 : model.validationRule) === null || _b === void 0 ? void 0 : _b.message) : null;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Box, {
    mb: "s1"
  }, /*#__PURE__*/React.createElement(Text, {
    variant: "bodySDemi"
  }, model.label), /*#__PURE__*/React.createElement(InputWrapper, null, /*#__PURE__*/React.createElement(StoreFinder, {
    suggestions: suggestions,
    onSuggestionsFetchRequested: onSuggestionsFetchRequested,
    onSuggestionsClearRequested: function onSuggestionsClearRequested() {},
    onClearInput: function onClearInput() {
      return onChange('');
    },
    onCurrentLocationDetected: function onCurrentLocationDetected() {},
    placeholder: model.placeholder,
    value: addressField.value,
    onChange: onChange,
    disabled: false,
    onSelect: function onSelect(value) {
      handleSelection(value);
    },
    detectLocation: false,
    displayIcon: false,
    rounded: false
  })), isError ? /*#__PURE__*/React.createElement(Text, {
    variant: "footnoteDemi",
    color: marangai
  }, errorText) : null), infoLayerContentKey && onInfoLayerChange ? /*#__PURE__*/React.createElement(Button, {
    variant: "textbutton",
    type: "button",
    onClick: function onClick() {
      onInfoLayerChange(infoLayerContentKey);
    }
  }, "I can't find my address") : null);
}

var data = {
	location: {
		address: {
			suggestions: [
				{
					value: "302835065",
					label: "5 Park Lane, Waihi 3610"
				},
				{
					value: "301703670",
					label: "5 Vic Butler Street, Mount Roskill, Auckland 1041"
				},
				{
					value: "300212736",
					label: "5A Vic Butler Street, Mount Roskill, Auckland 1041"
				},
				{
					value: "303076456",
					label: "5 Vic Knight Lane, RD 8 Te Kowhai 3288"
				},
				{
					value: "301066160",
					label: "5 Vicente Place, Oteha, North Shore 0632"
				},
				{
					value: "302051364",
					label: "5 Viceroy Place, Halswell, Christchurch 8025"
				},
				{
					value: "301880221",
					label: "5 Vickerman Street, Grovetown 7202"
				},
				{
					value: "300337212",
					label: "5A Vickerman Street, Otara, Manukau 2023"
				},
				{
					value: "301357123",
					label: "5B Vickerman Street, Otara, Manukau 2023"
				},
				{
					value: "301499505",
					label: "5C Vickerman Street, Otara, Manukau 2023"
				},
				{
					value: "300856160",
					label: "5 Vickerman Street, Port Nelson, Nelson 7010"
				},
				{
					value: "300159670",
					label: "5 Vickers Crescent, Mangere, Manukau 2022"
				},
				{
					value: "300721055",
					label: "5 Vickers Road, Waiwhakaiho, New Plymouth 4312"
				},
				{
					value: "301360869",
					label: "5A Vickers Road, Waiwhakaiho, New Plymouth 4312"
				},
				{
					value: "301991991",
					label: "5 Vickery Place, Maryhill, Dunedin 9011"
				},
				{
					value: "300971859",
					label: "5 Vickerys Road, Wigram, Christchurch 8042"
				},
				{
					value: "300517123",
					label: "5 Vicki Street, Sockburn, Christchurch 8042"
				},
				{
					value: "300697069",
					label: "5 Victa Lane, RD 2 Ardmore 2582"
				},
				{
					value: "302104250",
					label: "5 Victor Grove, Waikanae Beach 5036"
				},
				{
					value: "301366156",
					label: "5 Victor Road, Raumati Beach, Raumati 5032"
				}
			]
		}
	}
};
var addressSuggestions_mock = {
	data: data
};

var clickPaymentIFrameStyles = "\n  .cardForm {\n    font-family: 'Avenir Next', Helvetica, Arial, sans-serif;\n    font-weight: 500;\n  }\n\n  .cardForm input {\n    outline: none;\n  }\n\n  .cardForm__cardContainer,\n  .cardForm__userName,\n  .cardForm__cardExpiry,\n  .cardForm__cardCvv {\n    border: ".concat(colors.moeraki, " solid 2px;\n    font-weight: 500;\n  }\n\n  .cardForm__cardContainer:has(input:focus),\n  .cardForm__userName:focus,\n  .cardForm__cardExpiry:focus,\n  .cardForm__cardCvv:focus {\n    border-color: ").concat(colors.lupin, ";\n  }\n\n  #cardLogo {\n    display: none;\n  }\n");
function useClickPayment(_ref) {
  var onMessage = _ref.onMessage;

  var _useEnvironmentConfig = useEnvironmentConfig(),
      clickScriptURL = _useEnvironmentConfig.clickScriptURL,
      clickScriptIntegrity = _useEnvironmentConfig.clickScriptIntegrity;

  var integrityProps = clickScriptIntegrity ? {
    integrity: clickScriptIntegrity,
    crossOrigin: 'anonymous'
  } : {};

  var _useScript = useScript(Object.assign({
    src: clickScriptURL
  }, integrityProps)),
      _useScript2 = _slicedToArray(_useScript, 2),
      loading = _useScript2[0],
      error = _useScript2[1];

  useEffect(function () {
    window.addEventListener('message', onMessage);
    return function () {
      window.removeEventListener('message', onMessage);
    };
  }, []);
  var hasClickPaymentScriptLoaded = !loading && error == null && window.paymarkPlugin;

  if (!hasClickPaymentScriptLoaded) {
    return {
      isClickPaymentReady: false,
      initialisePayment: noop,
      renderCard: noop,
      renderOE: noop,
      submitPayment: noop
    };
  }

  var _window$paymarkPlugin = window.paymarkPlugin,
      renderCard = _window$paymarkPlugin.renderCard,
      renderOE = _window$paymarkPlugin.renderOE,
      submitPayment = _window$paymarkPlugin.submitPayment;

  var initialisePayment = function initialisePayment(_ref2) {
    var containerElementId = _ref2.containerElementId,
        onError = _ref2.onError,
        paymentSessionId = _ref2.paymentSessionId,
        storeCardMethod = _ref2.storeCardMethod;
    window.paymarkPlugin.initialise({
      redirect: false,
      targetElementId: containerElementId,
      paymentId: paymentSessionId,
      styles: clickPaymentIFrameStyles,
      genericErrorMessage: '',
      requiredFieldErrorMessagePrefix: '',
      storeCardMethod: storeCardMethod,
      onError: onError
    });
  };

  return {
    isClickPaymentReady: true,
    initialisePayment: initialisePayment,
    renderCard: renderCard,
    renderOE: renderOE,
    submitPayment: submitPayment
  };
}

var PaymentStoreCardMethod;

(function (PaymentStoreCardMethod) {
  PaymentStoreCardMethod["STORE_CARD"] = "STORE_CARD";
  PaymentStoreCardMethod["DO_NOT_STORE_CARD"] = "DO_NOT_STORE_CARD";
  PaymentStoreCardMethod["CUSTOMER_SELECTION"] = "CUSTOMER_SELECTION";
})(PaymentStoreCardMethod || (PaymentStoreCardMethod = {}));

var _templateObject$o, _templateObject2$g, _templateObject3$8, _templateObject4$7;
var CLICK_CONTAINER_ID = 'click-container';
var DONE_EVENTS = ['payment_submission_response', 'payment_challenge_response'];
var StyledBox = styled(Box)(_templateObject$o || (_templateObject$o = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref) {
  var spacing = _ref.theme.spacing;
  return css(_templateObject2$g || (_templateObject2$g = _taggedTemplateLiteral(["\n    display: flex;\n    flex-direction: column;\n    gap: ", ";\n  "])), spacing.s5);
});
var IconContainer$1 = styled.div(_templateObject3$8 || (_templateObject3$8 = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref2) {
  var spacing = _ref2.theme.spacing;
  return css(_templateObject4$7 || (_templateObject4$7 = _taggedTemplateLiteral(["\n    padding-right: ", ";\n  "])), spacing.s1);
});
var STORE_CARD = PaymentStoreCardMethod.STORE_CARD;

var getIsCardStored = function getIsCardStored(event) {
  var _a;

  try {
    var paymentDataTransactionResult = JSON.parse(Buffer.from((_a = event.data) === null || _a === void 0 ? void 0 : _a.data.paymentDetails, 'base64').toString('ascii')).transaction.result;
    return paymentDataTransactionResult.cardStored;
  } catch (error) {
    console.log('Error parsing payment event:', error);
    return false;
  }
};

function PaymentForm(_ref3) {
  var paymentSession = _ref3.paymentSession,
      onPaymentSubmit = _ref3.onPaymentSubmit,
      onPaymentError = _ref3.onPaymentError,
      storeCardMethod = _ref3.storeCardMethod,
      buttonLabel = _ref3.buttonLabel,
      storeCardMessage = _ref3.storeCardMessage;

  var _useTheme = useTheme(),
      lupin = _useTheme.palette.baseColors.lupin;

  var _useEnvironmentConfig = useEnvironmentConfig(),
      isDevelopmentEnvironment = _useEnvironmentConfig.isDevelopmentEnvironment;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isPaymentSubmitting = _useState2[0],
      setIsPaymentSubmitting = _useState2[1];

  var isFirstPaymentEventProcessing = false;
  var paymentSessionId = paymentSession.paymentSessionId;

  var handleClickPaymentMessage = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(event) {
      var _a, paymentEvent;

      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              paymentEvent = event.data;

              if (paymentEvent) {
                if (((_a = paymentEvent.data) === null || _a === void 0 ? void 0 : _a.valid) === false) {
                  setIsPaymentSubmitting(false);
                }

                if (DONE_EVENTS.includes(paymentEvent.event)) {
                  if (isDevelopmentEnvironment) console.log('Click Plugin Message:', event);

                  if (!isFirstPaymentEventProcessing) {
                    isFirstPaymentEventProcessing = true;
                    onPaymentSubmit({
                      paymentSessionId: paymentSessionId,
                      shouldSaveCard: getIsCardStored(event)
                    });
                  }
                }
              }

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleClickPaymentMessage(_x) {
      return _ref4.apply(this, arguments);
    };
  }();

  var _useClickPayment = useClickPayment({
    onMessage: handleClickPaymentMessage
  }),
      isClickPaymentReady = _useClickPayment.isClickPaymentReady,
      initialisePayment = _useClickPayment.initialisePayment,
      renderCard = _useClickPayment.renderCard,
      submitPayment = _useClickPayment.submitPayment;

  var handlePlaceOrder = function handlePlaceOrder() {
    setIsPaymentSubmitting(true);
    submitPayment();
  };

  var handleError = function handleError() {
    captureException(new Error('Internal Click payment error'), {
      contexts: {
        info: {
          paymentSessionId: paymentSessionId
        }
      }
    });
    onPaymentError();
  };

  useLayoutEffect(function () {
    if (isClickPaymentReady) {
      initialisePayment({
        containerElementId: CLICK_CONTAINER_ID,
        onError: handleError,
        paymentSessionId: paymentSessionId,
        storeCardMethod: storeCardMethod
      });
      renderCard();
    }
  }, [isClickPaymentReady]);
  return /*#__PURE__*/React.createElement(StyledBox, null, /*#__PURE__*/React.createElement("div", {
    id: CLICK_CONTAINER_ID
  }), storeCardMethod === STORE_CARD && storeCardMessage ? /*#__PURE__*/React.createElement(Box, {
    flexDirection: "row",
    gap: "s1"
  }, /*#__PURE__*/React.createElement(IconContainer$1, null, /*#__PURE__*/React.createElement(Icon, {
    name: "info_small",
    fill: lupin
  })), /*#__PURE__*/React.createElement(Text, {
    variant: "bodySDemi"
  }, storeCardMessage)) : null, /*#__PURE__*/React.createElement(Button, {
    type: "button",
    onClick: handlePlaceOrder,
    variant: "primary",
    isLoading: isPaymentSubmitting
  }, buttonLabel));
}

var ContentField = function ContentField(_ref) {
  var type = _ref.type,
      url = _ref.url,
      value = _ref.value;

  switch (type) {
    case 'HEADING':
      return /*#__PURE__*/React.createElement(Box, {
        pt: "s7"
      }, /*#__PURE__*/React.createElement(Text, {
        variant: "subheadingM"
      }, value));

    case 'SUB_HEADING':
      return /*#__PURE__*/React.createElement(Box, {
        pt: "s4"
      }, /*#__PURE__*/React.createElement(Text, {
        variant: "bodyMDemi"
      }, value));

    case 'PARAGRAPH':
      return /*#__PURE__*/React.createElement(Box, {
        pt: "s1"
      }, /*#__PURE__*/React.createElement(Text, {
        variant: "bodySMedium"
      }, value));

    case 'HYPERLINK':
      return /*#__PURE__*/React.createElement(Box, {
        pt: "s1"
      }, /*#__PURE__*/React.createElement(Link, {
        href: url,
        target: "_blank",
        rel: "noreferrer"
      }, value));

    default:
      // unsupported type
      return null;
  }
};

var _templateObject$n, _templateObject2$f, _templateObject3$7, _templateObject4$6;
var BaseStyle = css(_templateObject$n || (_templateObject$n = _taggedTemplateLiteral(["\n  ", "\n  line-height: 24px;\n"])), function (_ref) {
  var spacing = _ref.theme.spacing;
  return css(_templateObject2$f || (_templateObject2$f = _taggedTemplateLiteral(["\n    margin: ", " 0 0 -", ";\n  "])), spacing.s0_5, spacing.s2);
});
var OrderedList = styled.ol(_templateObject3$7 || (_templateObject3$7 = _taggedTemplateLiteral(["\n  ", "\n"])), BaseStyle);
var UnorderedList = styled.ul(_templateObject4$6 || (_templateObject4$6 = _taggedTemplateLiteral(["\n  ", "\n"])), BaseStyle);

var ContentFieldList = function ContentFieldList(_ref2) {
  var listItems = _ref2.listItems;
  var listType = listItems[0].type;
  var list = listItems.map(function (_ref3) {
    var key = _ref3.key,
        value = _ref3.value;
    return /*#__PURE__*/React.createElement("li", {
      key: key
    }, value);
  });
  return /*#__PURE__*/React.createElement(Box, {
    pt: "s1"
  }, listType === 'ORDERED_LIST_ITEM' ? /*#__PURE__*/React.createElement(OrderedList, null, list) : /*#__PURE__*/React.createElement(UnorderedList, null, list, " "));
};

var _ContentFieldsQuery, _templateObject$m;
var ContentFieldsContainer = styled.div(_templateObject$m || (_templateObject$m = _taggedTemplateLiteral(["\n  & > ", ":first-child {\n    padding-top: 0;\n  }\n"])), Box);
var query = _ContentFieldsQuery !== void 0 ? _ContentFieldsQuery : (_ContentFieldsQuery = require("./__generated__/ContentFieldsQuery.graphql"), _ContentFieldsQuery.hash && _ContentFieldsQuery.hash !== "bd9c924d0e68d78fe3ec4aa489b8bc23" && console.error("The definition of 'ContentFieldsQuery' appears to have changed. Run `relay-compiler` to update the generated files to receive the expected data."), _ContentFieldsQuery);

var ContentFields = function ContentFields(_ref) {
  var contentFragmentKey = _ref.contentFragmentKey,
      segment = _ref.segment,
      variation = _ref.variation;

  var _useLazyLoadQuery = useLazyLoadQuery(query, {
    contentFragmentKey: contentFragmentKey,
    segment: segment,
    variation: variation
  }),
      contentFields = _useLazyLoadQuery.contentFields;

  var listItems = [];

  var isListItem = function isListItem(item) {
    return item.type === 'ORDERED_LIST_ITEM' || item.type === 'UNORDERED_LIST_ITEM';
  };

  var compareTypes = function compareTypes(item1, item2) {
    return item1.type === item2.type;
  };

  return /*#__PURE__*/React.createElement(ContentFieldsContainer, null, contentFields.map(function (contentField, index) {
    if (isListItem(contentField)) {
      if (index === 0 || !compareTypes(contentField, contentFields[index - 1])) {
        listItems = [];
        listItems.push(contentField);
      }

      if (index !== 0 && compareTypes(contentField, contentFields[index - 1])) {
        listItems.push(contentField);
      }

      if (index === contentFields.length - 1 || !compareTypes(contentField, contentFields[index + 1])) {
        return /*#__PURE__*/React.createElement(ContentFieldList, {
          listItems: listItems
        });
      }
    } else {
      return /*#__PURE__*/React.createElement(ContentField, {
        key: contentField.key,
        type: contentField.type,
        url: contentField.url,
        value: contentField.value
      });
    }
  }));
};

var Loader = function Loader() {
  return /*#__PURE__*/React.createElement(Box, {
    title: "Loading content...",
    flexDirection: "row",
    justifyContent: "center",
    pt: "s8"
  }, /*#__PURE__*/React.createElement(LoadingSpinner, {
    size: 32
  }));
};

var ContentFragmentInfoLayer = function ContentFragmentInfoLayer(_ref) {
  var contentFragmentKey = _ref.contentFragmentKey,
      isOpen = _ref.isOpen,
      isNested = _ref.isNested,
      segment = _ref.segment,
      variation = _ref.variation,
      onClose = _ref.onClose;
  return /*#__PURE__*/React.createElement(InformationLayer, {
    isOpen: isOpen,
    isNested: isNested,
    onClose: onClose
  }, isOpen ? /*#__PURE__*/React.createElement(Suspense, {
    fallback: /*#__PURE__*/React.createElement(Loader, null)
  }, /*#__PURE__*/React.createElement(ContentFields, {
    contentFragmentKey: contentFragmentKey,
    segment: segment,
    variation: variation
  })) : null);
};

var InformationLayerLoader = function InformationLayerLoader() {
  return /*#__PURE__*/React.createElement(SparkContentLoader, {
    style: {
      height: '400px',
      width: '100%'
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: "0",
    y: "0",
    rx: "4",
    ry: "4",
    width: "100%",
    height: "32"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "0",
    y: "64",
    rx: "4",
    ry: "4",
    width: "100%",
    height: "24"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "0",
    y: "104",
    rx: "4",
    ry: "4",
    width: "100%",
    height: "24"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "0",
    y: "144",
    rx: "4",
    ry: "4",
    width: "159",
    height: "24"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "0",
    y: "200",
    rx: "4",
    ry: "4",
    width: "100%",
    height: "24"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "0",
    y: "240",
    rx: "4",
    ry: "4",
    width: "198",
    height: "24"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "0",
    y: "296",
    rx: "4",
    ry: "4",
    width: "100%",
    height: "24"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "0",
    y: "336",
    rx: "4",
    ry: "4",
    width: "207",
    height: "24"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "0",
    y: "376",
    rx: "4",
    ry: "4",
    width: "70",
    height: "24"
  }));
};

var Error$1 = function Error(_ref) {
  var refresh = _ref.refresh;
  var hasRefresh = Boolean(refresh);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, {
    variant: "subheadingM",
    mb: "s4"
  }, "Unfortunately, we're not able to load this right now."), /*#__PURE__*/React.createElement(Text, {
    variant: "bodySMedium",
    mb: "s4"
  }, "Please try again or come back later."), hasRefresh ? /*#__PURE__*/React.createElement(Button, {
    variant: "default",
    onClick: refresh
  }, "Try again") : null);
};

var ContentBody = function ContentBody(_ref2) {
  var contentId = _ref2.contentId,
      apiBaseUrl = _ref2.apiBaseUrl,
      variation = _ref2.variation;

  var _a, _b;

  var _useContent = useContent({
    apiBaseUrl: apiBaseUrl,
    persistedQuery: 'content-info-modal-list',
    modelId: 'info-modal-model',
    contentId: contentId,
    format: 'html',
    variation: variation
  }),
      infoLayerResponse = _useContent.data,
      isLoading = _useContent.isLoading;

  if (isLoading) return /*#__PURE__*/React.createElement(InformationLayerLoader, null);
  var content = (_b = (_a = infoLayerResponse === null || infoLayerResponse === void 0 ? void 0 : infoLayerResponse.data.infoModalList) === null || _a === void 0 ? void 0 : _a.items) === null || _b === void 0 ? void 0 : _b[0];

  if (content) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(InformationLayerTitle, null, content === null || content === void 0 ? void 0 : content.title), /*#__PURE__*/React.createElement(RawHTMLContent, {
      content: (content === null || content === void 0 ? void 0 : content.content.html) || ''
    }));
  }

  return null;
};

var ContentInfoLayer = function ContentInfoLayer(_ref3) {
  var handleRetry = _ref3.handleRetry,
      onClose = _ref3.onClose,
      apiBaseUrl = _ref3.apiBaseUrl,
      contentId = _ref3.contentId,
      contentKey = _ref3.contentKey,
      variation = _ref3.variation,
      isBusiness = _ref3.isBusiness;
  var isOpen = Boolean(contentKey);
  return /*#__PURE__*/React.createElement(InformationLayer, {
    isOpen: isOpen,
    onClose: onClose
  }, isOpen && /*#__PURE__*/React.createElement(ErrorBoundary, {
    fallback: function fallback() {
      return /*#__PURE__*/React.createElement(Error$1, {
        refresh: handleRetry
      });
    }
  }, /*#__PURE__*/React.createElement(Suspense, {
    fallback: /*#__PURE__*/React.createElement(InformationLayerLoader, null)
  }, /*#__PURE__*/React.createElement(ContentBody, {
    apiBaseUrl: apiBaseUrl,
    contentId: contentId,
    contentKey: contentKey,
    variation: getContentVariation(isBusiness, variation)
  }))));
};

function ContentLoader(_ref) {
  var radius = _ref.radius;
  var loaderRadius = radius || 6;
  return /*#__PURE__*/React.createElement(SparkContentLoader, {
    style: {
      height: '100%',
      width: '100%'
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: "0",
    y: "0",
    rx: loaderRadius,
    ry: loaderRadius,
    width: "100%",
    height: "100%"
  }));
}

var _templateObject$l;
var Clickable = styled.button(_templateObject$l || (_templateObject$l = _taggedTemplateLiteral(["\n  padding: 0;\n  border: 0;\n  background: transparent;\n  cursor: pointer;\n"])));

var _templateObject$k, _templateObject2$e, _templateObject3$6, _templateObject4$5, _templateObject5$2, _templateObject6$2, _templateObject7$2, _templateObject8$2, _templateObject9$2, _templateObject10$2, _templateObject11$2, _templateObject12$2, _templateObject13$2, _templateObject14$2;
var Container$1 = styled.div(_templateObject$k || (_templateObject$k = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref) {
  var _ref$theme = _ref.theme,
      spacing = _ref$theme.spacing,
      media = _ref$theme.media;
  return css(_templateObject2$e || (_templateObject2$e = _taggedTemplateLiteral(["\n    width: 100%;\n    padding: 90px ", ";\n\n    ", " {\n      padding: ", " ", ";\n    }\n    ", " {\n      padding: ", " 120px;\n    }\n  "])), spacing.s3, media.up('slim'), spacing.s7, spacing.s4, media.up('big'), spacing.s7);
});
var ItemWrapper = styled.div(_templateObject3$6 || (_templateObject3$6 = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref2) {
  var _ref2$theme = _ref2.theme,
      spacing = _ref2$theme.spacing,
      media = _ref2$theme.media;
  return css(_templateObject4$5 || (_templateObject4$5 = _taggedTemplateLiteral(["\n    display: none;\n    width: 100%;\n    column-count: 3;\n    column-gap: ", ";\n\n    ", " {\n      display: grid;\n      grid-template-columns: repeat(3, 1fr);\n    }\n\n    ", " {\n      display: flex;\n      justify-content: space-between;\n    }\n\n    > * {\n      width: 100%;\n      display: inline-block;\n      margin-bottom: ", ";\n    }\n  "])), spacing.s2, media.up('slim'), media.up('big'), spacing.s5);
});
var Column = styled.div(_templateObject5$2 || (_templateObject5$2 = _taggedTemplateLiteral([""])));
var Item = styled.div(_templateObject6$2 || (_templateObject6$2 = _taggedTemplateLiteral(["\n  height: 18px;\n  width: 100px;\n  margin: 20px 0;\n"])));
var ItemShort = styled(Item)(_templateObject7$2 || (_templateObject7$2 = _taggedTemplateLiteral(["\n  width: 60px;\n"])));
var ItemLong = styled(Item)(_templateObject8$2 || (_templateObject8$2 = _taggedTemplateLiteral(["\n  width: 130px;\n"])));
var MobileItemWrapper = styled.div(_templateObject9$2 || (_templateObject9$2 = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref3) {
  var media = _ref3.theme.media;
  return css(_templateObject10$2 || (_templateObject10$2 = _taggedTemplateLiteral(["\n    width: 100%;\n\n    ", " {\n      display: none;\n    }\n  "])), media.up('slim'));
});
var MobileItem = styled.div(_templateObject11$2 || (_templateObject11$2 = _taggedTemplateLiteral([""])));
var MobileItemInner = styled.div(_templateObject12$2 || (_templateObject12$2 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n  padding: 18px 0;\n"])));
var Left = styled.div(_templateObject13$2 || (_templateObject13$2 = _taggedTemplateLiteral(["\n  width: 150px;\n  height: 20px;\n"])));
var Right = styled.div(_templateObject14$2 || (_templateObject14$2 = _taggedTemplateLiteral(["\n  width: 18px;\n  height: 18px;\n"])));

function ItemSet() {
  var items = Array.from(Array(6).keys());
  return /*#__PURE__*/React.createElement(React.Fragment, null, items.map(function (value) {
    return /*#__PURE__*/React.createElement(Column, {
      key: value
    }, /*#__PURE__*/React.createElement(Item, null, /*#__PURE__*/React.createElement(ContentLoader, null)), /*#__PURE__*/React.createElement(ItemLong, null, /*#__PURE__*/React.createElement(ContentLoader, null)), /*#__PURE__*/React.createElement(ItemShort, null, /*#__PURE__*/React.createElement(ContentLoader, null)), /*#__PURE__*/React.createElement(Item, null, /*#__PURE__*/React.createElement(ContentLoader, null)), /*#__PURE__*/React.createElement(Item, null, /*#__PURE__*/React.createElement(ContentLoader, null)));
  }));
}

function MobileItemSet() {
  var items = Array.from(Array(6).keys());
  return /*#__PURE__*/React.createElement(React.Fragment, null, items.map(function (value) {
    return /*#__PURE__*/React.createElement(MobileItem, {
      key: value
    }, /*#__PURE__*/React.createElement(MobileItemInner, null, /*#__PURE__*/React.createElement(Left, null, /*#__PURE__*/React.createElement(ContentLoader, null)), /*#__PURE__*/React.createElement(Right, null, /*#__PURE__*/React.createElement(ContentLoader, {
      radius: "20"
    }))), /*#__PURE__*/React.createElement(Divider, null));
  }));
}

function FooterLoader() {
  return /*#__PURE__*/React.createElement(Container$1, {
    "data-testid": "footer-content-loader"
  }, /*#__PURE__*/React.createElement(ItemWrapper, null, /*#__PURE__*/React.createElement(ItemSet, null)), /*#__PURE__*/React.createElement(MobileItemWrapper, null, /*#__PURE__*/React.createElement(MobileItemSet, null)));
}

var FooterV2Wapper = function FooterV2Wapper(_ref) {
  var apiBaseUrl = _ref.apiBaseUrl,
      variation = _ref.variation;

  var _useContent = useContent({
    apiBaseUrl: apiBaseUrl,
    persistedQuery: 'footer-model-list',
    modelId: 'footer-model',
    contentId: 'footer-content',
    format: 'json',
    variation: variation
  }),
      footerData = _useContent.data,
      isLoading = _useContent.isLoading;

  if (isLoading) {
    return /*#__PURE__*/React.createElement(FooterLoader, null);
  }

  var _footerData$data$foot = footerData.data.footerModelList.items[0],
      footerLinkMenu = _footerData$data$foot.footerLinkMenu,
      footerLegalLinks = _footerData$data$foot.footerLegalLinks,
      footerSocialMediaLinks = _footerData$data$foot.footerSocialMediaLinks;
  var formattedLinkMenu = (footerLinkMenu === null || footerLinkMenu === void 0 ? void 0 : footerLinkMenu.map(function (_ref2) {
    var id = _ref2.id,
        label = _ref2.label,
        url = _ref2.url,
        items = _ref2.items;
    return {
      id: id,
      heading: label,
      url: url,
      items: items
    };
  })) || [];
  return /*#__PURE__*/React.createElement(Footer, {
    legalLinks: footerLegalLinks,
    linkMenuData: formattedLinkMenu,
    socialMediaLinks: footerSocialMediaLinks
  });
};

var FooterV2 = function FooterV2(_ref) {
  var apiBaseUrl = _ref.apiBaseUrl,
      variation = _ref.variation;
  return /*#__PURE__*/React.createElement(ErrorBoundary, {
    fallback: function fallback() {
      return null;
    }
  }, /*#__PURE__*/React.createElement(Suspense, {
    fallback: /*#__PURE__*/React.createElement(FooterLoader, null)
  }, /*#__PURE__*/React.createElement(FooterV2Wapper, {
    apiBaseUrl: apiBaseUrl,
    variation: variation
  })));
};

var _templateObject$j, _templateObject2$d;
var DEFAULT_ERROR_MESSAGE = 'This page is currently unavailable. Please try again later. Contact us if the problem persists.';
var FullWidthBox = styled(Box)(_templateObject$j || (_templateObject$j = _taggedTemplateLiteral(["\n  width: 100%;\n"])));
var AlignedText$1 = styled(Text)(_templateObject2$d || (_templateObject2$d = _taggedTemplateLiteral(["\n  text-align: center;\n"])));

var GenericErrorScreen = function GenericErrorScreen(_ref) {
  var _ref$message = _ref.message,
      message = _ref$message === void 0 ? DEFAULT_ERROR_MESSAGE : _ref$message,
      footer = _ref.footer;

  function handleTryAgainClick() {
    window.location.reload();
  }

  return /*#__PURE__*/React.createElement(FullWidthBox, {
    flexDirection: "column",
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(Text, {
    variant: "headingS",
    mb: "s3"
  }, "Sorry, something went wrong"), /*#__PURE__*/React.createElement(AlignedText$1, {
    variant: "bodyMDemi",
    mb: "s5"
  }, message), footer !== null && footer !== void 0 ? footer : /*#__PURE__*/React.createElement(Button, {
    variant: "default",
    onClick: handleTryAgainClick
  }, "Try again"));
};

var SearchButton = function SearchButton() {
  var _useHeader = useHeader(),
      isSearchBarOpen = _useHeader.isSearchBarOpen,
      setIsSearchBarOpen = _useHeader.setIsSearchBarOpen;

  var handleSearchClick = function handleSearchClick() {
    setIsSearchBarOpen(!isSearchBarOpen);
  };

  return /*#__PURE__*/React.createElement(SearchButton$1, {
    onClick: handleSearchClick,
    title: "search"
  });
};

var getSegmentUrl = function getSegmentUrl() {
  var _useSegment = useSegment(),
      isLargeBusiness = _useSegment.isLargeBusiness,
      isBusiness = _useSegment.isBusiness;

  if (isLargeBusiness) {
    return LARGE_BUSINESS_GOVT;
  }

  if (isBusiness) {
    return BUSINESS_HOME_PAGE;
  }

  return '';
};

var TRACKING_COMPLETION_DELAY_TIME = 50;
var handleSearchSubmit = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var query,
        searchBaseUrl,
        trimmedQuery,
        handleSearchRedirection,
        _args = arguments;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            query = _args.length > 0 && _args[0] !== undefined ? _args[0] : '';
            searchBaseUrl = _args.length > 1 && _args[1] !== undefined ? _args[1] : '';
            trimmedQuery = query.trim();

            if (!(trimmedQuery.length > 0)) {
              _context.next = 8;
              break;
            }

            handleSearchRedirection = function handleSearchRedirection() {
              var segmentUrl = getSegmentUrl();
              var searchURL = "".concat(searchBaseUrl || segmentUrl).concat(SEARCH_PATH, "?q=").concat(encodeURIComponent(trimmedQuery));
              window.location.assign(searchURL);
            };

            _context.next = 7;
            return trackDigitalEvent({
              event: 'onsiteSearch.searchBarAction',
              w3cddl: {
                event: [{
                  eventInfo: {
                    eventName: 'On Site Search Bar Action',
                    eventAction: 'onsiteSearch.searchBarAction'
                  },
                  attributes: {
                    onsiteSearch: {
                      searchTerm: trimmedQuery
                    }
                  }
                }]
              }
            });

          case 7:
            setTimeout(handleSearchRedirection, TRACKING_COMPLETION_DELAY_TIME);

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function handleSearchSubmit() {
    return _ref.apply(this, arguments);
  };
}();

var SegmentData = {
  personal: {
    name: 'Personal',
    url: '/'
  },
  business: {
    name: 'Business',
    url: '/business'
  },
  largeBusinessAndGovernment: {
    name: 'Large Business & Government',
    url: '/online/large-business-govt'
  }
};
var getUrlWithSegment = function getUrlWithSegment(segment) {
  return SegmentData[segment].url;
};
var getNameWithSegment = function getNameWithSegment(segment) {
  return SegmentData[segment].name;
};

var isBrowser = (typeof window === "undefined" ? "undefined" : _typeof(window)) !== "undefined";

var segments = ['personal', 'business', 'largeBusinessAndGovernment'];

var onCategoryClick$1 = function onCategoryClick(categoryUrl) {
  if (categoryUrl && isBrowser) {
    window.location.assign(categoryUrl);
  }
};

var getDesktopCategories = function getDesktopCategories(content, isPersonal) {
  var _a, _b;

  return isPersonal ? (_a = content === null || content === void 0 ? void 0 : content.headerContent) === null || _a === void 0 ? void 0 : _a.personalCategoriesDesktop : (_b = content === null || content === void 0 ? void 0 : content.headerContent) === null || _b === void 0 ? void 0 : _b.businessCategoriesDesktop;
};

function HeaderComponent(_ref) {
  var content = _ref.content,
      variant = _ref.variant,
      cartCookieName = _ref.cartCookieName,
      signInURL = _ref.signInURL,
      handleMinicartClick = _ref.handleMinicartClick,
      showCart = _ref.showCart,
      showSearch = _ref.showSearch,
      onLogout = _ref.onLogout,
      onSearchSubmit = _ref.onSearchSubmit,
      _ref$primaryOptions = _ref.primaryOptions,
      primaryOptions = _ref$primaryOptions === void 0 ? DEFAULT_AUTHENTICATED_PRIMARY_OPTIONS : _ref$primaryOptions,
      isMinicartOpen = _ref.isMinicartOpen,
      handleMinicartClose = _ref.handleMinicartClose,
      hideGoToCart = _ref.hideGoToCart,
      handleGoToCartClick = _ref.handleGoToCartClick,
      selectedSegment = _ref.segment,
      shouldDisplayRemoveButton = _ref.shouldDisplayRemoveButton,
      searchBaseUrl = _ref.searchBaseUrl;

  var _a, _b;

  var _useLogout = useLogout(),
      logoutAndRedirectToHome = _useLogout.logoutAndRedirectToHome;

  var isPersonalSegmentSelected = selectedSegment === 'personal';
  var isBusiness = selectedSegment === 'business';
  var brandLogoHref = PERSONAL_HOME_PAGE;
  var unauthenticatedMenuOptions = DEFAULT_UNAUTHENTICATED_MENU_OPTIONS;

  if (isBusiness) {
    brandLogoHref = BUSINESS_HOME_PAGE;
    unauthenticatedMenuOptions = DEFAULT_UNAUTHENTICATED_SME_MENU_OPTIONS;
  }

  var handleClick = function handleClick(event, value) {
    event.preventDefault();
    var url = getUrlWithSegment(value);

    if (url === null) {
      // The user is already in the correct segment don't redirect
      return;
    }

    window.location.assign(url);
  };

  var handleCartClick = function handleCartClick() {
    if (isBrowser && selectedSegment === 'business') {
      window.location.assign(CART_SME_PAGE);
    }

    if (isBrowser && selectedSegment === 'personal') {
      window.location.assign(CART_PAGE);
    }
  };

  var handleLogout = function handleLogout() {
    if (onLogout) {
      onLogout();
    }

    logoutAndRedirectToHome();
  };

  var MENU_ITEMS_PAGES = [{
    code: 'account',
    page: MYSPARK_HOME_PAGE
  }, {
    code: 'settings',
    page: SPARK_ID_SETTINGS_PAGE
  }, {
    code: 'signout',
    page: '',
    action: 'signout'
  }, {
    code: 'signin',
    page: signInURL
  }, {
    code: 'payabill',
    page: PAY_BILL_PAGE
  }, {
    code: 'topup',
    page: TOP_UP_PAGE
  }, {
    code: 'usage',
    page: MYSPARK_USAGE_PAGE
  }, {
    code: 'billing',
    page: MYSPARK_BILLING_PAGE
  }, {
    code: 'profile',
    page: MYSPARK_PROFILE_PAGE
  }];

  var onProfileMenuClick = function onProfileMenuClick(linkCode) {
    var menuItem = MENU_ITEMS_PAGES.find(function (item) {
      return item.code === linkCode;
    });

    if (menuItem === null || menuItem === void 0 ? void 0 : menuItem.page) {
      window.location.assign(menuItem.page);
    }

    if ((menuItem === null || menuItem === void 0 ? void 0 : menuItem.action) && (menuItem === null || menuItem === void 0 ? void 0 : menuItem.action) === 'signout') {
      trackCustomLink('Sign Out');
      handleLogout();
    }
  };

  var _useGlobalUser = useGlobalUser(),
      _useGlobalUser$authen = _useGlobalUser.authenticatedInfo,
      isLoggedIn = _useGlobalUser$authen.isLoggedIn,
      isGuest = _useGlobalUser$authen.isGuest,
      profile = _useGlobalUser$authen.profile;

  var showAuthenticatedProfileMenu = isLoggedIn && !isGuest;

  if (!content) {
    return null;
  }

  var customLinkCallback = function customLinkCallback(linkCode) {
    return function () {
      return trackCustomLink(linkCode);
    };
  };

  var handleSearch = function handleSearch(query) {
    handleSearchSubmit(query, searchBaseUrl);
  };

  return /*#__PURE__*/React.createElement(Header$2, {
    variant: variant || 'positive',
    profile: showAuthenticatedProfileMenu ? {
      firstName: (profile === null || profile === void 0 ? void 0 : profile.firstName) || '',
      lastName: (profile === null || profile === void 0 ? void 0 : profile.lastName) || '',
      profileNotifications: 0,
      src: undefined
    } : null,
    isStickyNavigation: true,
    onBurgerClose: customLinkCallback('Menu Close'),
    onBurgerOpen: customLinkCallback('Menu Open'),
    onSearchSubmit: onSearchSubmit !== null && onSearchSubmit !== void 0 ? onSearchSubmit : handleSearch,
    searchUrl: searchBaseUrl,
    components: {
      BrandLogo: /*#__PURE__*/React.createElement(LinkRegion, {
        regionId: "mainNav.".concat(selectedSegment)
      }, /*#__PURE__*/React.createElement(BrandLogo, {
        href: brandLogoHref,
        title: "Spark"
      })),
      SegmentSwitcher: /*#__PURE__*/React.createElement(HeaderSegmentSwitcher, null, segments.map(function (segment) {
        return /*#__PURE__*/React.createElement(LinkRegion, {
          key: segment,
          regionId: "globalNav.".concat(selectedSegment)
        }, /*#__PURE__*/React.createElement(HeaderSegmentSwitcherItem, {
          selected: segment === selectedSegment,
          onClick: function onClick(event) {
            return handleClick(event, segment);
          }
        }, getNameWithSegment(segment)));
      })),
      HeaderCategories: /*#__PURE__*/React.createElement(LinkRegion, {
        regionId: "mainNav.".concat(selectedSegment)
      }, /*#__PURE__*/React.createElement(MediaQuery, {
        max: "slim"
      }, /*#__PURE__*/React.createElement(HeaderCategories, {
        selectedSegment: selectedSegment
      }, isPersonalSegmentSelected ? /*#__PURE__*/React.createElement(PersonalCategoriesContainer, null, /*#__PURE__*/React.createElement(HeaderCategoryList, {
        categories: (_a = content === null || content === void 0 ? void 0 : content.headerContent) === null || _a === void 0 ? void 0 : _a.personalCategories,
        onCategoryClick: onCategoryClick$1
      })) : /*#__PURE__*/React.createElement(BusinessCategoriesContainer, null, /*#__PURE__*/React.createElement(HeaderCategoryList, {
        categories: (_b = content === null || content === void 0 ? void 0 : content.headerContent) === null || _b === void 0 ? void 0 : _b.businessCategories,
        onCategoryClick: onCategoryClick$1
      })))), /*#__PURE__*/React.createElement(MediaQuery, {
        min: "big"
      }, /*#__PURE__*/React.createElement(HeaderCategories, {
        selectedSegment: selectedSegment
      }, /*#__PURE__*/React.createElement(HeaderCategoriesContainer, null, /*#__PURE__*/React.createElement(HeaderCategoryList, {
        categories: getDesktopCategories(content, isPersonalSegmentSelected),
        onCategoryClick: onCategoryClick$1
      }))))),
      SearchButton: showSearch ? /*#__PURE__*/React.createElement(LinkRegion, {
        regionId: "utilityNav.".concat(selectedSegment)
      }, /*#__PURE__*/React.createElement(SearchButton, null)) : null,
      CartButton: showCart ? /*#__PURE__*/React.createElement(HeaderCartButton, {
        cartCookieName: cartCookieName,
        handleMinicartClick: handleMinicartClick,
        isMinicartOpen: isMinicartOpen,
        handleMinicartClose: handleMinicartClose,
        hideGoToCart: hideGoToCart,
        handleGoToCartClick: handleGoToCartClick,
        segment: selectedSegment,
        handleCartClick: handleCartClick,
        shouldDisplayRemoveButton: shouldDisplayRemoveButton
      }) : null,
      ProfilePill: /*#__PURE__*/React.createElement(LinkRegion, {
        regionId: "utilityNav.".concat(selectedSegment)
      }, /*#__PURE__*/React.createElement(ProfilePill, {
        onOpen: customLinkCallback('MySpark Menu Open'),
        onClose: customLinkCallback('MySpark Menu Close')
      }, /*#__PURE__*/React.createElement(LinkRegion, {
        regionId: "mySparkMenu"
      }, showAuthenticatedProfileMenu ? /*#__PURE__*/React.createElement(Box, {
        mr: "s2"
      }, /*#__PURE__*/React.createElement(AuthenticatedProfileMenu, {
        authenticatedPrimaryMenuOptions: primaryOptions,
        authenticatedSecondaryMenuOptions: DEFAULT_AUTHENTICATED_SECONDARY_OPTIONS,
        onClick: onProfileMenuClick
      })) : /*#__PURE__*/React.createElement(Box, {
        mr: "s0_5"
      }, /*#__PURE__*/React.createElement(UnauthenticatedProfileMenu, {
        unauthenticatedMenuOptions: unauthenticatedMenuOptions,
        onClick: onProfileMenuClick
      })))))
    }
  });
}

var _HeaderSpaContentQuery;
var headerSpaContentQuery = _HeaderSpaContentQuery !== void 0 ? _HeaderSpaContentQuery : (_HeaderSpaContentQuery = require("./__generated__/HeaderSpaContentQuery.graphql"), _HeaderSpaContentQuery.hash && _HeaderSpaContentQuery.hash !== "5bbfa3c794ac77aac52776581431baff" && console.error("The definition of 'HeaderSpaContentQuery' appears to have changed. Run `relay-compiler` to update the generated files to receive the expected data."), _HeaderSpaContentQuery);

function Header(_a) {
  var _a$headerId = _a.headerId,
      headerId = _a$headerId === void 0 ? DEFAULT_HEADER_ID : _a$headerId,
      headerSite = _a.headerSite,
      props = __rest(_a, ["headerId", "headerSite"]);

  var _useSegment = useSegment(),
      segment = _useSegment.segment;

  var content = useLazyLoadQuery$1(headerSpaContentQuery, {
    id: headerId,
    site: headerSite
  });
  return /*#__PURE__*/React.createElement(HeaderComponent, Object.assign({}, props, {
    content: content,
    segment: segment
  }));
}

function HeaderSpa(_ref) {
  var headerId = _ref.headerId,
      headerSite = _ref.headerSite,
      variant = _ref.variant,
      cartCookieName = _ref.cartCookieName,
      signInURL = _ref.signInURL,
      onLogout = _ref.onLogout,
      onSearchSubmit = _ref.onSearchSubmit,
      handleMinicartClick = _ref.handleMinicartClick,
      _ref$showCart = _ref.showCart,
      showCart = _ref$showCart === void 0 ? true : _ref$showCart,
      _ref$showSearch = _ref.showSearch,
      showSearch = _ref$showSearch === void 0 ? true : _ref$showSearch,
      _ref$shouldDisplayRem = _ref.shouldDisplayRemoveButton,
      shouldDisplayRemoveButton = _ref$shouldDisplayRem === void 0 ? false : _ref$shouldDisplayRem,
      primaryOptions = _ref.primaryOptions,
      isMinicartOpen = _ref.isMinicartOpen,
      handleMinicartClose = _ref.handleMinicartClose,
      hideGoToCart = _ref.hideGoToCart,
      handleGoToCartClick = _ref.handleGoToCartClick,
      searchBaseUrl = _ref.searchBaseUrl;
  return /*#__PURE__*/React.createElement(ErrorBoundary, {
    fallback: function fallback() {
      return null;
    }
  }, /*#__PURE__*/React.createElement(Suspense, {
    fallback: /*#__PURE__*/React.createElement(HeaderLoader, null)
  }, /*#__PURE__*/React.createElement(SnackbarProvider, null, /*#__PURE__*/React.createElement(Header, {
    headerId: headerId,
    headerSite: headerSite,
    variant: variant,
    cartCookieName: cartCookieName,
    signInURL: signInURL,
    onLogout: onLogout,
    onSearchSubmit: onSearchSubmit,
    handleMinicartClick: handleMinicartClick,
    showCart: showCart,
    showSearch: showSearch,
    shouldDisplayRemoveButton: shouldDisplayRemoveButton,
    primaryOptions: primaryOptions,
    isMinicartOpen: isMinicartOpen,
    handleMinicartClose: handleMinicartClose,
    hideGoToCart: hideGoToCart,
    handleGoToCartClick: handleGoToCartClick,
    searchBaseUrl: searchBaseUrl
  }))));
}

function HeaderCategoryListV2(_ref) {
  var categories = _ref.categories,
      onCategoryClick = _ref.onCategoryClick;

  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      selectedCategory = _useState2[0],
      setSelectedCategory = _useState2[1];

  var handleCategoryClick = function handleCategoryClick(url, label, optionList) {
    setSelectedCategory(label);
    trackCustomLink(label);

    if (optionList.length === 0) {
      onCategoryClick(url);
    }
  };

  var renderWithLinkRegion = function renderWithLinkRegion(regionId, children) {
    return /*#__PURE__*/React.createElement(LinkRegion, {
      regionId: regionId
    }, children);
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, categories.map(function (_ref2) {
    var label = _ref2.label,
        iconPath = _ref2.iconPath,
        url = _ref2.url,
        options = _ref2.options,
        viewAllFooterLink = _ref2.viewAllFooterLink;
    return /*#__PURE__*/React.createElement(HeaderCategoryV2, {
      key: label,
      isSelected: label === selectedCategory,
      onCategoryClick: function onCategoryClick() {
        handleCategoryClick(url, label, options);
      },
      iconPath: iconPath,
      optionList: options,
      tier1FooterLink: {
        url: viewAllFooterLink.url,
        label: viewAllFooterLink.label
      },
      renderTier1: function renderTier1(_ref3) {
        var children = _ref3.children;
        return renderWithLinkRegion("nav.".concat(selectedCategory), children);
      },
      renderTier2: function renderTier2(_ref4) {
        var children = _ref4.children,
            selectedOption = _ref4.selectedOption;
        return renderWithLinkRegion("".concat(selectedCategory, ".").concat(selectedOption.name), children);
      },
      renderTier1FooterLink: function renderTier1FooterLink(_ref5) {
        var children = _ref5.children;
        return renderWithLinkRegion("nav.".concat(selectedCategory), children);
      },
      renderHeaderCategory: function renderHeaderCategory(_ref6) {
        var children = _ref6.children;
        return renderWithLinkRegion("mainNav.".concat(selectedCategory), children);
      }
    }, label);
  }));
}

var MobileHeaderCategoryList = function MobileHeaderCategoryList(_ref) {
  var categories = _ref.categories,
      selectedCategory = _ref.selectedCategory,
      setSelectedCategory = _ref.setSelectedCategory,
      isMobileMegaMenuOpen = _ref.isMobileMegaMenuOpen,
      setIsMobileMegaMenuOpen = _ref.setIsMobileMegaMenuOpen,
      _onCategoryClick = _ref.onCategoryClick;

  var _a;

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      currentExpandedItems = _useState2[0],
      setCurrentExpandedItems = _useState2[1];

  var _useTheme = useTheme(),
      palette = _useTheme.palette;

  var selectedOptionListToShow = (_a = categories.filter(function (item) {
    return item.label === selectedCategory;
  })[0]) === null || _a === void 0 ? void 0 : _a.options;

  var handleMobileCategoryClick = function handleMobileCategoryClick(label) {
    setSelectedCategory(label);
    trackCustomLink(label);
    setIsMobileMegaMenuOpen(true);
  };

  var handleMobileMegaMenuClick = function handleMobileMegaMenuClick(url, name) {
    if (_onCategoryClick) {
      _onCategoryClick(url);

      setSelectedCategory(name);
    }
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, isMobileMegaMenuOpen ? selectedOptionListToShow === null || selectedOptionListToShow === void 0 ? void 0 : selectedOptionListToShow.map(function (_ref2) {
    var name = _ref2.name,
        subOptions = _ref2.subOptions,
        url = _ref2.url;
    var isOpen = currentExpandedItems.includes(name);

    if (subOptions && subOptions.length > 0) {
      return /*#__PURE__*/React.createElement(LinkRegion, {
        regionId: "nav.".concat(selectedCategory)
      }, /*#__PURE__*/React.createElement(HeaderAccordion, {
        key: name,
        allowMultipleExpanded: false,
        onChange: function onChange(expandedItems) {
          setCurrentExpandedItems(expandedItems);
          trackCustomLink(name);
        }
      }, /*#__PURE__*/React.createElement(HeaderAccordionItem, {
        key: name,
        uuid: name,
        isOpen: isOpen
      }, /*#__PURE__*/React.createElement(HeaderAccordionItemHeading, null, name, /*#__PURE__*/React.createElement(HeaderAccordionButton, {
        iconName: "chevron_down_small",
        iconColor: palette.baseColors.wairua
      })), /*#__PURE__*/React.createElement(HeaderAccordionItemBodyWithAnimation, {
        isOpen: isOpen
      }, subOptions === null || subOptions === void 0 ? void 0 : subOptions.map(function (subOption) {
        return /*#__PURE__*/React.createElement(LinkRegion, {
          regionId: "".concat(selectedCategory, ".").concat(name)
        }, /*#__PURE__*/React.createElement(HeaderCategoryV2, {
          key: subOption.name,
          isSelected: subOption.name === selectedCategory,
          onCategoryClick: function onCategoryClick() {
            trackCustomLink(subOption.name);
            handleMobileMegaMenuClick(subOption.url, name);
          },
          isInHeaderAccordion: true,
          isMobileMegaMenuOpen: true
        }, subOption.name));
      })))));
    }

    return /*#__PURE__*/React.createElement(LinkRegion, {
      regionId: "nav.".concat(selectedCategory)
    }, /*#__PURE__*/React.createElement(HeaderCategoryV2, {
      key: name,
      isSelected: name === selectedCategory,
      onCategoryClick: function onCategoryClick() {
        handleMobileMegaMenuClick(url, name);
      },
      isMobileMegaMenuOpen: true
    }, name));
  }) :
  /* Mega Menu not open, display regular categories */
  categories.map(function (_ref3) {
    var label = _ref3.label,
        url = _ref3.url,
        iconPath = _ref3.iconPath,
        options = _ref3.options,
        viewAllFooterLink = _ref3.viewAllFooterLink;
    return /*#__PURE__*/React.createElement(HeaderCategoryV2, {
      key: label,
      isSelected: label === selectedCategory,
      onCategoryClick: function onCategoryClick() {
        return (options === null || options === void 0 ? void 0 : options.length) > 0 ? handleMobileCategoryClick(label) : _onCategoryClick(url);
      },
      iconPath: iconPath,
      optionList: options,
      tier1FooterLink: {
        url: viewAllFooterLink.url,
        label: viewAllFooterLink.url
      }
    }, label);
  }));
};

var onCategoryClick = function onCategoryClick(categoryUrl) {
  if (categoryUrl) {
    window.location.assign(categoryUrl);
  }
};

var HeaderV2Wrapper = function HeaderV2Wrapper(headerProps) {
  var _a, _b, _c;

  var apiBaseUrl = headerProps.apiBaseUrl,
      contentId = headerProps.contentId,
      modelVariation = headerProps.modelVariation,
      variant = headerProps.variant,
      cartCookieName = headerProps.cartCookieName,
      signInURL = headerProps.signInURL,
      handleMinicartClick = headerProps.handleMinicartClick,
      onSearchSubmit = headerProps.onSearchSubmit,
      onLogout = headerProps.onLogout,
      isMinicartOpen = headerProps.isMinicartOpen,
      handleMinicartClose = headerProps.handleMinicartClose,
      handleGoToCartClick = headerProps.handleGoToCartClick,
      hideGoToCart = headerProps.hideGoToCart,
      shouldDisplayRemoveButton = headerProps.shouldDisplayRemoveButton,
      showCart = headerProps.showCart,
      searchBaseUrl = headerProps.searchBaseUrl;

  var _useContent = useContent({
    apiBaseUrl: apiBaseUrl,
    modelId: 'header-model',
    contentId: contentId,
    format: 'json',
    variation: modelVariation,
    persistedQuery: 'header-list'
  }),
      contentForHeader = _useContent.data,
      isLoading = _useContent.isLoading;

  var _useGlobalUser = useGlobalUser(),
      _useGlobalUser$authen = _useGlobalUser.authenticatedInfo,
      isLoggedIn = _useGlobalUser$authen.isLoggedIn,
      isGuest = _useGlobalUser$authen.isGuest,
      profile = _useGlobalUser$authen.profile;

  var _useState = useState(''),
      _useState2 = _slicedToArray(_useState, 2),
      selectedCategory = _useState2[0],
      setSelectedCategory = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isMobileMegaMenuOpen = _useState4[0],
      setIsMobileMegaMenuOpen = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      isHeaderFilterBottomSheetOpen = _useState6[0],
      setHeaderFilterBottomSheetOpen = _useState6[1];

  if (isLoading) {
    return /*#__PURE__*/React.createElement(HeaderLoader, null);
  }

  if (!contentForHeader) {
    return null;
  }

  var handleClick = function handleClick(event, selectedUrl) {
    event.preventDefault();

    if (selectedUrl === null) {
      return;
    }

    window.location.assign(selectedUrl);
  };

  var data = contentForHeader.data; // This is needed as Kong intermittently returns empty objects instead of empty arrays

  var forceArray = function forceArray(content) {
    return Array.isArray(content) ? content : [];
  };

  var desktopCategories = ((_b = (_a = data.categories.items[0]) === null || _a === void 0 ? void 0 : _a.tierOne) === null || _b === void 0 ? void 0 : _b.map(function (category) {
    var _a;

    return {
      isSelected: true,
      label: category.name,
      iconPath: (_a = category === null || category === void 0 ? void 0 : category.icon) === null || _a === void 0 ? void 0 : _a._path,
      url: category.url || undefined,
      viewAllFooterLink: {
        url: category.viewAllUrl,
        label: category.viewAllName
      },
      options: forceArray(category === null || category === void 0 ? void 0 : category.tierTwo).map(function (tierTwoCategory) {
        return {
          name: tierTwoCategory.name,
          url: tierTwoCategory.url,
          description: tierTwoCategory.description || '',
          subOptions: forceArray(tierTwoCategory === null || tierTwoCategory === void 0 ? void 0 : tierTwoCategory.tierThree).map(function (tierThreeCategory) {
            return {
              name: tierThreeCategory.name,
              url: tierThreeCategory.url,
              description: tierThreeCategory.description || ''
            };
          })
        };
      })
    };
  })) || [];
  var _data$segments$items$ = data.segments.items[0],
      showCartOption = _data$segments$items$.showCartOption,
      showSearchOption = _data$segments$items$.showSearchOption,
      showSignInButton = _data$segments$items$.showSignInButton,
      showProfileOption = _data$segments$items$.showProfileOption,
      selectedSegment = _data$segments$items$.selectedSegment,
      profileName = _data$segments$items$.profileName,
      segments = _data$segments$items$.segments,
      brandLogoUrl = _data$segments$items$.brandLogoUrl,
      authenticatedProfileMenu = _data$segments$items$.authenticatedProfileMenu,
      unauthenticatedProfileMenu = _data$segments$items$.unauthenticatedProfileMenu;
  var showAuthenticatedProfileMenu = isLoggedIn && !isGuest && showSignInButton;

  var handleCartClick = function handleCartClick() {
    if (selectedSegment === 'Business') {
      window.location.assign(CART_SME_PAGE);
    }

    if (selectedSegment === 'Personal') {
      window.location.assign(CART_PAGE);
    }
  };

  var customLinkCallback = function customLinkCallback(linkCode) {
    return function () {
      return trackCustomLink(linkCode);
    };
  };

  var iconToShowInMobileMegaMenu = (_c = desktopCategories === null || desktopCategories === void 0 ? void 0 : desktopCategories.filter(function (item) {
    return item.label === selectedCategory;
  })[0]) === null || _c === void 0 ? void 0 : _c.iconPath;
  var isCartButtonVisible = showCart && showCartOption;
  var hasSegmentSwitcher = segments.length > 0;
  var showMagicBurger = data.categories.items.length > 0;

  var handleSearch = function handleSearch(query) {
    handleSearchSubmit(query, searchBaseUrl);
  };

  return /*#__PURE__*/React.createElement(Header$2, {
    variant: variant || 'positive',
    profile: showAuthenticatedProfileMenu ? {
      firstName: (profile === null || profile === void 0 ? void 0 : profile.firstName) || '',
      lastName: (profile === null || profile === void 0 ? void 0 : profile.lastName) || '',
      profileNotifications: 0
    } : null,
    renderMagicBurger: function renderMagicBurger(_ref) {
      var children = _ref.children;
      return /*#__PURE__*/React.createElement(LinkRegion, {
        regionId: "utilityNav.".concat(selectedSegment)
      }, children);
    },
    isStickyNavigation: true,
    onBurgerClose: customLinkCallback('Menu Close'),
    onBurgerOpen: customLinkCallback('Menu Open'),
    isHeaderV2: true,
    showOverlayGradient: !isHeaderFilterBottomSheetOpen,
    hasSegmentSwitcher: hasSegmentSwitcher,
    showMagicBurger: showMagicBurger,
    searchUrl: searchBaseUrl,
    components: {
      BrandLogo: /*#__PURE__*/React.createElement(LinkRegion, {
        regionId: "mainNav.".concat(selectedSegment)
      }, /*#__PURE__*/React.createElement(BrandLogo, {
        href: brandLogoUrl,
        title: "Spark"
      })),
      SegmentSwitcher: /*#__PURE__*/React.createElement(SegmentSwitcherV2, {
        isMobileMegaMenuOpen: isMobileMegaMenuOpen,
        selectedCategory: selectedCategory,
        iconToShowInMobileMegaMenu: iconToShowInMobileMegaMenu,
        setIsMobileMegaMenuOpen: setIsMobileMegaMenuOpen,
        selectedSegment: selectedSegment,
        brandLogoUrl: brandLogoUrl,
        isHeaderFilterBottomSheetOpen: isHeaderFilterBottomSheetOpen,
        setHeaderFilterBottomSheetOpen: setHeaderFilterBottomSheetOpen,
        customLinkCallback: customLinkCallback,
        onCategoryClick: onCategoryClick,
        segments: forceArray(segments),
        handleClick: handleClick
      }),
      HeaderCategories: /*#__PURE__*/React.createElement(LinkRegion, {
        regionId: "mainNav.".concat(selectedSegment)
      }, /*#__PURE__*/React.createElement(MediaQuery, {
        max: "slim"
      }, /*#__PURE__*/React.createElement(HeaderCategories, {
        selectedSegment: selectedSegment
      }, /*#__PURE__*/React.createElement(HeaderCategoriesContainer, null, /*#__PURE__*/React.createElement(MobileHeaderCategoryList, {
        categories: desktopCategories,
        onCategoryClick: onCategoryClick,
        selectedCategory: selectedCategory,
        setSelectedCategory: setSelectedCategory,
        isMobileMegaMenuOpen: isMobileMegaMenuOpen,
        setIsMobileMegaMenuOpen: setIsMobileMegaMenuOpen
      })))), /*#__PURE__*/React.createElement(MediaQuery, {
        min: "big"
      }, /*#__PURE__*/React.createElement(HeaderCategories, {
        selectedSegment: selectedSegment
      }, /*#__PURE__*/React.createElement(HeaderCategoriesContainer, null, /*#__PURE__*/React.createElement(HeaderCategoryListV2, {
        categories: desktopCategories,
        onCategoryClick: onCategoryClick
      }))))),
      SearchBar: /*#__PURE__*/React.createElement(LinkRegion, {
        regionId: "searchDropdown"
      }, /*#__PURE__*/React.createElement(SearchBar, {
        onSearchSubmit: onSearchSubmit !== null && onSearchSubmit !== void 0 ? onSearchSubmit : handleSearch,
        searchUrl: searchBaseUrl
      })),
      SearchButton: showSearchOption ? /*#__PURE__*/React.createElement(LinkRegion, {
        regionId: "utilityNav.".concat(selectedSegment)
      }, /*#__PURE__*/React.createElement(SearchButton, null)) : null,
      CartButton: isCartButtonVisible ? /*#__PURE__*/React.createElement(HeaderCartButton, {
        cartCookieName: cartCookieName,
        handleMinicartClick: handleMinicartClick,
        isMinicartOpen: isMinicartOpen,
        handleMinicartClose: handleMinicartClose,
        hideGoToCart: hideGoToCart,
        handleGoToCartClick: handleGoToCartClick,
        segment: selectedSegment,
        handleCartClick: handleCartClick,
        shouldDisplayRemoveButton: shouldDisplayRemoveButton
      }) : null,
      ProfilePill: showProfileOption ? /*#__PURE__*/React.createElement(ProfilePillV2, {
        selectedSegment: selectedSegment,
        customLinkCallback: customLinkCallback,
        profileName: profileName,
        showAuthenticatedProfileMenu: showAuthenticatedProfileMenu,
        authenticatedProfileMenu: authenticatedProfileMenu,
        unauthenticatedProfileMenu: unauthenticatedProfileMenu,
        showSignInButton: showSignInButton,
        signInURL: signInURL,
        onLogout: onLogout,
        forceArray: forceArray
      }) : null
    }
  });
};

var SegmentSwitcherV2 = function SegmentSwitcherV2(_ref) {
  var isMobileMegaMenuOpen = _ref.isMobileMegaMenuOpen,
      selectedCategory = _ref.selectedCategory,
      iconToShowInMobileMegaMenu = _ref.iconToShowInMobileMegaMenu,
      setIsMobileMegaMenuOpen = _ref.setIsMobileMegaMenuOpen,
      selectedSegment = _ref.selectedSegment,
      brandLogoUrl = _ref.brandLogoUrl,
      isHeaderFilterBottomSheetOpen = _ref.isHeaderFilterBottomSheetOpen,
      setHeaderFilterBottomSheetOpen = _ref.setHeaderFilterBottomSheetOpen,
      customLinkCallback = _ref.customLinkCallback,
      onCategoryClick = _ref.onCategoryClick,
      segments = _ref.segments,
      handleClick = _ref.handleClick;

  var _useTheme = useTheme(),
      palette = _useTheme.palette;

  var segmentsForFilterDropdown = segments.map(function (segment) {
    return {
      id: segment.name,
      label: segment.name,
      value: segment.url
    };
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(MediaQuery, {
    max: "slim"
  }, isMobileMegaMenuOpen ? /*#__PURE__*/React.createElement(LinkRegion, {
    regionId: "nav.".concat(selectedCategory)
  }, /*#__PURE__*/React.createElement(MobileMegaMenuBackButton, {
    iconPath: iconToShowInMobileMegaMenu,
    onMobileMegaMenuBackButtonClick: function onMobileMegaMenuBackButtonClick() {
      setIsMobileMegaMenuOpen(false);
      trackCustomLink('Nav Back button');
    }
  }, selectedCategory)) : /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(LinkRegion, {
    regionId: "mainNav.".concat(selectedSegment)
  }, /*#__PURE__*/React.createElement(BrandLogo, {
    overrideColour: palette.baseColors.wairua,
    href: brandLogoUrl,
    title: "Spark"
  })), /*#__PURE__*/React.createElement(Box, {
    pb: "s3",
    pt: "s3"
  }, /*#__PURE__*/React.createElement(LinkRegion, {
    regionId: "globalNav"
  }, /*#__PURE__*/React.createElement(HeaderFilterDropdown, {
    placeholder: selectedSegment,
    isHeaderFilterBottomSheetOpen: isHeaderFilterBottomSheetOpen,
    setHeaderFilterBottomSheetOpen: setHeaderFilterBottomSheetOpen,
    onOpen: customLinkCallback('Segment Switcher Open'),
    onClose: customLinkCallback('Segment Switcher Close')
  }, /*#__PURE__*/React.createElement(HeaderFilterMenu, {
    MenuItems: segmentsForFilterDropdown,
    onClick: onCategoryClick
  })))))), /*#__PURE__*/React.createElement(MediaQuery, {
    min: "big"
  }, /*#__PURE__*/React.createElement(HeaderSegmentSwitcher, null, segments.map(function (segment) {
    return /*#__PURE__*/React.createElement(LinkRegion, {
      key: segment.name,
      regionId: "globalNav.".concat(selectedSegment)
    }, /*#__PURE__*/React.createElement(HeaderSegmentSwitcherItem, {
      selected: segment.name === selectedSegment,
      onClick: function onClick(event) {
        return handleClick(event, segment.url);
      }
    }, segment.name));
  }))));
};

var ProfilePillV2 = function ProfilePillV2(_ref) {
  var selectedSegment = _ref.selectedSegment,
      customLinkCallback = _ref.customLinkCallback,
      profileName = _ref.profileName,
      showAuthenticatedProfileMenu = _ref.showAuthenticatedProfileMenu,
      authenticatedProfileMenu = _ref.authenticatedProfileMenu,
      unauthenticatedProfileMenu = _ref.unauthenticatedProfileMenu,
      showSignInButton = _ref.showSignInButton,
      signInURL = _ref.signInURL,
      onLogout = _ref.onLogout,
      forceArray = _ref.forceArray;

  var _useLogout = useLogout(),
      logoutAndRedirectToHome = _useLogout.logoutAndRedirectToHome;

  var handleLogout = function handleLogout() {
    if (onLogout) {
      onLogout();
    }

    logoutAndRedirectToHome();
  };

  var onProfileMenuClick = function onProfileMenuClick(linkCode) {
    if (linkCode === 'signout') {
      trackCustomLink('Sign out');
      handleLogout();
    } else if (linkCode === 'signin') {
      trackCustomLink('Sign in');
      window.location.assign(signInURL);
    } else {
      window.location.assign(linkCode);
    }
  };

  var authenticatedMenuOptionsPrimary = forceArray(authenticatedProfileMenu.primary);
  var authenticatedMenuOptionsSecondary = forceArray(authenticatedProfileMenu.secondary);
  var unauthenticatedMenuOptionsPrimary = forceArray(unauthenticatedProfileMenu.primary);
  var unauthenticatedMenuOptionsSecondary = forceArray(unauthenticatedProfileMenu.secondary);
  var unauthenticatedMenuOptions = unauthenticatedMenuOptionsPrimary.concat(unauthenticatedMenuOptionsSecondary);
  return /*#__PURE__*/React.createElement(LinkRegion, {
    regionId: "utilityNav.".concat(selectedSegment)
  }, /*#__PURE__*/React.createElement(ProfilePill, {
    onOpen: customLinkCallback("".concat(profileName, " Menu Open") || 'MySpark Menu Open'),
    onClose: customLinkCallback("".concat(profileName, " Menu Close") || 'MySpark Menu Close'),
    text: profileName
  }, /*#__PURE__*/React.createElement(LinkRegion, {
    regionId: "profileMenu.".concat(selectedSegment)
  }, showAuthenticatedProfileMenu ? /*#__PURE__*/React.createElement(Box, {
    mr: "s2"
  }, /*#__PURE__*/React.createElement(AuthenticatedProfileMenu, {
    authenticatedPrimaryMenuOptions: authenticatedMenuOptionsPrimary,
    authenticatedSecondaryMenuOptions: authenticatedMenuOptionsSecondary,
    onClick: onProfileMenuClick
  })) : /*#__PURE__*/React.createElement(Box, {
    mr: "s0_5"
  }, /*#__PURE__*/React.createElement(UnauthenticatedProfileMenu, {
    unauthenticatedMenuOptions: unauthenticatedMenuOptions,
    onClick: onProfileMenuClick,
    showSignInButton: showSignInButton
  })))));
};

var HeaderV2 = function HeaderV2(_ref) {
  var apiBaseUrl = _ref.apiBaseUrl,
      contentId = _ref.contentId,
      modelVariation = _ref.modelVariation,
      variant = _ref.variant,
      cartCookieName = _ref.cartCookieName,
      signInURL = _ref.signInURL,
      onLogout = _ref.onLogout,
      onSearchSubmit = _ref.onSearchSubmit,
      handleMinicartClick = _ref.handleMinicartClick,
      primaryOptions = _ref.primaryOptions,
      isMinicartOpen = _ref.isMinicartOpen,
      handleMinicartClose = _ref.handleMinicartClose,
      handleGoToCartClick = _ref.handleGoToCartClick,
      hideGoToCart = _ref.hideGoToCart,
      _ref$showCart = _ref.showCart,
      showCart = _ref$showCart === void 0 ? true : _ref$showCart,
      shouldDisplayRemoveButton = _ref.shouldDisplayRemoveButton,
      showMagicBurger = _ref.showMagicBurger,
      searchBaseUrl = _ref.searchBaseUrl;
  return /*#__PURE__*/React.createElement(ErrorBoundary, {
    fallback: function fallback() {
      return null;
    }
  }, /*#__PURE__*/React.createElement(Suspense, {
    fallback: /*#__PURE__*/React.createElement(HeaderLoader, null)
  }, /*#__PURE__*/React.createElement(HeaderV2Wrapper, {
    apiBaseUrl: apiBaseUrl,
    contentId: contentId,
    modelVariation: modelVariation,
    variant: variant,
    cartCookieName: cartCookieName,
    signInURL: signInURL,
    onLogout: onLogout,
    handleMinicartClick: handleMinicartClick,
    primaryOptions: primaryOptions,
    onSearchSubmit: onSearchSubmit,
    showCart: showCart,
    isMinicartOpen: isMinicartOpen,
    hideGoToCart: hideGoToCart,
    handleMinicartClose: handleMinicartClose,
    handleGoToCartClick: handleGoToCartClick,
    shouldDisplayRemoveButton: shouldDisplayRemoveButton,
    showMagicBurger: showMagicBurger,
    searchBaseUrl: searchBaseUrl
  })));
};

var _templateObject$i;

function LoginJourney(_ref) {
  var onLoginSuccess = _ref.onLoginSuccess;

  var _useState = useState('signIn'),
      _useState2 = _slicedToArray(_useState, 2),
      activeJourney = _useState2[0],
      setActiveJourney = _useState2[1];

  if (activeJourney === 'forgotEmail') {
    return /*#__PURE__*/React.createElement(ForgotEmailJourney, {
      onSignInResult: function onSignInResult() {
        return setActiveJourney('signIn');
      }
    });
  }

  if (activeJourney === 'forgotPassword') {
    return /*#__PURE__*/React.createElement(ForgotPasswordJourney, {
      onSignInResult: function onSignInResult() {
        return setActiveJourney('signIn');
      },
      onForgotEmailResult: function onForgotEmailResult() {
        return setActiveJourney('forgotEmail');
      }
    });
  }

  if (activeJourney === 'signIn') {
    return /*#__PURE__*/React.createElement(LoginJourney$1, {
      onForgotPasswordResult: function onForgotPasswordResult() {
        return setActiveJourney('forgotPassword');
      },
      onLoginSuccess: onLoginSuccess,
      onRegisterResult: function onRegisterResult() {
        return setActiveJourney('register');
      }
    });
  }

  if (activeJourney === 'register') {
    return /*#__PURE__*/React.createElement(RegisterJourney, {
      onSignInResult: function onSignInResult() {
        return setActiveJourney('signIn');
      }
    });
  }

  return null;
}

var ContentContainer = styled.div(_templateObject$i || (_templateObject$i = _taggedTemplateLiteral(["\n  max-width: 312px;\n"])));
function LoginModal(_ref2) {
  var onClose = _ref2.onClose,
      onLoginSuccess = _ref2.onLoginSuccess,
      isOpen = _ref2.isOpen;
  return /*#__PURE__*/React.createElement(Modal, {
    isOpen: isOpen,
    onClose: onClose,
    showCloseButton: true
  }, /*#__PURE__*/React.createElement(ContentContainer, null, /*#__PURE__*/React.createElement(LoginJourney, {
    onLoginSuccess: onLoginSuccess
  })));
}

var _templateObject$h;
var WidgetContainer = styled.div(_templateObject$h || (_templateObject$h = _taggedTemplateLiteral(["\n  max-width: 320px;\n\n  .tw_primary-header {\n    margin: 0;\n  }\n"])));
function ForgerockLoginModal(_ref) {
  var isOpen = _ref.isOpen,
      onClose = _ref.onClose,
      onLoginSuccess = _ref.onLoginSuccess,
      config = _ref.config;
  return /*#__PURE__*/React.createElement(Modal, {
    isOpen: isOpen,
    onClose: onClose,
    showCloseButton: true
  }, /*#__PURE__*/React.createElement(WidgetContainer, {
    className: "spark"
  }, /*#__PURE__*/React.createElement(Widget, Object.assign({}, config, {
    onLoginSuccess: onLoginSuccess
  }))));
}

var _templateObject$g;
var StrikethroughText$1 = styled(Text)(_templateObject$g || (_templateObject$g = _taggedTemplateLiteral(["\n  text-decoration: line-through;\n"])));

var DiscountComparison = function DiscountComparison(_ref) {
  var currentPriceLabel = _ref.currentPriceLabel,
      currentDiscountLabel = _ref.currentDiscountLabel,
      newPriceLabel = _ref.newPriceLabel,
      newDiscountLabel = _ref.newDiscountLabel;

  var _useTheme = useTheme(),
      _useTheme$palette$bas = _useTheme.palette.baseColors,
      mawheranui = _useTheme$palette$bas.mawheranui,
      mawhero = _useTheme$palette$bas.mawhero;

  return /*#__PURE__*/React.createElement(Box, {
    flexDirection: "row",
    justifyContent: "space-between",
    mb: "s6",
    alignItems: "center"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Text, {
    variant: "footnoteDemi"
  }, "Current"), /*#__PURE__*/React.createElement(StrikethroughText$1, {
    variant: "footnoteDemi",
    color: mawheranui
  }, currentPriceLabel), /*#__PURE__*/React.createElement(StrikethroughText$1, {
    variant: "footnoteDemi",
    color: mawheranui
  }, currentDiscountLabel)), /*#__PURE__*/React.createElement(Icon, {
    name: "arrow_right_small",
    fill: mawhero
  }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Text, {
    variant: "footnoteDemi"
  }, "New"), /*#__PURE__*/React.createElement(Text, {
    variant: "bodySMedium",
    color: mawheranui
  }, newPriceLabel), /*#__PURE__*/React.createElement(Text, {
    variant: "footnoteDemi",
    color: mawhero
  }, newDiscountLabel)));
};

var ExistingPlan = function ExistingPlan(_ref) {
  var existingPlan = _ref.existingPlan;
  var currentPriceLabel = "".concat(formatNZD(existingPlan.currentPrice.effectivePrice), "/").concat(existingPlan.currentPrice.period);
  var currentDiscountLabel = existingPlan.currentPrice.discount ? "".concat(existingPlan.currentPrice.discount.appliedValue, "% savings") : 'Full price';
  var newPriceLabel = "".concat(formatNZD(existingPlan.updatedPrice.effectivePrice), "/").concat(existingPlan.updatedPrice.period);
  var newDiscountLabel = existingPlan.updatedPrice.discount ? "".concat(existingPlan.updatedPrice.discount.appliedValue, "% savings") : 'Full price';
  return /*#__PURE__*/React.createElement("div", {
    key: existingPlan.productOfferingId
  }, /*#__PURE__*/React.createElement(LinkRegion, {
    isNotTracked: true
  }, /*#__PURE__*/React.createElement(Text, {
    variant: "bodySDemi"
  }, existingPlan.lineNumber ? formatLineNumber(existingPlan.lineNumber) : '••• ••• ••••')), /*#__PURE__*/React.createElement(Text, {
    variant: "bodySMedium",
    mb: "s2"
  }, existingPlan.name), /*#__PURE__*/React.createElement(DiscountComparison, {
    currentPriceLabel: currentPriceLabel,
    currentDiscountLabel: currentDiscountLabel,
    newPriceLabel: newPriceLabel,
    newDiscountLabel: newDiscountLabel
  }));
};

var _templateObject$f, _templateObject2$c;
var InfoIcon = styled(Icon)(_templateObject$f || (_templateObject$f = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref) {
  var spacing = _ref.theme.spacing;
  return css(_templateObject2$c || (_templateObject2$c = _taggedTemplateLiteral(["\n    margin-left: ", ";\n  "])), spacing.s1);
});

var TeamUpDescription = function TeamUpDescription() {
  var _useTheme = useTheme(),
      lupin = _useTheme.palette.baseColors.lupin;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isInfoLayerOpen = _useState2[0],
      setInfoLayerOpen = _useState2[1];

  var handleInfoButtonClick = function handleInfoButtonClick() {
    trackCustomLink('Team up saver icon');
    setInfoLayerOpen(true);
  };

  return /*#__PURE__*/React.createElement(LinkRegion, {
    regionId: "changeplan.postpaid.MPDDetails"
  }, /*#__PURE__*/React.createElement(Text, {
    variant: "bodySDemi",
    mb: "s1"
  }, "Changing to this plan will adjust your monthly savings, as shown below."), /*#__PURE__*/React.createElement(Box, {
    flexDirection: "row",
    alignItems: "start"
  }, /*#__PURE__*/React.createElement(Text, {
    variant: "bodySDemi",
    mb: "s3"
  }, "See how Team Up works."), /*#__PURE__*/React.createElement(Clickable, {
    onClick: handleInfoButtonClick,
    title: "info-button",
    type: "button"
  }, /*#__PURE__*/React.createElement(InfoIcon, {
    name: "info_small",
    fill: lupin
  }))), /*#__PURE__*/React.createElement(ContentFragmentInfoLayer, {
    contentFragmentKey: "myspark/team-up-discount",
    isOpen: isInfoLayerOpen,
    onClose: function onClose() {
      setInfoLayerOpen(false);
    },
    isNested: true
  }));
};

var trackMpdComparisonData = function trackMpdComparisonData(_ref) {
  var existingPlans = _ref.existingPlans;
  trackDigitalEvent({
    event: 'component.view',
    w3cddl: {
      event: [{
        eventInfo: {
          eventName: 'Component View',
          eventAction: 'component.view'
        }
      }],
      component: [{
        componentInfo: {
          componentID: 'productDetails.changePlan.MPDDetails',
          componentName: 'Change Plan MPD Details'
        },
        category: {
          primaryCategory: 'productDetails',
          subCategory1: 'Change Plan'
        }
      }],
      product: [{
        attributes: {
          discountInfo: existingPlans === null || existingPlans === void 0 ? void 0 : existingPlans.map(function (_ref2) {
            var updatedPrice = _ref2.updatedPrice,
                currentPrice = _ref2.currentPrice;

            var _a, _b;

            return {
              type: 'MPDDiscount',
              discountValue: (_a = updatedPrice === null || updatedPrice === void 0 ? void 0 : updatedPrice.discount) === null || _a === void 0 ? void 0 : _a.appliedValue,
              discountAction: (_b = updatedPrice === null || updatedPrice === void 0 ? void 0 : updatedPrice.discount) === null || _b === void 0 ? void 0 : _b.discountType,
              currentDiscountValue: currentPrice === null || currentPrice === void 0 ? void 0 : currentPrice.effectivePrice,
              currentDiscountAction: currentPrice === null || currentPrice === void 0 ? void 0 : currentPrice.priceType
            };
          })
        }
      }]
    }
  });
};

var _templateObject$e, _templateObject2$b;
var StrikethroughText = styled(Text)(_templateObject$e || (_templateObject$e = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref) {
  var spacing = _ref.theme.spacing;
  return css(_templateObject2$b || (_templateObject2$b = _taggedTemplateLiteral(["\n    text-decoration: line-through;\n    margin-left: ", ";\n  "])), spacing.s1);
});

var MpdComparison = function MpdComparison(_ref2) {
  var lineNumber = _ref2.lineNumber,
      plansMpdComparison = _ref2.plansMpdComparison;

  var _useTheme = useTheme(),
      _useTheme$palette$bas = _useTheme.palette.baseColors,
      mawheranui = _useTheme$palette$bas.mawheranui,
      mawhero = _useTheme$palette$bas.mawhero;

  var formattedLineNumber = formatLineNumber(lineNumber);
  var bundles = plansMpdComparison.bundles,
      existingPlans = plansMpdComparison.existingPlans,
      discountPercentageChanged = plansMpdComparison.discountPercentageChanged; // TODO: add support for multiple bundles

  var items = bundles[0].items;
  var itemToAdd = items.find(function (item) {
    return item.action === 'add';
  });
  var itemToDelete = items.find(function (item) {
    return item.action === 'delete';
  });
  var newPrice = itemToAdd.price;
  var name = itemToDelete.name,
      currentPrice = itemToDelete.price;
  var isExistingPlansSectionVisible = existingPlans.length > 0 && discountPercentageChanged;
  useEffect(function () {
    if (isExistingPlansSectionVisible) {
      trackMpdComparisonData({
        existingPlans: existingPlans
      });
    }
  }, [isExistingPlansSectionVisible, existingPlans]);

  if (!discountPercentageChanged) {
    return null;
  }

  return /*#__PURE__*/React.createElement(React.Fragment, null, !(currentPrice === null || currentPrice === void 0 ? void 0 : currentPrice.discount) && (newPrice === null || newPrice === void 0 ? void 0 : newPrice.discount) ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, {
    variant: "bodyMDemi",
    mb: "s4"
  }, "Changes to your monthly plan price"), /*#__PURE__*/React.createElement(TeamUpDescription, null), /*#__PURE__*/React.createElement(LinkRegion, {
    isNotTracked: true
  }, /*#__PURE__*/React.createElement(Text, {
    variant: "bodySDemi"
  }, formattedLineNumber)), /*#__PURE__*/React.createElement(Text, {
    variant: "bodySMedium",
    mb: "s2"
  }, name), /*#__PURE__*/React.createElement(Text, {
    variant: "footnoteDemi"
  }, "New"), /*#__PURE__*/React.createElement(Box, {
    flexDirection: "row"
  }, /*#__PURE__*/React.createElement(Text, {
    variant: "bodySMedium"
  }, "".concat(formatNZD(newPrice.effectivePrice), "/").concat(newPrice.period)), /*#__PURE__*/React.createElement(StrikethroughText, {
    variant: "bodySMedium",
    color: mawheranui
  }, "".concat(formatNZD(newPrice.basePrice), "/").concat(newPrice.period))), /*#__PURE__*/React.createElement(Text, {
    variant: "footnoteDemi",
    color: mawhero,
    mb: "s6"
  }, "".concat(newPrice.discount.appliedValue, "% savings"))) : null, isExistingPlansSectionVisible ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, {
    variant: "bodyMDemi",
    mb: "s4"
  }, "Changes to your existing plan".concat(existingPlans.length > 1 ? 's' : '')), /*#__PURE__*/React.createElement(Box, {
    mb: "s3"
  }, /*#__PURE__*/React.createElement(InfoBanner, {
    text: "Some plan information may be hidden for security reasons."
  })), !(newPrice === null || newPrice === void 0 ? void 0 : newPrice.discount) ? /*#__PURE__*/React.createElement(TeamUpDescription, null) : null, existingPlans.map(function (existingPlan) {
    return /*#__PURE__*/React.createElement(ExistingPlan, {
      key: "".concat(existingPlan.lineNumber, "-").concat(existingPlan.productOfferingId),
      existingPlan: existingPlan
    });
  })) : null);
};

var MaybeImpressionRegion = function MaybeImpressionRegion(_ref) {
  var children = _ref.children,
      impressionData = _ref.impressionData,
      isFullHeight = _ref.isFullHeight,
      _ref$toBeTracked = _ref.toBeTracked,
      toBeTracked = _ref$toBeTracked === void 0 ? true : _ref$toBeTracked;

  if (impressionData && toBeTracked) {
    return /*#__PURE__*/React.createElement(ImpressionRegion, {
      impressionData: impressionData,
      isFullHeight: isFullHeight
    }, children);
  }

  return /*#__PURE__*/React.createElement(React.Fragment, null, children);
};

var _templateObject$d;
var TITLE_COPY = 'A {segment} account is not linked to this MySpark login';
var HIDE_CHECKOUT_TITLE_COPY = "There's no existing {missingPlan} linked to your Personal account.";
var PARAGRAPH_COPY = 'To keep shopping, sign in with an email linked to a {segment} account. If you don’t have a {segment} Pay Monthly account, select Checkout as a new {segment} customer.';
var HIDE_CHECKOUT_PARAGRAPH_COPY = 'To continue shopping, close this pop-up and choose a new mobile plan. Or sign in with a different email address that has a {segment} plan already linked.';
var CHECKOUT_BUTTON_COPY = 'Checkout as a new {segment} customer';
var AlignedText = styled(Text)(_templateObject$d || (_templateObject$d = _taggedTemplateLiteral(["\n  text-align: ", ";\n"])), function (_ref) {
  var alignment = _ref.alignment;
  return alignment;
});

function includesSegmentAccount(_ref2) {
  var accounts = _ref2.accounts,
      segment = _ref2.segment;
  return accounts.some(function (account) {
    return account.segment === segment;
  });
}

function NoAccountContent(_ref3) {
  var fetchAccountList = _ref3.fetchAccountList,
      onContinue = _ref3.onContinue,
      onLoginClose = _ref3.onLoginClose,
      onLoginOpen = _ref3.onLoginOpen,
      onLoginSuccessWithNoSegmentAccount = _ref3.onLoginSuccessWithNoSegmentAccount,
      onNewAccountClick = _ref3.onNewAccountClick,
      segment = _ref3.segment,
      variant = _ref3.variant,
      _ref3$hideCheckout = _ref3.hideCheckout,
      hideCheckout = _ref3$hideCheckout === void 0 ? false : _ref3$hideCheckout;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isReloginButtonLoading = _useState2[0],
      setReloginButtonLoading = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isNewAccountButtonLoading = _useState4[0],
      setNewAccountButtonLoading = _useState4[1];

  var _useLogout = useLogout(),
      requestLogout = _useLogout.requestLogout;

  var _useLoginModal = useLoginModal(),
      openLoginModal = _useLoginModal.openLoginModal;

  function handleReloginClick() {
    return _handleReloginClick.apply(this, arguments);
  }

  function _handleReloginClick() {
    _handleReloginClick = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              setReloginButtonLoading(true);
              _context2.next = 3;
              return requestLogout();

            case 3:
              setReloginButtonLoading(false);

              if (onLoginOpen) {
                onLoginOpen();
              }

              openLoginModal({
                onClose: onLoginClose,
                onLoginSuccess: function () {
                  var _onLoginSuccess = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
                    var refetchedAccounts, hasSegmentAccountAfterRefetch;
                    return _regeneratorRuntime().wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            _context.next = 2;
                            return fetchAccountList();

                          case 2:
                            refetchedAccounts = _context.sent;
                            hasSegmentAccountAfterRefetch = includesSegmentAccount({
                              accounts: refetchedAccounts,
                              segment: segment
                            });

                            if (hasSegmentAccountAfterRefetch) {
                              _context.next = 7;
                              break;
                            }

                            onLoginSuccessWithNoSegmentAccount();
                            return _context.abrupt("return");

                          case 7:
                            onContinue();

                          case 8:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee);
                  }));

                  function onLoginSuccess() {
                    return _onLoginSuccess.apply(this, arguments);
                  }

                  return onLoginSuccess;
                }()
              });

            case 6:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
    return _handleReloginClick.apply(this, arguments);
  }

  function handleNewAccountClick() {
    return _handleNewAccountClick.apply(this, arguments);
  }

  function _handleNewAccountClick() {
    _handleNewAccountClick = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              setNewAccountButtonLoading(true);
              _context3.next = 3;
              return onNewAccountClick();

            case 3:
              setNewAccountButtonLoading(false);

            case 4:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));
    return _handleNewAccountClick.apply(this, arguments);
  }

  var isScreenVariant = variant === 'screen';
  var modalParagraph = hideCheckout ? HIDE_CHECKOUT_PARAGRAPH_COPY : PARAGRAPH_COPY;
  var title = hideCheckout ? HIDE_CHECKOUT_TITLE_COPY : TITLE_COPY;
  var missingPlan = segment === SEGMENTS.PERSONAL ? 'Pay Monthly plan' : 'Business plan';
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(AlignedText, {
    alignment: isScreenVariant ? 'center' : 'left',
    variant: isScreenVariant ? 'headingS' : 'subheadingL',
    mb: "s3"
  }, interpolateText(title, {
    segment: capitalize(segment),
    missingPlan: missingPlan
  })), /*#__PURE__*/React.createElement(AlignedText, {
    alignment: isScreenVariant ? 'center' : 'left',
    variant: isScreenVariant ? 'bodyMDemi' : 'bodySDemi',
    mb: "s3"
  }, interpolateText(modalParagraph, {
    segment: capitalize(segment)
  })), /*#__PURE__*/React.createElement(Box, {
    flexDirection: ['column', isScreenVariant ? 'row' : 'column'],
    justifyContent: "center",
    gap: isScreenVariant ? 's3' : 's2'
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    onClick: handleReloginClick,
    isLoading: isReloginButtonLoading,
    disabled: isNewAccountButtonLoading
  }, "Sign in with another email address"), !hideCheckout ? /*#__PURE__*/React.createElement(Button, {
    variant: "default",
    onClick: handleNewAccountClick,
    isLoading: isNewAccountButtonLoading,
    disabled: isReloginButtonLoading
  }, interpolateText(CHECKOUT_BUTTON_COPY, {
    segment: capitalize(segment)
  })) : null));
}

var _templateObject$c;
var Container = styled.div(_templateObject$c || (_templateObject$c = _taggedTemplateLiteral(["\n  width: 312px;\n"])));
function NoAccountModal(_ref) {
  var fetchAccountList = _ref.fetchAccountList,
      isOpen = _ref.isOpen,
      onClose = _ref.onClose,
      onContinue = _ref.onContinue,
      onLoginOpen = _ref.onLoginOpen,
      onLoginSuccessWithNoSegmentAccount = _ref.onLoginSuccessWithNoSegmentAccount,
      onNewAccountClick = _ref.onNewAccountClick,
      segment = _ref.segment,
      _ref$hideCheckout = _ref.hideCheckout,
      hideCheckout = _ref$hideCheckout === void 0 ? false : _ref$hideCheckout;
  return /*#__PURE__*/React.createElement(Modal, {
    isOpen: isOpen,
    onClose: onClose,
    showCloseButton: true
  }, /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(NoAccountContent, {
    fetchAccountList: fetchAccountList,
    onContinue: onContinue,
    onLoginClose: onClose,
    onLoginOpen: onLoginOpen,
    onLoginSuccessWithNoSegmentAccount: onLoginSuccessWithNoSegmentAccount,
    onNewAccountClick: onNewAccountClick,
    segment: segment,
    variant: "modal",
    hideCheckout: hideCheckout
  })));
}

function NoAccountScreen(props) {
  return /*#__PURE__*/React.createElement(GridRow, null, /*#__PURE__*/React.createElement(GridColumn, {
    lil: 2,
    slim: 6,
    big: 8,
    bigOffset: 2
  }, /*#__PURE__*/React.createElement(NoAccountContent, Object.assign({
    variant: "screen"
  }, props))));
}

var useAccountDropdown = function useAccountDropdown(accounts) {
  var formatAccountName = function formatAccountName(_ref) {
    var firstName = _ref.firstName,
        lastName = _ref.lastName;
    return [firstName, lastName].filter(Boolean).join(' ');
  };

  var toDropdownOption = function toDropdownOption(_a) {
    var accountNumber = _a.accountNumber,
        names = __rest(_a, ["accountNumber"]);

    return {
      label: "".concat(formatAccountName(names), " - #").concat(accountNumber),
      value: accountNumber
    };
  };

  var getDropdownOption = function getDropdownOption(value) {
    var account = accounts.find(function (_ref2) {
      var accountNumber = _ref2.accountNumber;
      return accountNumber === value;
    });
    return account ? toDropdownOption(account) : {
      label: '',
      value: ''
    };
  };

  return {
    formatAccountName: formatAccountName,
    toDropdownOption: toDropdownOption,
    getDropdownOption: getDropdownOption
  };
};

var maximumChoiceboxOptions = 5;

var AccountNumberField = function AccountNumberField(_ref) {
  var name = _ref.name,
      accounts = _ref.accounts;

  var _useFormContext = useFormContext(),
      control = _useFormContext.control,
      isSubmitting = _useFormContext.formState.isSubmitting;

  var _useAccountDropdown = useAccountDropdown(accounts),
      formatAccountName = _useAccountDropdown.formatAccountName,
      getDropdownOption = _useAccountDropdown.getDropdownOption,
      toDropdownOption = _useAccountDropdown.toDropdownOption;

  return /*#__PURE__*/React.createElement(Controller, {
    render: function render(_ref2) {
      var field = _ref2.field;
      return accounts.length > maximumChoiceboxOptions ? /*#__PURE__*/React.createElement(FormDropdown, Object.assign({}, field, {
        value: getDropdownOption(field.value),
        options: accounts.map(toDropdownOption),
        onChange: function onChange(_ref3) {
          var value = _ref3.value;
          field.onChange(value);
        },
        placeholder: "Select",
        disabled: isSubmitting
      })) : /*#__PURE__*/React.createElement(ChoiceboxGroup, null, accounts.map(function (_a) {
        var accountNumber = _a.accountNumber,
            names = __rest(_a, ["accountNumber"]);

        var isChecked = field.value === accountNumber;
        return /*#__PURE__*/React.createElement(ChoiceBox, Object.assign({}, field, {
          key: accountNumber,
          checked: isChecked,
          onChange: function onChange() {
            field.onChange(accountNumber);
          },
          disabled: isSubmitting
        }), /*#__PURE__*/React.createElement(Box, {
          flexDirection: "column"
        }, /*#__PURE__*/React.createElement(Text, {
          variant: "bodySDemi"
        }, formatAccountName(names)), /*#__PURE__*/React.createElement(Text, {
          variant: "bodySMedium"
        }, "#", accountNumber)));
      }));
    },
    control: control,
    name: name,
    rules: {
      required: true
    }
  });
};

var FormSubmitButton = function FormSubmitButton(_ref) {
  var children = _ref.children,
      isOverlayVisible = _ref.isOverlayVisible;

  var _useFormState = useFormState(),
      isValid = _useFormState.isValid,
      isSubmitting = _useFormState.isSubmitting;

  return /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    type: "submit",
    fullWidth: true,
    disabled: !isValid || isSubmitting,
    isLoading: isSubmitting && !isOverlayVisible
  }, children);
};

var SelectAccountForm = function SelectAccountForm(_ref) {
  var accounts = _ref.accounts,
      onSubmit = _ref.onSubmit,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? {
    text: ''
  } : _ref$title,
      isOverlayVisible = _ref.isOverlayVisible;

  var _a;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      hasError = _useState2[0],
      setHasError = _useState2[1];

  var methods = useForm({
    mode: 'onChange'
  });
  var handleSubmit = methods.handleSubmit( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(values) {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              setHasError(false);
              _context.next = 4;
              return onSubmit(values);

            case 4:
              _context.next = 9;
              break;

            case 6:
              _context.prev = 6;
              _context.t0 = _context["catch"](0);
              setHasError(true);

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 6]]);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }());
  return /*#__PURE__*/React.createElement(FormProvider, Object.assign({}, methods), /*#__PURE__*/React.createElement("form", {
    onSubmit: handleSubmit
  }, /*#__PURE__*/React.createElement(Box, {
    mb: "s4"
  }, /*#__PURE__*/React.createElement(LinkRegion, {
    isNotTracked: true
  }, /*#__PURE__*/React.createElement(Text, {
    variant: (_a = title.variant) !== null && _a !== void 0 ? _a : 'bodySDemi',
    mb: "s3"
  }, title.text), /*#__PURE__*/React.createElement(AccountNumberField, {
    name: "accountNumber",
    accounts: accounts
  }))), hasError ? /*#__PURE__*/React.createElement(Box, {
    mb: "s1"
  }, /*#__PURE__*/React.createElement(InfoBanner, {
    variant: "ERROR",
    text: "Something went wrong and we couldn't progress you to the next step. Please try again."
  })) : null, /*#__PURE__*/React.createElement(FormSubmitButton, {
    isOverlayVisible: isOverlayVisible
  }, "Continue")));
};

/**
 * This file was auto-generated by openapi-typescript.
 * Do not make direct changes to the file.
 */
var ApiPaths;

(function (ApiPaths) {
  ApiPaths["fetchEligibleBroadbandProductsByElid"] = "/v1/products/eligibility/broadband/:elid";
  ApiPaths["fetchBroadbandAvailabilityByElid"] = "/v1/products/eligibility/broadband/:elid/availability";
  ApiPaths["fetchEligibleModemsByOfferid"] = "/v1/products/eligibility/broadband/:broadbandOfferId/modem";
  ApiPaths["fetchEligibleLandlineAddonsByOfferid"] = "/v1/products/eligibility/broadband/:broadbandOfferId/landlineaddons";
  ApiPaths["fetchEligibleIfps"] = "/v1/products/eligibility/offer/:offerId/ifp";
  ApiPaths["fetchEligibleProductOffersByCategoryId"] = "/v2/products/offers/categories/:categoryId";
  ApiPaths["fetchEligibleAddons"] = "/v1/products/eligibility/cart/:cartId/bundle/:bundleId/addons";
  ApiPaths["fetchOneNumberEligibleLines"] = "/v1/products/eligibility/one-number-eligibility/me/access";
  ApiPaths["fetchEligibleFeaturePacks"] = "/v1/products/eligibility/broadband/:landLineNumber/featurepack";
  ApiPaths["fetchEligibleProductOffersByCategoryIdV3"] = "/v3/products/offers/categories/:categoryId";
  ApiPaths["fetchEligibleLandlinesToUpdateSettings"] = "/v1/products/eligibility/landline-settings/me/access";
  ApiPaths["fetchDirectoryListingSettingsEligibleLines"] = "/v1/products/eligibility/directory-listing/me/access";
  ApiPaths["checkProductOfferEligibility"] = "/v1/products/eligibility/:offerId/me";
  ApiPaths["retrieveAccountsLinesEligibilityForPlan"] = "/v1/products/eligibility/buy/plans/:offerId/me";
  ApiPaths["retrieveAccountsLinesEligibilityForChangePlan"] = "/v1/products/eligibility/change/plans/:offerId/me";
})(ApiPaths || (ApiPaths = {}));

// baseUrl and path may both have trailing/leading slashes.
var trimBaseUrl = function trimBaseUrl(baseUrl) {
  if (baseUrl.endsWith('/')) {
    return baseUrl.slice(0, -1);
  }

  return baseUrl;
};

var insertPathParams = function insertPathParams(path, params) {
  return path.replace(/\/:([^/]+)/g, function (_, key) {
    return "/".concat(params[key]);
  });
};

var createQueryString = function createQueryString(params) {
  return "?".concat(new URLSearchParams(params));
};

var getApiPath = function getApiPath(_ref) {
  var baseUrl = _ref.baseUrl,
      path = _ref.path,
      pathParams = _ref.pathParams,
      queryParams = _ref.queryParams;
  var trimmedBaseUrl = trimBaseUrl(baseUrl);
  var pathWithParams = pathParams ? insertPathParams(path, pathParams) : path;
  var queryString = queryParams ? createQueryString(queryParams) : '';
  return "".concat(trimmedBaseUrl).concat(pathWithParams).concat(queryString);
};

var sessionId = getUiSessionId();

var handleResponse = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(res) {
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (res.ok) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return", Promise.reject(res));

          case 2:
            return _context.abrupt("return", res.json());

          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function handleResponse(_x) {
    return _ref.apply(this, arguments);
  };
}();

var get = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(_ref2) {
    var path, _ref2$credentials, credentials;

    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            path = _ref2.path, _ref2$credentials = _ref2.credentials, credentials = _ref2$credentials === void 0 ? 'include' : _ref2$credentials;
            return _context2.abrupt("return", fetch(path, {
              method: 'GET',
              headers: {
                'X-DASL-SESSION-ID': sessionId,
                'Content-Type': 'application/json'
              },
              mode: 'cors',
              credentials: credentials
            }).then(handleResponse));

          case 2:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function get(_x2) {
    return _ref3.apply(this, arguments);
  };
}();

function getBuyPlanOfferEligibility(_x) {
  return _getBuyPlanOfferEligibility.apply(this, arguments);
}

function _getBuyPlanOfferEligibility() {
  _getBuyPlanOfferEligibility = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref) {
    var baseUrl, offerId, accountNumber, lineNumber, channel, operationName, queryParams, path;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            baseUrl = _ref.baseUrl, offerId = _ref.offerId, accountNumber = _ref.accountNumber, lineNumber = _ref.lineNumber, channel = _ref.channel;
            operationName = 'retrieveAccountsLinesEligibilityForPlan';
            queryParams = {
              accountNumber: accountNumber,
              channel: channel,
              lineNumber: lineNumber
            };
            path = getApiPath({
              baseUrl: baseUrl,
              path: ApiPaths[operationName],
              pathParams: {
                offerId: offerId
              },
              queryParams: queryParams
            });
            return _context.abrupt("return", get({
              path: path,
              credentials: 'omit'
            }));

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _getBuyPlanOfferEligibility.apply(this, arguments);
}

var ProductEligibilityService = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getBuyPlanOfferEligibility: getBuyPlanOfferEligibility
});

var Errors;

(function (Errors) {
  Errors["NoEligibleAccounts"] = "NO_ELIGIBLE_ACCOUNTS";
  Errors["NoEligibleLines"] = "ALL_LINES_INELIGIBLE";
  Errors["AccountLimitReached"] = "ACCOUNT_LIMIT_REACHED";
  Errors["GenericApiError"] = "GENERIC_API_ERROR";
})(Errors || (Errors = {}));

var GoBackButton = function GoBackButton(_ref) {
  var hasMultipleAccounts = _ref.hasMultipleAccounts,
      variant = _ref.variant,
      onClick = _ref.onClick;

  if (!hasMultipleAccounts) {
    return null;
  }

  return /*#__PURE__*/React.createElement(Button, {
    variant: variant,
    onClick: onClick,
    fullWidth: true
  }, "Select a different account");
};

var Actions = function Actions(_ref2) {
  var hasMultipleAccounts = _ref2.hasMultipleAccounts,
      errorType = _ref2.errorType,
      goBack = _ref2.goBack,
      onContinueAsNewCustomer = _ref2.onContinueAsNewCustomer,
      onTryAnotherLogin = _ref2.onTryAnotherLogin;

  if (errorType === Errors.NoEligibleLines) {
    return /*#__PURE__*/React.createElement(Box, {
      flexDirection: "column",
      gap: "s2"
    }, /*#__PURE__*/React.createElement(Button, {
      component: "a",
      variant: "primary",
      href: MOBILE_PLANS_PATH,
      fullWidth: true
    }, "Buy a new mobile plan"), /*#__PURE__*/React.createElement(GoBackButton, {
      hasMultipleAccounts: hasMultipleAccounts,
      variant: "default",
      onClick: goBack
    }));
  }

  if (errorType === Errors.AccountLimitReached) {
    return /*#__PURE__*/React.createElement(Box, {
      flexDirection: "column",
      gap: "s2"
    }, /*#__PURE__*/React.createElement(GoBackButton, {
      hasMultipleAccounts: hasMultipleAccounts,
      variant: "primary",
      onClick: goBack
    }), /*#__PURE__*/React.createElement(Button, {
      component: "a",
      variant: hasMultipleAccounts ? 'default' : 'primary',
      href: MESSAGE_US,
      fullWidth: true
    }, "Message us"));
  }

  return /*#__PURE__*/React.createElement(Box, {
    flexDirection: "column",
    gap: "s2"
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: onContinueAsNewCustomer,
    variant: "primary",
    fullWidth: true
  }, "Continue as a new customer"), /*#__PURE__*/React.createElement(Button, {
    onClick: onTryAnotherLogin,
    variant: "default",
    fullWidth: true
  }, "Try a different MySpark account"));
};

var IneligibleFeedback = function IneligibleFeedback(_ref3) {
  var hasMultipleAccounts = _ref3.hasMultipleAccounts,
      errorMessage = _ref3.errorMessage,
      errorType = _ref3.errorType,
      goBack = _ref3.goBack,
      onContinueAsNewCustomer = _ref3.onContinueAsNewCustomer,
      onTryAnotherLogin = _ref3.onTryAnotherLogin;
  var accountButNoLineMessage = hasMultipleAccounts ? 'Please select another account or buy a new Pay Monthly mobile plan.' : 'Please buy a new Pay Monthly mobile plan.';
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Box, {
    mb: "s4"
  }, /*#__PURE__*/React.createElement(InfoBanner, {
    variant: "WARN",
    isCustomChildrenEnabled: true
  }, /*#__PURE__*/React.createElement(RawHtml, {
    variant: "bodySMedium"
  }, errorMessage), errorType === Errors.NoEligibleLines ? /*#__PURE__*/React.createElement(Text, {
    variant: "bodySMedium"
  }, accountButNoLineMessage) : null)), /*#__PURE__*/React.createElement(Actions, {
    hasMultipleAccounts: hasMultipleAccounts,
    errorType: errorType,
    goBack: goBack,
    onContinueAsNewCustomer: onContinueAsNewCustomer,
    onTryAnotherLogin: onTryAnotherLogin
  }));
};

var ERROR_MESSAGES = {
  NO_ELIGIBLE_ACCOUNTS: /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("p", null, "To add a Kids Plan, you'll need a Personal account linked to your MySpark with an active, eligible Pay Monthly mobile plan."), /*#__PURE__*/React.createElement("p", null, "Continue as a new customer to buy an eligible Pay Monthly mobile plan or try a different MySpark account.")),
  ALL_LINES_INELIGIBLE: 'There are no eligible Pay Monthly mobile plans on this account to add Kids Plan.',
  ACCOUNT_LIMIT_REACHED: /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("p", null, "You have exceeded the amount of Kids Plan you can add to your account."), /*#__PURE__*/React.createElement("p", null, "Please try a different MySpark account or message us.")),
  GENERIC_API_ERROR: "Something went wrong and we couldn't progress you to the next step. Please try again."
};

var MobilePlanEligibilityCheck = function MobilePlanEligibilityCheck(_ref) {
  var apiBaseUrl = _ref.apiBaseUrl,
      cartCookieName = _ref.cartCookieName,
      selectedPlanOfferId = _ref.selectedPlanOfferId,
      onSuccess = _ref.onSuccess,
      onContinueAsNewCustomer = _ref.onContinueAsNewCustomer,
      onTryAnotherLogin = _ref.onTryAnotherLogin;

  var _useSegment = useSegment(),
      channel = _useSegment.channel;

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      accounts = _useState2[0],
      setAccounts = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      error = _useState4[0],
      setError = _useState4[1];

  var _useAvailableAccounts = useAvailableAccounts({
    cartCookieName: cartCookieName
  }),
      fetchAvailableAccounts = _useAvailableAccounts.fetchAvailableAccounts,
      isFetchingAccounts = _useAvailableAccounts.isFetchingAccounts;

  var handleAccountFormSubmit = useCallback( /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref2) {
      var selectedAccountNumber, _yield$ProductEligibi, eligibleAccounts, ineligibleAccounts, selectedIneligibleAccount, eligibleAccount;

      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              selectedAccountNumber = _ref2.accountNumber;
              _context.prev = 1;
              _context.next = 4;
              return getBuyPlanOfferEligibility({
                baseUrl: apiBaseUrl,
                offerId: selectedPlanOfferId,
                accountNumber: selectedAccountNumber,
                channel: channel
              });

            case 4:
              _yield$ProductEligibi = _context.sent;
              eligibleAccounts = _yield$ProductEligibi.eligibleAccounts;
              ineligibleAccounts = _yield$ProductEligibi.ineligibleAccounts;

              if (!ineligibleAccounts.length) {
                _context.next = 20;
                break;
              }

              selectedIneligibleAccount = ineligibleAccounts.find(function (account) {
                return account.accountNumber === selectedAccountNumber;
              });

              if (!selectedIneligibleAccount) {
                _context.next = 20;
                break;
              }

              _context.t0 = selectedIneligibleAccount.reason;
              _context.next = _context.t0 === Errors.AccountLimitReached ? 13 : _context.t0 === Errors.NoEligibleLines ? 15 : _context.t0 === 'INCOMPATIBLE_PLAN' ? 15 : 17;
              break;

            case 13:
              setError(Errors.AccountLimitReached);
              return _context.abrupt("break", 19);

            case 15:
              setError(Errors.NoEligibleLines);
              return _context.abrupt("break", 19);

            case 17:
              setError(Errors.NoEligibleAccounts);
              return _context.abrupt("break", 19);

            case 19:
              return _context.abrupt("return");

            case 20:
              if (eligibleAccounts.length) {
                eligibleAccount = eligibleAccounts.find(function (account) {
                  return account.accountNumber === selectedAccountNumber;
                });
                onSuccess(eligibleAccount);
              }

              _context.next = 26;
              break;

            case 23:
              _context.prev = 23;
              _context.t1 = _context["catch"](1);
              setError(Errors.GenericApiError);

            case 26:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 23]]);
    }));

    return function (_x) {
      return _ref3.apply(this, arguments);
    };
  }(), [apiBaseUrl, channel, selectedPlanOfferId, onSuccess]);
  useEffect(function () {
    if (!accounts.length && !isFetchingAccounts && !error) {
      var fetchAccounts = /*#__PURE__*/function () {
        var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
          var _yield$fetchAvailable, fetchedAccounts, fetchedCartAccountNumber;

          return _regeneratorRuntime().wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.next = 2;
                  return fetchAvailableAccounts();

                case 2:
                  _yield$fetchAvailable = _context2.sent;
                  fetchedAccounts = _yield$fetchAvailable.accounts;
                  fetchedCartAccountNumber = _yield$fetchAvailable.cartAccountNumber;

                  if (!fetchedAccounts.length && !isFetchingAccounts && !fetchedCartAccountNumber) {
                    setError(Errors.NoEligibleAccounts);
                  }

                  setAccounts(fetchedCartAccountNumber ? fetchedAccounts.filter(function (account) {
                    return account.accountNumber === fetchedCartAccountNumber;
                  }) : fetchedAccounts);

                case 7:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        return function fetchAccounts() {
          return _ref4.apply(this, arguments);
        };
      }();

      fetchAccounts();
    }
  }, [fetchAvailableAccounts, isFetchingAccounts, handleAccountFormSubmit, accounts, error]);
  useEffect(function () {
    if (accounts.length === 1) {
      var accountNumber = accounts[0].accountNumber;
      handleAccountFormSubmit({
        accountNumber: accountNumber
      });
    }
  }, [accounts, handleAccountFormSubmit]);

  if (isFetchingAccounts) {
    return /*#__PURE__*/React.createElement(InformationLayerLoader, null);
  }

  if (error) {
    var errorMessage = ERROR_MESSAGES[error];
    return /*#__PURE__*/React.createElement(IneligibleFeedback, {
      errorMessage: errorMessage,
      hasMultipleAccounts: accounts.length > 1,
      errorType: error,
      goBack: function goBack() {
        return setError(null);
      },
      onContinueAsNewCustomer: onContinueAsNewCustomer,
      onTryAnotherLogin: onTryAnotherLogin
    });
  }

  return /*#__PURE__*/React.createElement(SelectAccountForm, {
    accounts: accounts,
    onSubmit: handleAccountFormSubmit,
    title: {
      text: 'Select an account',
      variant: 'headingS'
    }
  });
};

var _templateObject$b, _templateObject2$a, _templateObject3$5, _templateObject4$4;
var CurrentPlanOrPackContainer = styled.div(_templateObject$b || (_templateObject$b = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref) {
  var _ref$theme = _ref.theme,
      borderRadius = _ref$theme.borderRadius,
      media = _ref$theme.media,
      palette = _ref$theme.palette,
      spacing = _ref$theme.spacing;
  return css(_templateObject2$a || (_templateObject2$a = _taggedTemplateLiteral(["\n    padding: ", ";\n    margin-bottom: ", ";\n    border: 2px solid ", ";\n    border-radius: ", ";\n\n    ", " {\n      margin-bottom: ", ";\n    }\n  "])), spacing.s2, spacing.s3, palette.baseColors.alto, borderRadius.r0_75, media.up('big'), spacing.s4);
});
var NewPlanOrPackContainer = styled(CurrentPlanOrPackContainer)(_templateObject3$5 || (_templateObject3$5 = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref2) {
  var palette = _ref2.theme.palette;
  return css(_templateObject4$4 || (_templateObject4$4 = _taggedTemplateLiteral(["\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    border-color: ", ";\n  "])), palette.baseColors.mawhero);
});

var _templateObject$a, _templateObject2$9, _templateObject3$4, _templateObject4$3;
var WarningIcon = styled(Icon)(_templateObject$a || (_templateObject$a = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref) {
  var spacing = _ref.theme.spacing;
  return css(_templateObject2$9 || (_templateObject2$9 = _taggedTemplateLiteral(["\n    flex-shrink: 0;\n    margin-right: ", ";\n  "])), spacing.s1);
});
var GrandfatheredFootnoteContainer = styled.div(_templateObject3$4 || (_templateObject3$4 = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref2) {
  var spacing = _ref2.theme.spacing;
  return css(_templateObject4$3 || (_templateObject4$3 = _taggedTemplateLiteral(["\n    display: flex;\n    margin-top: -", "; // move closer to the grandfathered plan while keeping rest of styles generic\n    padding-bottom: ", ";\n  "])), spacing.s1, spacing.s2);
});

var GrandfatheredFootnote = function GrandfatheredFootnote() {
  var _useTheme = useTheme(),
      sparkOrange = _useTheme.palette.baseColors.sparkOrange;

  var footnote = "This plan is no longer offered at Spark. Once you're on your new plan, you\n      won't be able to change back.";
  return /*#__PURE__*/React.createElement(GrandfatheredFootnoteContainer, null, /*#__PURE__*/React.createElement(WarningIcon, {
    name: "warning_small",
    fill: sparkOrange
  }), /*#__PURE__*/React.createElement(Text, {
    variant: "footnoteDemi",
    color: sparkOrange
  }, footnote));
};

var _CurrentPlanQuery;
var currentPlanQuery = _CurrentPlanQuery !== void 0 ? _CurrentPlanQuery : (_CurrentPlanQuery = require("./__generated__/CurrentPlanQuery.graphql"), _CurrentPlanQuery.hash && _CurrentPlanQuery.hash !== "7aa0a436cd562ccd845aa047079cad46" && console.error("The definition of 'CurrentPlanQuery' appears to have changed. Run `relay-compiler` to update the generated files to receive the expected data."), _CurrentPlanQuery);

var CurrentPlan = function CurrentPlan(_ref) {
  var label = _ref.label,
      offerId = _ref.offerId,
      journeyId = _ref.journeyId,
      contentVariation = _ref.contentVariation;

  var _useTheme = useTheme(),
      alto = _useTheme.palette.baseColors.alto;

  var _useLazyLoadQuery = useLazyLoadQuery(currentPlanQuery, {
    offerIds: [offerId]
  }),
      offerDetails = _useLazyLoadQuery.productOfferDetails.offerDetails;

  var isGrandfathered = offerDetails[0].isGrandfathered;

  var _useAuthorableContent = useAuthorableContentsFromRelay(journeyId, contentVariation),
      getText = _useAuthorableContent.getText;

  var currentPlanTitle = getText('planComparer.subHeader2');
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, {
    variant: "bodyMDemi",
    mb: "s2"
  }, currentPlanTitle), /*#__PURE__*/React.createElement(CurrentPlanOrPackContainer, null, /*#__PURE__*/React.createElement(Text, {
    variant: "bodyMDemi",
    color: alto
  }, label)), isGrandfathered ? /*#__PURE__*/React.createElement(GrandfatheredFootnote, null) : null);
};

var NewPlanOrPack = function NewPlanOrPack(_ref) {
  var label = _ref.label,
      contentVariation = _ref.contentVariation,
      journeyId = _ref.journeyId;

  var _useTheme = useTheme(),
      mawhero = _useTheme.palette.baseColors.mawhero;

  var _useAuthorableContent = useAuthorableContentsFromRelay(journeyId, contentVariation),
      getText = _useAuthorableContent.getText;

  var newPlanTitle = getText('planComparer.subHeader1');
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, {
    variant: "bodyMDemi",
    mb: "s2"
  }, newPlanTitle), /*#__PURE__*/React.createElement(NewPlanOrPackContainer, null, /*#__PURE__*/React.createElement(Text, {
    variant: "bodyMDemi",
    color: mawhero
  }, label), /*#__PURE__*/React.createElement(Icon, {
    name: "why_spark_small",
    fill: mawhero
  })));
};

var trackPlanComparerField = function trackPlanComparerField() {
  return {
    event: [{
      eventInfo: {
        eventName: 'Component View',
        eventAction: 'component.view'
      }
    }],
    component: [{
      componentInfo: {
        componentID: 'selfService.changePlan.postpaid.planSummary',
        componentName: 'Self Service Change Plan Postpaid Plan Summary'
      },
      category: {
        primaryCategory: 'Self Service',
        subCategory1: 'Change Plan'
      }
    }]
  };
};

var PostpaidPlanComparerField = function PostpaidPlanComparerField(_ref) {
  var journeyId = _ref.journeyId,
      currentPlanOfferId = _ref.currentPlanOfferId,
      currentPlanTitle = _ref.currentPlanTitle,
      newPlanTitle = _ref.newPlanTitle,
      contentVariation = _ref.contentVariation;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(MaybeImpressionRegion, {
    impressionData: trackPlanComparerField()
  }, /*#__PURE__*/React.createElement(NewPlanOrPack, {
    label: newPlanTitle,
    journeyId: journeyId,
    contentVariation: contentVariation
  }), /*#__PURE__*/React.createElement(CurrentPlan, {
    label: currentPlanTitle,
    offerId: currentPlanOfferId,
    journeyId: journeyId,
    contentVariation: contentVariation
  })));
};

function RawHTMLInfoLayer(_ref) {
  var isNested = _ref.isNested,
      isOpen = _ref.isOpen,
      onClose = _ref.onClose,
      contentKey = _ref.contentKey,
      journeyId = _ref.journeyId,
      typography = _ref.typography,
      contentVariation = _ref.contentVariation;

  var _useAuthorableContent = useAuthorableContentsFromRelay(journeyId, contentVariation),
      getText = _useAuthorableContent.getText;

  var content = getText(contentKey);
  return /*#__PURE__*/React.createElement(InformationLayer, {
    isNested: isNested,
    isOpen: isOpen,
    onClose: onClose
  }, /*#__PURE__*/React.createElement(RawHTMLContent, {
    content: content,
    typography: typography
  }));
}

var getFormattedSubscriptionPrice = function getFormattedSubscriptionPrice(isIncluded, price) {
  return isIncluded ? 'Included in plan' : "".concat(formatNZD(price.basePrice), "/").concat(price.frequencyPeriod.toLowerCase());
};

var _templateObject$9, _templateObject2$8;
var SubscriptionIcon = styled.img(_templateObject$9 || (_templateObject$9 = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref) {
  var spacing = _ref.theme.spacing;
  return css(_templateObject2$8 || (_templateObject2$8 = _taggedTemplateLiteral(["\n    width: 48px;\n    height: 48px;\n    margin-right: ", ";\n  "])), spacing.s2);
});

var Subscription = function Subscription(_ref2) {
  var _ref2$subscription = _ref2.subscription,
      offerName = _ref2$subscription.offerName,
      isIncluded = _ref2$subscription.isIncluded,
      price = _ref2$subscription.price,
      iconUrl = _ref2$subscription.iconUrl;
  var formattedPrice = getFormattedSubscriptionPrice(isIncluded, price);
  return /*#__PURE__*/React.createElement(Box, {
    flexDirection: "row",
    mb: "s3"
  }, /*#__PURE__*/React.createElement(SubscriptionIcon, {
    src: iconUrl
  }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Text, {
    variant: "bodySDemi"
  }, offerName), /*#__PURE__*/React.createElement(Text, {
    variant: "footnoteDemi"
  }, formattedPrice), /*#__PURE__*/React.createElement(Text, {
    variant: "footnoteDemi"
  }, price.description)));
};

var SubscriptionCheckbox = function SubscriptionCheckbox(_ref) {
  var recommendationId = _ref.recommendationId,
      _ref$subscription = _ref.subscription,
      isIncluded = _ref$subscription.isIncluded,
      price = _ref$subscription.price,
      offerName = _ref$subscription.offerName,
      recommendations = _ref.recommendations,
      areRecommendationsSubmitted = _ref.areRecommendationsSubmitted,
      addOrUpdateRecommendations = _ref.addOrUpdateRecommendations;

  if (!recommendations) {
    return null;
  }

  var formattedPrice = getFormattedSubscriptionPrice(isIncluded, price);
  var checkboxLabel = "I'd like to continue with my ".concat(offerName, " subscription at a cost of ").concat(formattedPrice);
  var isChecked = recommendations[recommendationId] === 'KEEP';
  return /*#__PURE__*/React.createElement(Box, {
    mb: "s5"
  }, /*#__PURE__*/React.createElement(LinkRegion, {
    regionId: "changePlan.Postpaid.benefits"
  }, /*#__PURE__*/React.createElement(Checkbox, {
    label: checkboxLabel,
    onCheck: function onCheck() {
      addOrUpdateRecommendations(_defineProperty({}, recommendationId, isChecked ? 'CANCEL' : 'KEEP'));
      trackCustomLink(checkboxLabel);
    },
    checked: isChecked,
    disabled: areRecommendationsSubmitted
  })));
};

var AvailableSubscription = function AvailableSubscription(_ref) {
  var recommendationId = _ref.recommendationId,
      subscription = _ref.subscription,
      ctas = _ref.ctas,
      isSubscriptionAccountRetainable = _ref.isSubscriptionAccountRetainable,
      recommendations = _ref.recommendations,
      areRecommendationsSubmitted = _ref.areRecommendationsSubmitted,
      addOrUpdateRecommendations = _ref.addOrUpdateRecommendations;

  var _useTheme = useTheme(),
      mawheranui = _useTheme.palette.baseColors.mawheranui;

  var brand = subscription.brand;
  var brandDescription = "You can still keep your existing ".concat(brand, " account. You won\u2019t need to create another account.");
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Subscription, {
    subscription: subscription
  }), isSubscriptionAccountRetainable ? /*#__PURE__*/React.createElement(Text, {
    variant: "footnoteDemi",
    color: mawheranui,
    mb: "s4"
  }, brandDescription) : null, ctas.length >= 2 ? /*#__PURE__*/React.createElement(SubscriptionCheckbox, {
    recommendationId: recommendationId,
    subscription: subscription,
    recommendations: recommendations,
    areRecommendationsSubmitted: areRecommendationsSubmitted,
    addOrUpdateRecommendations: addOrUpdateRecommendations
  }) : null);
};

var _templateObject$8, _templateObject2$7;
var GrayscaledSubscription = styled.div(_templateObject$8 || (_templateObject$8 = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref) {
  var _ref$theme = _ref.theme,
      palette = _ref$theme.palette,
      spacing = _ref$theme.spacing;
  return css(_templateObject2$7 || (_templateObject2$7 = _taggedTemplateLiteral(["\n    margin-bottom: ", ";\n    filter: grayscale(1);\n\n    & p {\n      color: ", ";\n      text-decoration: line-through;\n    }\n  "])), spacing.s1, palette.baseColors.mawheranui);
});

var UnavailableSubscription = function UnavailableSubscription(_ref2) {
  var subscription = _ref2.subscription;
  return /*#__PURE__*/React.createElement(GrayscaledSubscription, null, /*#__PURE__*/React.createElement(Subscription, {
    subscription: subscription
  }));
};

var trackSubscriptionComparisonData = function trackSubscriptionComparisonData(_ref) {
  var availableSubscriptions = _ref.availableSubscriptions,
      unavailableSubscriptions = _ref.unavailableSubscriptions;
  var newBenefits = availableSubscriptions === null || availableSubscriptions === void 0 ? void 0 : availableSubscriptions.map(function (_ref2) {
    var available = _ref2.available;
    return available === null || available === void 0 ? void 0 : available.offerName;
  });
  var benefitsNotAvailable = unavailableSubscriptions === null || unavailableSubscriptions === void 0 ? void 0 : unavailableSubscriptions.map(function (item) {
    return item === null || item === void 0 ? void 0 : item.offerName;
  });
  var previousBenefits = newBenefits.concat(benefitsNotAvailable).join(',');
  trackDigitalEvent({
    event: 'component.view',
    w3cddl: {
      event: [{
        eventInfo: {
          eventName: 'Component View',
          eventAction: 'component.view'
        }
      }],
      component: [{
        componentInfo: {
          componentID: 'productDetails.changePlan.postPaid.benefitDetails',
          componentName: 'Change Plan Postpaid Plan Benefit Details'
        },
        category: {
          primaryCategory: 'productDetails',
          subCategory1: 'Change Plan'
        }
      }],
      product: [{
        attributes: {
          benefitsDifferInfo: {
            previousBenefits: previousBenefits,
            newBenefits: newBenefits,
            benefitsNotAvailable: benefitsNotAvailable,
            hasSpotifyOptIn: (availableSubscriptions === null || availableSubscriptions === void 0 ? void 0 : availableSubscriptions.length) > 0
          }
        }
      }]
    }
  });
};

var _templateObject$7, _templateObject2$6;
var UnavailableSubscriptions = styled.div(_templateObject$7 || (_templateObject$7 = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref) {
  var _ref$theme = _ref.theme,
      palette = _ref$theme.palette,
      spacing = _ref$theme.spacing,
      isDividerVisible = _ref.isDividerVisible;
  return css(_templateObject2$6 || (_templateObject2$6 = _taggedTemplateLiteral(["\n    margin-bottom: ", ";\n    border-bottom: ", ";\n  "])), spacing.s4, isDividerVisible ? "solid 1px ".concat(palette.baseColors.moeraki) : "none");
});

var SubscriptionComparison = function SubscriptionComparison(_ref2) {
  var comparisons = _ref2.comparisons,
      recommendations = _ref2.recommendations,
      areRecommendationsSubmitted = _ref2.areRecommendationsSubmitted,
      addOrUpdateRecommendations = _ref2.addOrUpdateRecommendations;
  useEffect(function () {
    if (comparisons.length > 0) {
      var defaultRecommendations = comparisons.reduce(function (accumulatedRecommendations, comparison) {
        return Object.assign(Object.assign({}, accumulatedRecommendations), _defineProperty({}, comparison.recommendationId, comparison.ctas[0].type));
      }, {});
      addOrUpdateRecommendations(defaultRecommendations);
    }
  }, []);
  var applicableComparisons = comparisons.filter(function (_ref3) {
    var available = _ref3.available,
        unavailable = _ref3.unavailable;
    return (available === null || available === void 0 ? void 0 : available.offerId) !== (unavailable === null || unavailable === void 0 ? void 0 : unavailable.offerId);
  });

  if (applicableComparisons.length < 1) {
    return null;
  }

  var availableSubscriptions = applicableComparisons.filter(function (_ref4) {
    var available = _ref4.available;
    return Boolean(available);
  }).map(function (_ref5) {
    var recommendationId = _ref5.recommendationId,
        available = _ref5.available,
        ctas = _ref5.ctas;
    return {
      recommendationId: recommendationId,
      available: available,
      ctas: ctas
    };
  });
  var unavailableSubscriptions = applicableComparisons.filter(function (_ref6) {
    var unavailable = _ref6.unavailable;
    return Boolean(unavailable);
  }).map(function (_ref7) {
    var unavailable = _ref7.unavailable;
    return unavailable;
  });
  useEffect(function () {
    trackSubscriptionComparisonData({
      availableSubscriptions: availableSubscriptions,
      unavailableSubscriptions: unavailableSubscriptions
    });
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, {
    variant: "bodyMDemi",
    mb: "s3"
  }, "Benefits differ on this plan"), unavailableSubscriptions.length > 0 ? /*#__PURE__*/React.createElement(UnavailableSubscriptions, {
    isDividerVisible: availableSubscriptions.length > 0
  }, /*#__PURE__*/React.createElement(Text, {
    variant: "bodySDemi",
    mb: "s2"
  }, "".concat(unavailableSubscriptions.length > 1 ? 'These offers' : 'This offer', " will no longer be available:")), unavailableSubscriptions.map(function (unavailableSubscription) {
    return /*#__PURE__*/React.createElement(UnavailableSubscription, {
      key: unavailableSubscription.offerId,
      subscription: unavailableSubscription
    });
  })) : null, availableSubscriptions.length > 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, {
    variant: "bodySDemi",
    mb: "s2"
  }, "".concat(availableSubscriptions.length > 1 ? 'These offers are' : 'This offer is', " now available:")), availableSubscriptions.map(function (_ref8) {
    var recommendationId = _ref8.recommendationId,
        availableSubscription = _ref8.available,
        ctas = _ref8.ctas;
    return /*#__PURE__*/React.createElement(AvailableSubscription, {
      key: availableSubscription.offerId,
      recommendationId: recommendationId,
      recommendations: recommendations,
      areRecommendationsSubmitted: areRecommendationsSubmitted,
      addOrUpdateRecommendations: addOrUpdateRecommendations,
      subscription: availableSubscription,
      ctas: ctas,
      isSubscriptionAccountRetainable: unavailableSubscriptions.some(function (_ref9) {
        var brand = _ref9.brand;
        return brand === availableSubscription.brand;
      })
    });
  })) : null);
};

var _templateObject$6, _templateObject2$5;
var MediaLoader = styled(ProductCardMedia)(_templateObject$6 || (_templateObject$6 = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref) {
  var palette = _ref.theme.palette;
  return css(_templateObject2$5 || (_templateObject2$5 = _taggedTemplateLiteral(["\n    background-color: ", ";\n  "])), palette.baseColors.onepu);
});

var ProductCardLoader = function ProductCardLoader() {
  return /*#__PURE__*/React.createElement(BaseProductCard, {
    title: "Add-on loading"
  }, /*#__PURE__*/React.createElement(MediaLoader, null), /*#__PURE__*/React.createElement(ProductCardSection, null, /*#__PURE__*/React.createElement(SparkContentLoader, {
    height: 152,
    style: {
      width: '100%'
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: "0",
    y: "0",
    rx: "8",
    ry: "8",
    width: "50%",
    height: "20"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "0",
    y: "44",
    rx: "8",
    ry: "8",
    width: "65%",
    height: "20"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "0",
    y: "84",
    rx: "8",
    ry: "8",
    width: "80%",
    height: "20"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "0",
    y: "128",
    rx: "8",
    ry: "8",
    width: "70%",
    height: "20"
  }))), /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(ProductCardSection, null, /*#__PURE__*/React.createElement(SparkContentLoader, {
    height: 152,
    style: {
      width: '100%'
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: "0",
    y: "0",
    rx: "8",
    ry: "8",
    width: "70%",
    height: "20"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "0",
    y: "44",
    rx: "8",
    ry: "8",
    width: "65%",
    height: "20"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "0",
    y: "84",
    rx: "8",
    ry: "8",
    width: "40%",
    height: "20"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "0",
    y: "128",
    rx: "8",
    ry: "8",
    width: "70%",
    height: "20"
  }))));
};

var _templateObject$5, _templateObject2$4, _templateObject3$3, _templateObject4$2, _templateObject5$1, _templateObject6$1, _templateObject7$1, _templateObject8$1, _templateObject9$1, _templateObject10$1, _templateObject11$1, _templateObject12$1, _templateObject13$1, _templateObject14$1, _templateObject15$1, _templateObject16;
var StyledProductCard = styled(BaseProductCard)(_templateObject$5 || (_templateObject$5 = _taggedTemplateLiteral(["\n  flex-shrink: 0;\n"])));
var TopProductCardSection = styled(ProductCardSection)(_templateObject2$4 || (_templateObject2$4 = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref) {
  var media = _ref.theme.media;
  return css(_templateObject3$3 || (_templateObject3$3 = _taggedTemplateLiteral(["\n    max-height: 198px;\n    ", " {\n      max-height: 227px;\n    }\n  "])), media.up('slim'));
});
var PromotionSection = styled(ProductCardSection)(_templateObject4$2 || (_templateObject4$2 = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref2) {
  var spacing = _ref2.theme.spacing;
  return css(_templateObject5$1 || (_templateObject5$1 = _taggedTemplateLiteral(["\n    padding: ", " ", " 0 ", ";\n    margin-bottom: ", ";\n  "])), spacing.s4, spacing.s4, spacing.s4, spacing.s3);
});
var VASTitle = styled(Text)(_templateObject6$1 || (_templateObject6$1 = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref3) {
  var spacing = _ref3.theme.spacing;
  return css(_templateObject7$1 || (_templateObject7$1 = _taggedTemplateLiteral(["\n    margin-bottom: ", ";\n  "])), spacing.s1);
});
var PricingRow = styled.div(_templateObject8$1 || (_templateObject8$1 = _taggedTemplateLiteral(["\n  align-items: flex-end;\n  display: flex;\n"])));
var StatusText = styled(Text)(_templateObject9$1 || (_templateObject9$1 = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref4) {
  var spacing = _ref4.theme.spacing;
  return css(_templateObject10$1 || (_templateObject10$1 = _taggedTemplateLiteral(["\n    margin-bottom: ", ";\n  "])), spacing.s2);
});
var GstExclText = styled(Text)(_templateObject11$1 || (_templateObject11$1 = _taggedTemplateLiteral(["\n  align-self: flex-end;\n  white-space: pre;\n"])));
var ActionSection = styled(ProductCardSection)(_templateObject12$1 || (_templateObject12$1 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n  justify-content: flex-end;\n  padding-top: 0;\n"])));
var FullSizeProductCardMedia = styled.div(_templateObject13$1 || (_templateObject13$1 = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref5) {
  var imagePath = _ref5.imagePath;
  return css(_templateObject14$1 || (_templateObject14$1 = _taggedTemplateLiteral(["\n    background: url(", ");\n    background-size: cover;\n    width: 100%;\n    height: 100%;\n  "])), imagePath);
});
var PromotionSectionText = styled(Text)(_templateObject15$1 || (_templateObject15$1 = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref6) {
  var spacing = _ref6.theme.spacing;
  return css(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["\n    margin-bottom: ", ";\n  "])), spacing.s2);
});
function VASProductCard(_ref7) {
  var className = _ref7.className,
      disabled = _ref7.disabled,
      product = _ref7.product,
      _ref7$showFullSizePro = _ref7.showFullSizeProductMedia,
      showFullSizeProductMedia = _ref7$showFullSizePro === void 0 ? false : _ref7$showFullSizePro,
      _ref7$addButtonText = _ref7.addButtonText,
      addButtonText = _ref7$addButtonText === void 0 ? 'Add to cart' : _ref7$addButtonText,
      deal = _ref7.deal,
      onAddClick = _ref7.onAddClick,
      onLearnMoreClick = _ref7.onLearnMoreClick,
      onOptionChange = _ref7.onOptionChange,
      statusText = _ref7.statusText,
      selectedOptionId = _ref7.selectedOptionId,
      dynamicTargetValue = _ref7.dynamicTargetValue;

  var _a, _b, _c;

  var name = product.name,
      price = product.price,
      chargePeriod = product.chargePeriod,
      description = product.description,
      imagePath = product.imagePath,
      _product$options = product.options,
      options = _product$options === void 0 ? [] : _product$options,
      isIncluded = product.isIncluded,
      _product$showPromotio = product.showPromotionSection,
      showPromotionSection = _product$showPromotio === void 0 ? false : _product$showPromotio,
      isGstExcl = product.isGstExcl,
      backgroundUrl = product.backgroundUrl;

  var _useTheme = useTheme(),
      baseColors = _useTheme.palette.baseColors;

  var _useState = useState(selectedOptionId !== null && selectedOptionId !== void 0 ? selectedOptionId : (_a = options[0]) === null || _a === void 0 ? void 0 : _a.optionID),
      _useState2 = _slicedToArray(_useState, 2),
      currentlySelected = _useState2[0],
      setCurrentlySelected = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isLoading = _useState4[0],
      setLoading = _useState4[1];

  var showOptions = options.length > 0;
  var formattedPrice = formatNZD(price);

  function handleClick() {
    return _handleClick.apply(this, arguments);
  }

  function _handleClick() {
    _handleClick = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setLoading(true);
              _context.next = 3;
              return onAddClick();

            case 3:
              setLoading(false);

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return _handleClick.apply(this, arguments);
  }

  return /*#__PURE__*/React.createElement(StyledProductCard, {
    className: className,
    disabled: disabled,
    marketingMessage: deal === null || deal === void 0 ? void 0 : deal.tag,
    dynamicTargetValue: dynamicTargetValue
  }, /*#__PURE__*/React.createElement(ProductCardMedia, {
    backgroundUrl: backgroundUrl
  }, showFullSizeProductMedia ? /*#__PURE__*/React.createElement(FullSizeProductCardMedia, {
    imagePath: imagePath
  }) : /*#__PURE__*/React.createElement("img", {
    src: imagePath,
    alt: "".concat(name, " Logo"),
    style: {
      width: '50%'
    }
  })), /*#__PURE__*/React.createElement(TopProductCardSection, null, /*#__PURE__*/React.createElement(VASTitle, {
    variant: "subheadingM"
  }, name), isIncluded ? /*#__PURE__*/React.createElement(Text, {
    variant: "headingS"
  }, "Included") : /*#__PURE__*/React.createElement(PricingRow, null, /*#__PURE__*/React.createElement(Text, {
    variant: "headingS"
  }, formattedPrice), /*#__PURE__*/React.createElement(Text, {
    variant: "bodySMedium"
  }, chargePeriod ? "/".concat(chargePeriod.toLowerCase()) : '/month'), isGstExcl ? /*#__PURE__*/React.createElement(GstExclText, {
    variant: "bodySMedium",
    color: disabled ? baseColors.moeraki : baseColors.mawheranui
  }, " (excl. GST)") : null), /*#__PURE__*/React.createElement(Text, {
    variant: "footnoteDemi",
    color: baseColors.mawhero
  }, deal === null || deal === void 0 ? void 0 : deal.text), description ? /*#__PURE__*/React.createElement(Box, {
    pt: "s1"
  }, /*#__PURE__*/React.createElement(Text, {
    variant: "bodySMedium"
  }, description, onLearnMoreClick && /*#__PURE__*/React.createElement(React.Fragment, null, "\xA0", /*#__PURE__*/React.createElement(Button, {
    variant: "textbutton",
    onClick: onLearnMoreClick
  }, "Learn more")))) : null), showOptions ? /*#__PURE__*/React.createElement(Box, {
    pt: ['s4', 's0', 's0']
  }, /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(ProductCardSection, null, /*#__PURE__*/React.createElement(RadioGroup, {
    title: "Choose your subscription:"
  }, options.map(function (option) {
    return /*#__PURE__*/React.createElement(RadioButton, {
      key: option.optionID,
      checked: currentlySelected === option.optionID,
      value: option.optionID,
      subtext: option.description,
      name: "RadioButtonGroup",
      onChange: function onChange() {
        setCurrentlySelected(option.optionID);
        onOptionChange === null || onOptionChange === void 0 ? void 0 : onOptionChange(option);
      }
    }, /*#__PURE__*/React.createElement(Text, {
      variant: "bodySDemi"
    }, option.name), /*#__PURE__*/React.createElement(Text, {
      variant: "bodySDemi"
    }, option.price));
  })))) : null, showPromotionSection && ((_b = deal === null || deal === void 0 ? void 0 : deal.promotionText) === null || _b === void 0 ? void 0 : _b.length) ? /*#__PURE__*/React.createElement(Box, {
    pt: "s1_5"
  }, /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(PromotionSection, null, (_c = deal === null || deal === void 0 ? void 0 : deal.promotionText) === null || _c === void 0 ? void 0 : _c.map(function (text) {
    return /*#__PURE__*/React.createElement(PromotionSectionText, {
      key: text,
      variant: "bodySMedium",
      color: baseColors.greyLynn
    }, text);
  }))) : null, /*#__PURE__*/React.createElement(ActionSection, null, /*#__PURE__*/React.createElement(FloatUp, {
    show: Boolean(statusText)
  }, /*#__PURE__*/React.createElement(StatusText, {
    variant: "bodySMedium",
    color: baseColors.sparkGreen
  }, statusText)), /*#__PURE__*/React.createElement(ProductCardButton, {
    variant: "default",
    onClick: handleClick,
    isLoading: isLoading,
    disabled: isLoading || disabled
  }, addButtonText)));
}

function removeNullValuesInQuery(queryParameters) {
  return omitBy(queryParameters, isNil);
}

var getPath = function getPath(route, isBusiness) {
  if (isBusiness) return "".concat(BUSINESS_HOME_PAGE).concat(route);
  return route;
};

var UPFRONT_PAYMENT_ID = 'pay_upfront';

var _templateObject$4;
var StyledCardAnchor = styled.a(_templateObject$4 || (_templateObject$4 = _taggedTemplateLiteral(["\n  text-decoration: none;\n"])));
function getCardLinkDestination(product, isBusiness) {
  var groupId = product.groupId,
      offerId = product.offerId,
      defaultPlan = product.defaultPlan,
      defaultIfpTerm = product.defaultIfpTerm;
  var pageQuery = removeNullValuesInQuery({
    offerId: offerId,
    planId: defaultPlan === null || defaultPlan === void 0 ? void 0 : defaultPlan.id,
    ifpId: defaultIfpTerm || UPFRONT_PAYMENT_ID
  });
  return {
    pathname: "".concat(getPath(PRODUCT_DETAILS_PAGE, isBusiness), "/").concat(groupId),
    query: pageQuery
  };
}
function ProductGalleryCardAnchor(_ref) {
  var children = _ref.children,
      onClick = _ref.onClick;
  return /*#__PURE__*/React.createElement(StyledCardAnchor, {
    onClick: onClick
  }, children);
}

var DEFAULT_FALLBACK_IMAGE_PATH = "".concat(BASE_PATH, "/static/assets/fallback/no-image.svg");

var ImageWithFallback = function ImageWithFallback(_a) {
  var src = _a.src,
      alt = _a.alt,
      _a$fallbackSrc = _a.fallbackSrc,
      fallbackSrc = _a$fallbackSrc === void 0 ? DEFAULT_FALLBACK_IMAGE_PATH : _a$fallbackSrc,
      rest = __rest(_a, ["src", "alt", "fallbackSrc"]);

  var _useState = useState(src),
      _useState2 = _slicedToArray(_useState, 2),
      imgSrc = _useState2[0],
      setImgSrc = _useState2[1];

  return /*#__PURE__*/React.createElement("img", Object.assign({}, rest, {
    alt: alt,
    src: imgSrc,
    onError: function onError() {
      return setImgSrc(fallbackSrc);
    }
  }));
};

var PromotionType;

(function (PromotionType) {
  PromotionType["CHARACTERISTIC"] = "CHARACTERISTIC";
  PromotionType["DEAL"] = "DEAL";
  PromotionType["FEATURE"] = "FEATURE";
  PromotionType["MARKETING"] = "MARKETING";
  PromotionType["ORIGINAL_RRP"] = "ORIGINAL_RRP";
})(PromotionType || (PromotionType = {}));
function getPromotionByType(promotions, promotionType) {
  return promotions === null || promotions === void 0 ? void 0 : promotions.find(function (_ref) {
    var productType = _ref.productType;
    return productType === promotionType;
  });
}
function getFeaturedPromoDeals(promotions) {
  if (!Array.isArray(promotions)) {
    return null;
  }

  return promotions === null || promotions === void 0 ? void 0 : promotions.filter(function (_ref4) {
    var productType = _ref4.productType,
        featured = _ref4.featured;
    return productType === PromotionType.DEAL && featured === true;
  }).map(function (_ref5) {
    var name = _ref5.name;
    return name;
  }).join(' & ');
}

var _templateObject$3, _templateObject2$3, _templateObject3$2;
var IconContainer = styled(Box)(_templateObject$3 || (_templateObject$3 = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref) {
  var spacing = _ref.theme.spacing;
  return css(_templateObject2$3 || (_templateObject2$3 = _taggedTemplateLiteral(["\n    width: 24px;\n    display: flex;\n    align-items: center;\n    margin-right: ", ";\n  "])), spacing.s2);
});
var BottomSection = styled(Box)(_templateObject3$2 || (_templateObject3$2 = _taggedTemplateLiteral(["\n  flex: 1;\n"])));

var ProductGalleryCardDeals = function ProductGalleryCardDeals(_ref2) {
  var pricePointCreditDescription = _ref2.pricePointCreditDescription,
      promoDealString = _ref2.promoDealString;

  var _useTheme = useTheme(),
      baseColors = _useTheme.palette.baseColors;

  if (!pricePointCreditDescription && !promoDealString) {
    return null;
  }

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(BottomSection, {
    alignItems: "center",
    pt: "s3",
    px: "s4",
    pb: "s2",
    flexDirection: "column"
  }, pricePointCreditDescription ? /*#__PURE__*/React.createElement(Box, {
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
    pb: "s2"
  }, /*#__PURE__*/React.createElement(IconContainer, null, /*#__PURE__*/React.createElement(Icon, {
    name: "spend_small"
  })), /*#__PURE__*/React.createElement(Text, {
    variant: "bodySMedium"
  }, pricePointCreditDescription)) : null, promoDealString ? /*#__PURE__*/React.createElement(Box, {
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
    pb: "s2"
  }, /*#__PURE__*/React.createElement(IconContainer, null, /*#__PURE__*/React.createElement(Icon, {
    name: "gift"
  })), /*#__PURE__*/React.createElement(Text, {
    variant: "bodySMedium",
    color: baseColors.mawhero
  }, promoDealString)) : null));
};

var MAX_TITLE_SPACING_PER_LINE = 50;
var MAX_IFP_DESCRIPTION_SPACING_PER_LINE = 35;
var BODY_S_MEDIUM_LINE_HEIGHT = 24;
var BODY_M_DEMI_LINE_HEIGHT = 28;

function getPricingDetails(_ref) {
  var priceType = _ref.priceType,
      basePrice = _ref.basePrice,
      basePriceExcludingTax = _ref.basePriceExcludingTax,
      effectivePrice = _ref.effectivePrice,
      effectivePriceExcludingTax = _ref.effectivePriceExcludingTax,
      isBusiness = _ref.isBusiness;
  var isMonthlyPayment = (priceType === null || priceType === void 0 ? void 0 : priceType.toLocaleLowerCase()) === 'recurring';
  var hasAssociatedPriceRule = isMonthlyPayment && effectivePrice;
  var consumerPrice = hasAssociatedPriceRule ? effectivePrice : basePrice;
  var businessPrice = hasAssociatedPriceRule ? effectivePriceExcludingTax : basePriceExcludingTax;
  return {
    priceValue: isBusiness ? businessPrice : consumerPrice,
    pricePeriod: isMonthlyPayment ? 'month' : '',
    isGstExcl: isBusiness
  };
}

function getPlanName(plan, isBusiness) {
  var _a;

  var planPrice = isBusiness ? plan.basePriceExcludingTax : plan.basePrice;
  return "$".concat(planPrice, " ").concat(removePricesAndCharacteristics((_a = plan === null || plan === void 0 ? void 0 : plan.name) !== null && _a !== void 0 ? _a : ''));
}

function generateIfpDescription(constructIfpDescriptionParameters) {
  // Don't show anything for SME until IFP fields are properly handled in backend
  var defaultPlan = constructIfpDescriptionParameters.defaultPlan,
      defaultIfpTerm = constructIfpDescriptionParameters.defaultIfpTerm,
      downPaymentRequired = constructIfpDescriptionParameters.downPaymentRequired,
      minimumDownPaymentAmount = constructIfpDescriptionParameters.minimumDownPaymentAmount,
      isDeferrable = constructIfpDescriptionParameters.isDeferrable,
      ifpSaving = constructIfpDescriptionParameters.ifpSaving,
      priceType = constructIfpDescriptionParameters.priceType,
      isBusiness = constructIfpDescriptionParameters.isBusiness;
  if (!isDeferrable) return '';
  var hasIFPSaving = ifpSaving && (priceType === null || priceType === void 0 ? void 0 : priceType.toLocaleLowerCase()) === 'recurring'; // Default descriptions for customers without default plan

  if (!defaultIfpTerm) {
    return 'Interest free payments options are available to existing Spark customers on an eligible plan';
  }

  if (!defaultPlan) {
    return "Interest free over ".concat(defaultIfpTerm, " months available for customers with a Spark account");
  }

  var planName = getPlanName(defaultPlan, isBusiness);
  var baseDescription = "Interest free over ".concat(defaultIfpTerm, " months on a ").concat(planName);

  if (downPaymentRequired) {
    var downPaymentDescription = "with a minimum $".concat(minimumDownPaymentAmount, " deposit, subject to credit checks.");
    return hasIFPSaving ? "over ".concat(defaultIfpTerm, " months interest free on a ").concat(planName, " ").concat(downPaymentDescription) : "".concat(baseDescription, ", with a $").concat(minimumDownPaymentAmount, " upfront minimum deposit, subject to credit checks.");
  }

  return hasIFPSaving ? "over ".concat(defaultIfpTerm, " months interest free on a ").concat(planName, ", subject to credit checks.") : baseDescription;
}

function constructIfpDescription(constructIfpDescriptionParameters) {
  var priceType = constructIfpDescriptionParameters.priceType,
      ifpSaving = constructIfpDescriptionParameters.ifpSaving;
  var ifpDescription = generateIfpDescription(constructIfpDescriptionParameters);
  var isInteger = ifpSaving % 1 === 0;
  var formattedSavingPrice = formatNZD(ifpSaving, isInteger ? 0 : 2);

  if (ifpSaving && (priceType === null || priceType === void 0 ? void 0 : priceType.toLocaleLowerCase()) === 'recurring') {
    return "Save ".concat(formattedSavingPrice, " ").concat(ifpDescription, " Offer applied to monthly price.");
  }

  return ifpDescription;
}

function getPreOrderText(product) {
  var _a;

  if ((_a = product.productCharacteristics) === null || _a === void 0 ? void 0 : _a.preOrderable) return 'Pre-order now';
  return '';
}
function getTitleText(product) {
  return product.name;
}
function getPrePriceText(product) {
  var isDeferrable = product.isDeferrable,
      priceType = product.priceType;

  if (isDeferrable && priceType !== 'Onetime') {
    return 'From';
  }

  return '';
}
function getStockText(product) {
  var _a;

  var stockDescriptionMapping = {
    OUT_OF_STOCK: 'Out of stock'
  };
  return (_a = stockDescriptionMapping[product.stockStatus]) !== null && _a !== void 0 ? _a : '';
}
function getIFPDescriptionText(product, isBusiness) {
  var isDeferrable = product.isDeferrable,
      priceType = product.priceType,
      defaultPlan = product.defaultPlan,
      defaultIfpTerm = product.defaultIfpTerm,
      downPaymentRequired = product.downPaymentRequired,
      minimumDownPaymentAmount = product.minimumDownPaymentAmount,
      pricePointCredit = product.pricePointCredit,
      pricePointCreditExcludingTax = product.pricePointCreditExcludingTax;
  var ifpSaving = isBusiness ? pricePointCreditExcludingTax : pricePointCredit;
  return constructIfpDescription({
    defaultPlan: defaultPlan,
    defaultIfpTerm: defaultIfpTerm,
    downPaymentRequired: downPaymentRequired,
    minimumDownPaymentAmount: minimumDownPaymentAmount,
    isDeferrable: isDeferrable,
    isBusiness: isBusiness,
    priceType: priceType,
    ifpSaving: ifpSaving
  });
}
function getDeviceOnlyText(product, isBusiness) {
  var isDeferrable = product.isDeferrable,
      priceType = product.priceType,
      startPricePoint = product.startPricePoint,
      startPricePointExcludingTax = product.startPricePointExcludingTax;
  var deviceOnlyPrice = isBusiness ? startPricePointExcludingTax : startPricePoint;
  var shouldShowDeviceOnlyPrice = isDeferrable && priceType !== 'Onetime' && startPricePoint;
  return shouldShowDeviceOnlyPrice ? "Device only from ".concat(formatNZD(deviceOnlyPrice)) : '';
}
function getTitleLineCount(product) {
  var title = getTitleText(product);
  var spacesAndDashesCount = title.split('').filter(function (a) {
    return [' ', '-'].includes(a);
  }).length;
  var totalSpace = title.length * 2 - spacesAndDashesCount;
  return Math.ceil(totalSpace / MAX_TITLE_SPACING_PER_LINE);
}
function getSavingPriceText(product, isBusiness) {
  var pricePointCreditExcludingTax = product.pricePointCreditExcludingTax,
      pricePointCredit = product.pricePointCredit,
      savePrice = product.savePrice,
      savePriceExcludingTax = product.savePriceExcludingTax;
  var ifpSaving = isBusiness ? pricePointCreditExcludingTax : pricePointCredit;
  var wasSaving = isBusiness ? savePriceExcludingTax : savePrice;
  var savingPrice = ifpSaving || wasSaving || 0;
  var shouldShowSavingTag = savingPrice > 0;
  var isInteger = savingPrice % 1 === 0;
  var formattedSavingPrice = formatNZD(savingPrice, isInteger ? 0 : 2);
  return shouldShowSavingTag ? formattedSavingPrice : '';
}
function getPriceValueText(product, isBusiness) {
  var priceType = product.priceType,
      basePrice = product.basePrice,
      basePriceExcludingTax = product.basePriceExcludingTax,
      effectivePrice = product.effectivePrice,
      effectivePriceExcludingTax = product.effectivePriceExcludingTax;

  var _getPricingDetails = getPricingDetails({
    priceType: priceType,
    basePrice: basePrice,
    basePriceExcludingTax: basePriceExcludingTax,
    effectivePrice: effectivePrice,
    effectivePriceExcludingTax: effectivePriceExcludingTax,
    isBusiness: isBusiness
  }),
      priceValue = _getPricingDetails.priceValue;

  return formatNZD(priceValue);
}
function getPricePeriod(product, isBusiness) {
  var priceType = product.priceType,
      basePrice = product.basePrice,
      basePriceExcludingTax = product.basePriceExcludingTax,
      effectivePrice = product.effectivePrice,
      effectivePriceExcludingTax = product.effectivePriceExcludingTax;

  var _getPricingDetails2 = getPricingDetails({
    priceType: priceType,
    basePrice: basePrice,
    basePriceExcludingTax: basePriceExcludingTax,
    effectivePrice: effectivePrice,
    effectivePriceExcludingTax: effectivePriceExcludingTax,
    isBusiness: isBusiness
  }),
      pricePeriod = _getPricingDetails2.pricePeriod;

  return pricePeriod;
}
function getWasPriceText(product, isBusiness) {
  var wasBasePrice = product.wasBasePrice,
      wasBasePriceExcludingTax = product.wasBasePriceExcludingTax;
  var wasPrice = isBusiness ? wasBasePriceExcludingTax : wasBasePrice;
  var savingPrice = getSavingPriceText(product, isBusiness);
  var pricePeriod = getPricePeriod(product, isBusiness);
  var shouldShowWasPriceTag = wasPrice > 0 && !pricePeriod && !!savingPrice;

  if (shouldShowWasPriceTag) {
    var isInteger = wasPrice % 1 === 0;
    return formatNZD(wasPrice, isInteger ? 0 : 2);
  }

  return '';
}
function getIFPDescriptionLineCount(product, isBusiness) {
  return Math.ceil(getIFPDescriptionText(product, isBusiness).length / MAX_IFP_DESCRIPTION_SPACING_PER_LINE);
}
function getGalleryProductsWithPosition(filteredProducts, cardsCountInSameRow, isBusiness) {
  var galleryProductsWithPosition = [];

  for (var index = 0; index < filteredProducts.length; index += 1) {
    if (index % cardsCountInSameRow === 0) {
      (function () {
        var rowProducts = filteredProducts.slice(index, index + cardsCountInSameRow);
        var displaySettings = {
          shouldShowPreOrderLine: rowProducts.some(function (product) {
            return !!getPreOrderText(product);
          }),
          shouldShowTitle: rowProducts.some(function (product) {
            return !!getTitleText(product);
          }),
          shouldShowWasPriceLine: rowProducts.some(function (product) {
            return !!getWasPriceText(product, isBusiness);
          }),
          shouldShowPrePriceLine: rowProducts.some(function (product) {
            return !!getPrePriceText(product);
          }),
          shouldShowStockLine: rowProducts.some(function (product) {
            return !!getStockText(product);
          }),
          shouldShowDescription: rowProducts.some(function (product) {
            return !!getIFPDescriptionText(product, isBusiness);
          }),
          shouldShowDeviceOnly: rowProducts.some(function (product) {
            return !!getDeviceOnlyText(product, isBusiness);
          }),
          titleLineCount: Math.max.apply(Math, _toConsumableArray(rowProducts.map(function (product) {
            return getTitleLineCount(product);
          }))),
          ifpDescriptionLineCount: Math.max.apply(Math, _toConsumableArray(rowProducts.map(function (product) {
            return getIFPDescriptionLineCount(product, isBusiness);
          })))
        };
        rowProducts.forEach(function (product) {
          return galleryProductsWithPosition.push(Object.assign(Object.assign({}, product), {
            displaySettings: displaySettings
          }));
        });
      })();
    }
  }

  return galleryProductsWithPosition;
}

var _templateObject$2, _templateObject2$2;
var Tag = styled(Box)(_templateObject$2 || (_templateObject$2 = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref) {
  var _ref$theme = _ref.theme,
      borderRadius = _ref$theme.borderRadius,
      palette = _ref$theme.palette;
  return css(_templateObject2$2 || (_templateObject2$2 = _taggedTemplateLiteral(["\n    background: ", ";\n    align-self: flex-end;\n    border-top-left-radius: ", ";\n    border-bottom-left-radius: ", ";\n  "])), palette.baseColors.newZealandBlack, borderRadius.rHalf, borderRadius.rHalf);
});

var _templateObject$1, _templateObject2$1, _templateObject3$1, _templateObject4$1;
var StyledText = styled(Text)(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteral(["\n  white-space: pre;\n"])));
var WasPriceText = styled(Text)(_templateObject2$1 || (_templateObject2$1 = _taggedTemplateLiteral(["\n  height: 24px;\n  span {\n    text-decoration: line-through;\n  }\n"])));
var WasPriceTag = styled(Tag)(_templateObject3$1 || (_templateObject3$1 = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref) {
  var palette = _ref.theme.palette;
  return css(_templateObject4$1 || (_templateObject4$1 = _taggedTemplateLiteral(["\n    background: ", ";\n  "])), "".concat(palette.baseColors.darkPink, "16"));
});

var ProductPrice = function ProductPrice(_ref2) {
  var product = _ref2.product,
      isBusiness = _ref2.isBusiness;

  var _useTheme = useTheme(),
      baseColors = _useTheme.palette.baseColors;

  var wasPriceText = getWasPriceText(product, isBusiness);
  var savingPriceText = getSavingPriceText(product, isBusiness);
  var pricePeriod = getPricePeriod(product, isBusiness);
  var priceValue = getPriceValueText(product, isBusiness);
  var displaySettings = product.displaySettings;
  var shouldShowWasPriceLine = displaySettings.shouldShowWasPriceLine;
  var shouldShowSavingTag = !!savingPriceText;
  var wasPriceElement = wasPriceText ? /*#__PURE__*/React.createElement(React.Fragment, null, "Was ", /*#__PURE__*/React.createElement("span", null, wasPriceText)) : null;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Box, {
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "end"
  }, /*#__PURE__*/React.createElement(Box, {
    flexDirection: "row",
    px: "s4",
    alignItems: "baseline"
  }, /*#__PURE__*/React.createElement(Text, {
    variant: "subheadingL",
    color: baseColors.newZealandBlack
  }, priceValue), pricePeriod ? /*#__PURE__*/React.createElement(StyledText, {
    variant: "bodySMedium",
    color: baseColors.newZealandBlack
  }, "/".concat(pricePeriod)) : null), shouldShowSavingTag ? /*#__PURE__*/React.createElement(WasPriceTag, {
    position: "absolute",
    px: "s1",
    py: "s1"
  }, /*#__PURE__*/React.createElement(Text, {
    variant: "bodySDemi",
    color: baseColors.darkPink
  }, "Save ", savingPriceText)) : null), /*#__PURE__*/React.createElement(Box, {
    px: "s4",
    flexDirection: "row",
    gap: "s1",
    mb: "s1"
  }, isBusiness ? /*#__PURE__*/React.createElement(StyledText, {
    variant: "bodySMedium",
    color: baseColors.mawheranui
  }, "(excl. GST)") : null, shouldShowWasPriceLine ? /*#__PURE__*/React.createElement(WasPriceText, {
    variant: "bodySMedium",
    color: baseColors.mawheranui
  }, wasPriceElement) : null));
};

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15;
var StyledBaseProductCard = styled(BaseProductCard)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref) {
  var borderRadius = _ref.theme.borderRadius;
  return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    padding: 0;\n    cursor: pointer;\n    border-radius: ", ";\n  "])), borderRadius.round);
});
var PreOrderText = styled(Text)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  min-height: ", "px;\n"])), BODY_S_MEDIUM_LINE_HEIGHT);
var Title = styled(Text)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref2) {
  var media = _ref2.theme.media,
      lineClamp = _ref2.lineClamp;
  return css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    ", " {\n      height: ", ";\n      overflow: hidden;\n      display: -webkit-box;\n      -webkit-line-clamp: ", ";\n      -webkit-box-orient: vertical;\n    }\n  "])), media.up('slim'), "".concat(BODY_M_DEMI_LINE_HEIGHT * lineClamp, "px"), lineClamp);
});
var DescriptionText = styled(Text)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref3) {
  var _ref3$theme = _ref3.theme,
      media = _ref3$theme.media,
      palette = _ref3$theme.palette,
      lineClamp = _ref3.lineClamp;
  return css(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n    ", " {\n      height: ", "px;\n      overflow: hidden;\n      display: -webkit-box;\n      -webkit-line-clamp: ", ";\n      -webkit-box-orient: vertical;\n    }\n    span {\n      color: ", ";\n    }\n  "])), media.up('slim'), BODY_S_MEDIUM_LINE_HEIGHT * lineClamp, lineClamp, palette.baseColors.mawhero);
});
var DeviceOnlyText = styled(Text)(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  height: ", "px;\n  white-space: nowrap;\n"])), BODY_S_MEDIUM_LINE_HEIGHT);
var StyledImageWithFallback = styled(ImageWithFallback)(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  width: 200px;\n  height: 200px;\n  object-fit: scale-down;\n"])));
var StartingFromText = styled(Text)(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  min-height: ", "px;\n"])), BODY_S_MEDIUM_LINE_HEIGHT);
var StockDescriptionText = styled(Text)(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  min-height: ", "px;\n"])), BODY_S_MEDIUM_LINE_HEIGHT);
var GstText = styled.span(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref4) {
  var baseColors = _ref4.theme.palette.baseColors;
  return css(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n    color: ", ";\n  "])), baseColors.mawheranui);
});
var PreOrderBand = styled(Box)(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref5) {
  var palette = _ref5.theme.palette,
      hasContent = _ref5.hasContent;
  return css(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n    text-align: center;\n    background-color: ", ";\n  "])), hasContent ? "".concat(palette.baseColors.darkPink, "16") : null);
});

var ProductGalleryCard = function ProductGalleryCard(_ref6) {
  var product = _ref6.product,
      _ref6$eagerLoadImage = _ref6.eagerLoadImage,
      eagerLoadImage = _ref6$eagerLoadImage === void 0 ? false : _ref6$eagerLoadImage,
      isBusiness = _ref6.isBusiness,
      dynamicTargetValue = _ref6.dynamicTargetValue;

  var _a;

  var _useTheme = useTheme(),
      _useTheme$palette = _useTheme.palette,
      importantSecondary = _useTheme$palette.importantSecondary,
      baseColors = _useTheme$palette.baseColors;

  var _ref7 = product || {},
      promotions = _ref7.promotions,
      displaySettings = _ref7.displaySettings;

  var shouldShowPreOrderLine = displaySettings.shouldShowPreOrderLine,
      shouldShowTitle = displaySettings.shouldShowTitle,
      shouldShowPrePriceLine = displaySettings.shouldShowPrePriceLine,
      shouldShowStockLine = displaySettings.shouldShowStockLine,
      shouldShowDescription = displaySettings.shouldShowDescription,
      shouldShowDeviceOnly = displaySettings.shouldShowDeviceOnly,
      titleLineCount = displaySettings.titleLineCount,
      ifpDescriptionLineCount = displaySettings.ifpDescriptionLineCount;
  var promoTag = (_a = getPromotionByType(promotions, PromotionType.MARKETING)) === null || _a === void 0 ? void 0 : _a.name;
  var promoDealString = getFeaturedPromoDeals(promotions);
  var deviceOnlyText = getDeviceOnlyText(product, isBusiness);
  var shouldShowDeviceOnlyPriceExclGST = !!deviceOnlyText && isBusiness;
  var preOrderText = getPreOrderText(product);
  var titleText = getTitleText(product);
  var prePriceText = getPrePriceText(product);
  var stockText = getStockText(product);
  var ifpText = getIFPDescriptionText(product, isBusiness);
  var exclGSTText = shouldShowDeviceOnlyPriceExclGST ? /*#__PURE__*/React.createElement(GstText, null, "(excl. GST)") : null;
  return /*#__PURE__*/React.createElement(StyledBaseProductCard, {
    marketingMessage: promoTag,
    dynamicTargetValue: dynamicTargetValue
  }, /*#__PURE__*/React.createElement(Box, {
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    pt: "s4",
    pb: "s4"
  }, /*#__PURE__*/React.createElement(StyledImageWithFallback, {
    loading: eagerLoadImage ? 'eager' : 'lazy',
    src: product.imageUrl,
    alt: titleText,
    title: titleText,
    fallbackSrc: "".concat(BASE_PATH, "/static/assets/fallback/no-image.svg")
  })), shouldShowPreOrderLine ? /*#__PURE__*/React.createElement(PreOrderBand, {
    hasContent: !!preOrderText,
    py: "s1",
    mb: "s3"
  }, /*#__PURE__*/React.createElement(PreOrderText, {
    variant: "bodySDemi",
    color: importantSecondary
  }, preOrderText)) : null, /*#__PURE__*/React.createElement(Box, {
    flexDirection: "column",
    alignItems: "flex-start"
  }, product.tag ? /*#__PURE__*/React.createElement(Tag, {
    position: "absolute",
    pl: "s1",
    pr: "s3",
    py: "s1"
  }, /*#__PURE__*/React.createElement(Text, {
    variant: "bodySDemi",
    color: baseColors.wairua
  }, product.tag)) : null, /*#__PURE__*/React.createElement(Box, {
    px: "s4",
    flexDirection: "column"
  }, shouldShowTitle ? /*#__PURE__*/React.createElement(Title, {
    variant: "bodyMDemi",
    title: product.name,
    mb: "s1",
    lineClamp: titleLineCount
  }, titleText) : null, shouldShowPrePriceLine ? /*#__PURE__*/React.createElement(StartingFromText, {
    variant: "bodySMedium"
  }, prePriceText) : null)), /*#__PURE__*/React.createElement(ProductPrice, {
    product: product,
    isBusiness: isBusiness
  }), /*#__PURE__*/React.createElement(Box, {
    px: "s4",
    pb: "s4",
    flexDirection: "column"
  }, shouldShowStockLine ? /*#__PURE__*/React.createElement(StockDescriptionText, {
    variant: "bodySMedium",
    color: baseColors.marangai,
    mb: "s1"
  }, stockText) : null, shouldShowDescription ? /*#__PURE__*/React.createElement(DescriptionText, {
    variant: "bodySMedium",
    title: "IFP description",
    lineClamp: ifpDescriptionLineCount
  }, ifpText) : null, shouldShowDeviceOnly ? /*#__PURE__*/React.createElement(Box, {
    pt: "s3"
  }, /*#__PURE__*/React.createElement(DeviceOnlyText, {
    variant: "bodySMedium",
    title: "Device only price"
  }, deviceOnlyText, "\xA0", exclGSTText)) : null), /*#__PURE__*/React.createElement(ProductGalleryCardDeals, {
    promoDealString: promoDealString
  }));
};

var ProductGalleryCard$1 = /*#__PURE__*/React.memo(ProductGalleryCard);

export { ADDONS_PAGE, ADDONS_SME_PAGE, AccordionWithContent, AccountNumberField$1 as AccountNumberField, AddressField, AuthorableContentsProvider, BASE_PATH, BUSINESS_HOME_PAGE, CART, CART_PAGE, CART_SME_PAGE, CHANNELS, CHECKOUT_ACTION_LAYER_INNER_ID, CHECKOUT_HEADER_HEIGHT, CaptchaProvider, ChoiceBoxField, Clickable, ContentFields, ContentFragmentInfoLayer, ContentInfoLayer, ContentLoader, DEFAULT_AUTHENTICATED_PRIMARY_OPTIONS, DEFAULT_AUTHENTICATED_SECONDARY_OPTIONS, DEFAULT_ERROR_MESSAGE, DEFAULT_HEADER_ID, DEFAULT_UNAUTHENTICATED_MENU_OPTIONS, DEFAULT_UNAUTHENTICATED_SME_MENU_OPTIONS, DateFormat, DateInputField, DeliveryItemsField, DeliveryOptionsField, EnvironmentConfigProvider, ErrorBoundary, FooterLoader, FooterV2, FooterV2Wapper as FooterV2Wrapper, ForgerockLoginModal, FullDateInputField, GLOBAL_QUERY_PARAMS, GenericErrorScreen, GenericErrorText, GlobalUserProvider, Header$1 as Header, HeaderCartButton, HeaderCategoryList, HeaderComponent, HeaderLoader, HeaderSpa, HeaderV2, HeadingField, INCLUDED_TEXT, ImageWithFallback$1 as ImageWithFallback, InfoBoxField, JOURNEY_HEADER_KEY, JOURNEY_SESSION_KEY, LARGE_BUSINESS_GOVT, LEGACY_HEADER_SEGMENTS, LoginModal, LoginModalProvider, MESSAGE_US, MOBILE_PLANS_PATH, MYSPARK_BILLING_PAGE, MYSPARK_HOME_PAGE, MYSPARK_PAY_BILL, MYSPARK_PRODUCTS_PAGE, MYSPARK_PROFILE_PAGE, MYSPARK_SPARK_ID_SETTINGS, MYSPARK_USAGE_PAGE, MaybeImpressionRegion, Minicart, MobilePlanEligibilityCheck, MonthDateInputField, MpdComparison, NoAccountModal, NoAccountModalProvider, NoAccountScreen, PAY_BILL_PAGE, PERSONAL_HOME_PAGE, PRODUCT_DETAILS_PAGE, PaymentForm, PaymentStoreCardMethod, PhoneInput as PhoneInputField, PostpaidPlanComparerField, ProductCardLoader, ProductEligibilityService, ProductGalleryCard$1 as ProductGalleryCard, ProductGalleryCardAnchor, RawHTMLContent, RawHTMLInfoLayer, SEARCH_PATH, SEGMENTS, SEGMENT_PATHS, SETUP_SERVICE_PROVIDER_ID_FIELD_KEY, SHOP_TOP_UP, SPARK_ID_SETTINGS_PAGE, SubscriptionComparison, TOP_UP_PAGE, VASProductCard, addressSuggestions_mock as addressSuggestionsMock, buildCardBrandLogoURL, buildFieldKey, buildHeadersMiddleware, buildRootFieldsAndOptions, cartFragment, constructIfpDescription, createRelayEnvironment, decodeCartCookie, deliveryItemsFragment, extractDESLErrorAttributes, formatDateTime, formatLineNumber, formatNZD, formatNZDWithoutSymbol, getBillingFrequencyLabel, getCardLinkDestination, getCartImageUrl, getCartItemPrice, getContentVariation, getGalleryProductsWithPosition, getJourneyName, getLastFourCardCharacters, getOptionsFromDataRef, getPricingDetails, getSegmentData, getSelectedOption, getSparkLdContext, getUiSessionId, instantScrollToId, interpolateText, logFunction, makeRelayEnvironment, parseFieldName$1 as parseFieldName, pluralize, removePrice, removePricesAndCharacteristics, resetRelayEnvironment, setJourneyName, setupRenderWithForm, smoothScrollToId, useAuthorableContents, useAuthorableContentsFromRelay, useAuthorableContentsUpdate, useAvailableAccounts, useCaptcha, useCartCookie, useContent, useEnvironmentConfig, useFetchQuery, useGlobalUser, useLoginModal, useLogout, useNoAccountModal, usePromiseMutation, useSegment, useTrackFieldError };
//# sourceMappingURL=index.es.js.map
